parcelRequire = (function (e, r, t, n) {
  var i,
    o = "function" == typeof parcelRequire && parcelRequire,
    u = "function" == typeof require && require;
  function f(t, n) {
    if (!r[t]) {
      if (!e[t]) {
        var i = "function" == typeof parcelRequire && parcelRequire;
        if (!n && i) return i(t, !0);
        if (o) return o(t, !0);
        if (u && "string" == typeof t) return u(t);
        var c = new Error("Cannot find module '" + t + "'");
        throw ((c.code = "MODULE_NOT_FOUND"), c);
      }
      (p.resolve = function (r) {
        return e[t][1][r] || r;
      }),
        (p.cache = {});
      var l = (r[t] = new f.Module(t));
      e[t][0].call(l.exports, p, l, l.exports, this);
    }
    return r[t].exports;
    function p(e) {
      return f(p.resolve(e));
    }
  }
  (f.isParcelRequire = !0),
    (f.Module = function (e) {
      (this.id = e), (this.bundle = f), (this.exports = {});
    }),
    (f.modules = e),
    (f.cache = r),
    (f.parent = o),
    (f.register = function (r, t) {
      e[r] = [
        function (e, r) {
          r.exports = t;
        },
        {},
      ];
    });
  for (var c = 0; c < t.length; c++)
    try {
      f(t[c]);
    } catch (e) {
      i || (i = e);
    }
  if (t.length) {
    var l = f(t[t.length - 1]);
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = l)
      : "function" == typeof define && define.amd
      ? define(function () {
          return l;
        })
      : n && (this[n] = l);
  }
  if (((parcelRequire = f), i)) throw i;
  return f;
})(
  {
    "../node_modules/process/browser.js": [
      function (require, module, exports) {
        var t,
          e,
          n = (module.exports = {});
        function r() {
          throw new Error("setTimeout has not been defined");
        }
        function o() {
          throw new Error("clearTimeout has not been defined");
        }
        function i(e) {
          if (t === setTimeout) return setTimeout(e, 0);
          if ((t === r || !t) && setTimeout)
            return (t = setTimeout), setTimeout(e, 0);
          try {
            return t(e, 0);
          } catch (n) {
            try {
              return t.call(null, e, 0);
            } catch (n) {
              return t.call(this, e, 0);
            }
          }
        }
        function u(t) {
          if (e === clearTimeout) return clearTimeout(t);
          if ((e === o || !e) && clearTimeout)
            return (e = clearTimeout), clearTimeout(t);
          try {
            return e(t);
          } catch (n) {
            try {
              return e.call(null, t);
            } catch (n) {
              return e.call(this, t);
            }
          }
        }
        !(function () {
          try {
            t = "function" == typeof setTimeout ? setTimeout : r;
          } catch (n) {
            t = r;
          }
          try {
            e = "function" == typeof clearTimeout ? clearTimeout : o;
          } catch (n) {
            e = o;
          }
        })();
        var c,
          s = [],
          l = !1,
          a = -1;
        function f() {
          l &&
            c &&
            ((l = !1),
            c.length ? (s = c.concat(s)) : (a = -1),
            s.length && h());
        }
        function h() {
          if (!l) {
            var t = i(f);
            l = !0;
            for (var e = s.length; e; ) {
              for (c = s, s = []; ++a < e; ) c && c[a].run();
              (a = -1), (e = s.length);
            }
            (c = null), (l = !1), u(t);
          }
        }
        function m(t, e) {
          (this.fun = t), (this.array = e);
        }
        function p() {}
        (n.nextTick = function (t) {
          var e = new Array(arguments.length - 1);
          if (arguments.length > 1)
            for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
          s.push(new m(t, e)), 1 !== s.length || l || i(h);
        }),
          (m.prototype.run = function () {
            this.fun.apply(null, this.array);
          }),
          (n.title = "browser"),
          (n.env = {}),
          (n.argv = []),
          (n.version = ""),
          (n.versions = {}),
          (n.on = p),
          (n.addListener = p),
          (n.once = p),
          (n.off = p),
          (n.removeListener = p),
          (n.removeAllListeners = p),
          (n.emit = p),
          (n.prependListener = p),
          (n.prependOnceListener = p),
          (n.listeners = function (t) {
            return [];
          }),
          (n.binding = function (t) {
            throw new Error("process.binding is not supported");
          }),
          (n.cwd = function () {
            return "/";
          }),
          (n.chdir = function (t) {
            throw new Error("process.chdir is not supported");
          }),
          (n.umask = function () {
            return 0;
          });
      },
      {},
    ],
    "../node_modules/jquery/dist/jquery.js": [
      function (require, module, exports) {
        var global = arguments[3];
        var process = require("process");
        var define;
        var e,
          t = arguments[3],
          n = require("process");
        !(function (e, t) {
          "use strict";
          "object" == typeof module && "object" == typeof module.exports
            ? (module.exports = e.document
                ? t(e, !0)
                : function (e) {
                    if (!e.document)
                      throw new Error(
                        "jQuery requires a window with a document",
                      );
                    return t(e);
                  })
            : t(e);
        })("undefined" != typeof window ? window : this, function (t, n) {
          "use strict";
          var r = [],
            i = Object.getPrototypeOf,
            o = r.slice,
            a = r.flat
              ? function (e) {
                  return r.flat.call(e);
                }
              : function (e) {
                  return r.concat.apply([], e);
                },
            s = r.push,
            u = r.indexOf,
            l = {},
            c = l.toString,
            f = l.hasOwnProperty,
            p = f.toString,
            d = p.call(Object),
            h = {},
            g = function (e) {
              return (
                "function" == typeof e &&
                "number" != typeof e.nodeType &&
                "function" != typeof e.item
              );
            },
            v = function (e) {
              return null != e && e === e.window;
            },
            y = t.document,
            m = { type: !0, src: !0, nonce: !0, noModule: !0 };
          function x(e, t, n) {
            var r,
              i,
              o = (n = n || y).createElement("script");
            if (((o.text = e), t))
              for (r in m)
                (i = t[r] || (t.getAttribute && t.getAttribute(r))) &&
                  o.setAttribute(r, i);
            n.head.appendChild(o).parentNode.removeChild(o);
          }
          function b(e) {
            return null == e
              ? e + ""
              : "object" == typeof e || "function" == typeof e
              ? l[c.call(e)] || "object"
              : typeof e;
          }
          var w = function (e, t) {
            return new w.fn.init(e, t);
          };
          function T(e) {
            var t = !!e && "length" in e && e.length,
              n = b(e);
            return (
              !g(e) &&
              !v(e) &&
              ("array" === n ||
                0 === t ||
                ("number" == typeof t && t > 0 && t - 1 in e))
            );
          }
          (w.fn = w.prototype =
            {
              jquery: "3.6.0",
              constructor: w,
              length: 0,
              toArray: function () {
                return o.call(this);
              },
              get: function (e) {
                return null == e
                  ? o.call(this)
                  : e < 0
                  ? this[e + this.length]
                  : this[e];
              },
              pushStack: function (e) {
                var t = w.merge(this.constructor(), e);
                return (t.prevObject = this), t;
              },
              each: function (e) {
                return w.each(this, e);
              },
              map: function (e) {
                return this.pushStack(
                  w.map(this, function (t, n) {
                    return e.call(t, n, t);
                  }),
                );
              },
              slice: function () {
                return this.pushStack(o.apply(this, arguments));
              },
              first: function () {
                return this.eq(0);
              },
              last: function () {
                return this.eq(-1);
              },
              even: function () {
                return this.pushStack(
                  w.grep(this, function (e, t) {
                    return (t + 1) % 2;
                  }),
                );
              },
              odd: function () {
                return this.pushStack(
                  w.grep(this, function (e, t) {
                    return t % 2;
                  }),
                );
              },
              eq: function (e) {
                var t = this.length,
                  n = +e + (e < 0 ? t : 0);
                return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
              },
              end: function () {
                return this.prevObject || this.constructor();
              },
              push: s,
              sort: r.sort,
              splice: r.splice,
            }),
            (w.extend = w.fn.extend =
              function () {
                var e,
                  t,
                  n,
                  r,
                  i,
                  o,
                  a = arguments[0] || {},
                  s = 1,
                  u = arguments.length,
                  l = !1;
                for (
                  "boolean" == typeof a &&
                    ((l = a), (a = arguments[s] || {}), s++),
                    "object" == typeof a || g(a) || (a = {}),
                    s === u && ((a = this), s--);
                  s < u;
                  s++
                )
                  if (null != (e = arguments[s]))
                    for (t in e)
                      (r = e[t]),
                        "__proto__" !== t &&
                          a !== r &&
                          (l &&
                          r &&
                          (w.isPlainObject(r) || (i = Array.isArray(r)))
                            ? ((n = a[t]),
                              (o =
                                i && !Array.isArray(n)
                                  ? []
                                  : i || w.isPlainObject(n)
                                  ? n
                                  : {}),
                              (i = !1),
                              (a[t] = w.extend(l, o, r)))
                            : void 0 !== r && (a[t] = r));
                return a;
              }),
            w.extend({
              expando: "jQuery" + ("3.6.0" + Math.random()).replace(/\D/g, ""),
              isReady: !0,
              error: function (e) {
                throw new Error(e);
              },
              noop: function () {},
              isPlainObject: function (e) {
                var t, n;
                return (
                  !(!e || "[object Object]" !== c.call(e)) &&
                  (!(t = i(e)) ||
                    ("function" ==
                      typeof (n = f.call(t, "constructor") && t.constructor) &&
                      p.call(n) === d))
                );
              },
              isEmptyObject: function (e) {
                var t;
                for (t in e) return !1;
                return !0;
              },
              globalEval: function (e, t, n) {
                x(e, { nonce: t && t.nonce }, n);
              },
              each: function (e, t) {
                var n,
                  r = 0;
                if (T(e))
                  for (
                    n = e.length;
                    r < n && !1 !== t.call(e[r], r, e[r]);
                    r++
                  );
                else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
                return e;
              },
              makeArray: function (e, t) {
                var n = t || [];
                return (
                  null != e &&
                    (T(Object(e))
                      ? w.merge(n, "string" == typeof e ? [e] : e)
                      : s.call(n, e)),
                  n
                );
              },
              inArray: function (e, t, n) {
                return null == t ? -1 : u.call(t, e, n);
              },
              merge: function (e, t) {
                for (var n = +t.length, r = 0, i = e.length; r < n; r++)
                  e[i++] = t[r];
                return (e.length = i), e;
              },
              grep: function (e, t, n) {
                for (var r = [], i = 0, o = e.length, a = !n; i < o; i++)
                  !t(e[i], i) !== a && r.push(e[i]);
                return r;
              },
              map: function (e, t, n) {
                var r,
                  i,
                  o = 0,
                  s = [];
                if (T(e))
                  for (r = e.length; o < r; o++)
                    null != (i = t(e[o], o, n)) && s.push(i);
                else for (o in e) null != (i = t(e[o], o, n)) && s.push(i);
                return a(s);
              },
              guid: 1,
              support: h,
            }),
            "function" == typeof Symbol &&
              (w.fn[Symbol.iterator] = r[Symbol.iterator]),
            w.each(
              "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
                " ",
              ),
              function (e, t) {
                l["[object " + t + "]"] = t.toLowerCase();
              },
            );
          var C = (function (e) {
            var t,
              n,
              r,
              i,
              o,
              a,
              s,
              u,
              l,
              c,
              f,
              p,
              d,
              h,
              g,
              v,
              y,
              m,
              x,
              b = "sizzle" + 1 * new Date(),
              w = e.document,
              T = 0,
              C = 0,
              E = ue(),
              S = ue(),
              k = ue(),
              A = ue(),
              N = function (e, t) {
                return e === t && (f = !0), 0;
              },
              j = {}.hasOwnProperty,
              D = [],
              q = D.pop,
              L = D.push,
              H = D.push,
              O = D.slice,
              P = function (e, t) {
                for (var n = 0, r = e.length; n < r; n++)
                  if (e[n] === t) return n;
                return -1;
              },
              R =
                "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
              M = "[\\x20\\t\\r\\n\\f]",
              I =
                "(?:\\\\[\\da-fA-F]{1,6}" +
                M +
                "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
              W =
                "\\[" +
                M +
                "*(" +
                I +
                ")(?:" +
                M +
                "*([*^$|!~]?=)" +
                M +
                "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                I +
                "))|)" +
                M +
                "*\\]",
              F =
                ":(" +
                I +
                ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
                W +
                ")*)|.*)\\)|)",
              B = new RegExp(M + "+", "g"),
              $ = new RegExp(
                "^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$",
                "g",
              ),
              _ = new RegExp("^" + M + "*," + M + "*"),
              z = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
              U = new RegExp(M + "|>"),
              X = new RegExp(F),
              V = new RegExp("^" + I + "$"),
              G = {
                ID: new RegExp("^#(" + I + ")"),
                CLASS: new RegExp("^\\.(" + I + ")"),
                TAG: new RegExp("^(" + I + "|[*])"),
                ATTR: new RegExp("^" + W),
                PSEUDO: new RegExp("^" + F),
                CHILD: new RegExp(
                  "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                    M +
                    "*(even|odd|(([+-]|)(\\d*)n|)" +
                    M +
                    "*(?:([+-]|)" +
                    M +
                    "*(\\d+)|))" +
                    M +
                    "*\\)|)",
                  "i",
                ),
                bool: new RegExp("^(?:" + R + ")$", "i"),
                needsContext: new RegExp(
                  "^" +
                    M +
                    "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                    M +
                    "*((?:-\\d)?\\d*)" +
                    M +
                    "*\\)|)(?=[^-]|$)",
                  "i",
                ),
              },
              Y = /HTML$/i,
              Q = /^(?:input|select|textarea|button)$/i,
              J = /^h\d$/i,
              K = /^[^{]+\{\s*\[native \w/,
              Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
              ee = /[+~]/,
              te = new RegExp(
                "\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])",
                "g",
              ),
              ne = function (e, t) {
                var n = "0x" + e.slice(1) - 65536;
                return (
                  t ||
                  (n < 0
                    ? String.fromCharCode(n + 65536)
                    : String.fromCharCode(
                        (n >> 10) | 55296,
                        (1023 & n) | 56320,
                      ))
                );
              },
              re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
              ie = function (e, t) {
                return t
                  ? "\0" === e
                    ? "�"
                    : e.slice(0, -1) +
                      "\\" +
                      e.charCodeAt(e.length - 1).toString(16) +
                      " "
                  : "\\" + e;
              },
              oe = function () {
                p();
              },
              ae = be(
                function (e) {
                  return (
                    !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
                  );
                },
                { dir: "parentNode", next: "legend" },
              );
            try {
              H.apply((D = O.call(w.childNodes)), w.childNodes),
                D[w.childNodes.length].nodeType;
            } catch (Se) {
              H = {
                apply: D.length
                  ? function (e, t) {
                      L.apply(e, O.call(t));
                    }
                  : function (e, t) {
                      for (var n = e.length, r = 0; (e[n++] = t[r++]); );
                      e.length = n - 1;
                    },
              };
            }
            function se(e, t, r, i) {
              var o,
                s,
                l,
                c,
                f,
                h,
                y,
                m = t && t.ownerDocument,
                w = t ? t.nodeType : 9;
              if (
                ((r = r || []),
                "string" != typeof e || !e || (1 !== w && 9 !== w && 11 !== w))
              )
                return r;
              if (!i && (p(t), (t = t || d), g)) {
                if (11 !== w && (f = Z.exec(e)))
                  if ((o = f[1])) {
                    if (9 === w) {
                      if (!(l = t.getElementById(o))) return r;
                      if (l.id === o) return r.push(l), r;
                    } else if (
                      m &&
                      (l = m.getElementById(o)) &&
                      x(t, l) &&
                      l.id === o
                    )
                      return r.push(l), r;
                  } else {
                    if (f[2]) return H.apply(r, t.getElementsByTagName(e)), r;
                    if (
                      (o = f[3]) &&
                      n.getElementsByClassName &&
                      t.getElementsByClassName
                    )
                      return H.apply(r, t.getElementsByClassName(o)), r;
                  }
                if (
                  n.qsa &&
                  !A[e + " "] &&
                  (!v || !v.test(e)) &&
                  (1 !== w || "object" !== t.nodeName.toLowerCase())
                ) {
                  if (((y = e), (m = t), 1 === w && (U.test(e) || z.test(e)))) {
                    for (
                      ((m = (ee.test(e) && ye(t.parentNode)) || t) === t &&
                        n.scope) ||
                        ((c = t.getAttribute("id"))
                          ? (c = c.replace(re, ie))
                          : t.setAttribute("id", (c = b))),
                        s = (h = a(e)).length;
                      s--;

                    )
                      h[s] = (c ? "#" + c : ":scope") + " " + xe(h[s]);
                    y = h.join(",");
                  }
                  try {
                    return H.apply(r, m.querySelectorAll(y)), r;
                  } catch (T) {
                    A(e, !0);
                  } finally {
                    c === b && t.removeAttribute("id");
                  }
                }
              }
              return u(e.replace($, "$1"), t, r, i);
            }
            function ue() {
              var e = [];
              return function t(n, i) {
                return (
                  e.push(n + " ") > r.cacheLength && delete t[e.shift()],
                  (t[n + " "] = i)
                );
              };
            }
            function le(e) {
              return (e[b] = !0), e;
            }
            function ce(e) {
              var t = d.createElement("fieldset");
              try {
                return !!e(t);
              } catch (Se) {
                return !1;
              } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
              }
            }
            function fe(e, t) {
              for (var n = e.split("|"), i = n.length; i--; )
                r.attrHandle[n[i]] = t;
            }
            function pe(e, t) {
              var n = t && e,
                r =
                  n &&
                  1 === e.nodeType &&
                  1 === t.nodeType &&
                  e.sourceIndex - t.sourceIndex;
              if (r) return r;
              if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
              return e ? 1 : -1;
            }
            function de(e) {
              return function (t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e;
              };
            }
            function he(e) {
              return function (t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e;
              };
            }
            function ge(e) {
              return function (t) {
                return "form" in t
                  ? t.parentNode && !1 === t.disabled
                    ? "label" in t
                      ? "label" in t.parentNode
                        ? t.parentNode.disabled === e
                        : t.disabled === e
                      : t.isDisabled === e ||
                        (t.isDisabled !== !e && ae(t) === e)
                    : t.disabled === e
                  : "label" in t && t.disabled === e;
              };
            }
            function ve(e) {
              return le(function (t) {
                return (
                  (t = +t),
                  le(function (n, r) {
                    for (var i, o = e([], n.length, t), a = o.length; a--; )
                      n[(i = o[a])] && (n[i] = !(r[i] = n[i]));
                  })
                );
              });
            }
            function ye(e) {
              return e && void 0 !== e.getElementsByTagName && e;
            }
            for (t in ((n = se.support = {}),
            (o = se.isXML =
              function (e) {
                var t = e && e.namespaceURI,
                  n = e && (e.ownerDocument || e).documentElement;
                return !Y.test(t || (n && n.nodeName) || "HTML");
              }),
            (p = se.setDocument =
              function (e) {
                var t,
                  i,
                  a = e ? e.ownerDocument || e : w;
                return a != d && 9 === a.nodeType && a.documentElement
                  ? ((h = (d = a).documentElement),
                    (g = !o(d)),
                    w != d &&
                      (i = d.defaultView) &&
                      i.top !== i &&
                      (i.addEventListener
                        ? i.addEventListener("unload", oe, !1)
                        : i.attachEvent && i.attachEvent("onunload", oe)),
                    (n.scope = ce(function (e) {
                      return (
                        h.appendChild(e).appendChild(d.createElement("div")),
                        void 0 !== e.querySelectorAll &&
                          !e.querySelectorAll(":scope fieldset div").length
                      );
                    })),
                    (n.attributes = ce(function (e) {
                      return (e.className = "i"), !e.getAttribute("className");
                    })),
                    (n.getElementsByTagName = ce(function (e) {
                      return (
                        e.appendChild(d.createComment("")),
                        !e.getElementsByTagName("*").length
                      );
                    })),
                    (n.getElementsByClassName = K.test(
                      d.getElementsByClassName,
                    )),
                    (n.getById = ce(function (e) {
                      return (
                        (h.appendChild(e).id = b),
                        !d.getElementsByName || !d.getElementsByName(b).length
                      );
                    })),
                    n.getById
                      ? ((r.filter.ID = function (e) {
                          var t = e.replace(te, ne);
                          return function (e) {
                            return e.getAttribute("id") === t;
                          };
                        }),
                        (r.find.ID = function (e, t) {
                          if (void 0 !== t.getElementById && g) {
                            var n = t.getElementById(e);
                            return n ? [n] : [];
                          }
                        }))
                      : ((r.filter.ID = function (e) {
                          var t = e.replace(te, ne);
                          return function (e) {
                            var n =
                              void 0 !== e.getAttributeNode &&
                              e.getAttributeNode("id");
                            return n && n.value === t;
                          };
                        }),
                        (r.find.ID = function (e, t) {
                          if (void 0 !== t.getElementById && g) {
                            var n,
                              r,
                              i,
                              o = t.getElementById(e);
                            if (o) {
                              if (
                                (n = o.getAttributeNode("id")) &&
                                n.value === e
                              )
                                return [o];
                              for (
                                i = t.getElementsByName(e), r = 0;
                                (o = i[r++]);

                              )
                                if (
                                  (n = o.getAttributeNode("id")) &&
                                  n.value === e
                                )
                                  return [o];
                            }
                            return [];
                          }
                        })),
                    (r.find.TAG = n.getElementsByTagName
                      ? function (e, t) {
                          return void 0 !== t.getElementsByTagName
                            ? t.getElementsByTagName(e)
                            : n.qsa
                            ? t.querySelectorAll(e)
                            : void 0;
                        }
                      : function (e, t) {
                          var n,
                            r = [],
                            i = 0,
                            o = t.getElementsByTagName(e);
                          if ("*" === e) {
                            for (; (n = o[i++]); )
                              1 === n.nodeType && r.push(n);
                            return r;
                          }
                          return o;
                        }),
                    (r.find.CLASS =
                      n.getElementsByClassName &&
                      function (e, t) {
                        if (void 0 !== t.getElementsByClassName && g)
                          return t.getElementsByClassName(e);
                      }),
                    (y = []),
                    (v = []),
                    (n.qsa = K.test(d.querySelectorAll)) &&
                      (ce(function (e) {
                        var t;
                        (h.appendChild(e).innerHTML =
                          "<a id='" +
                          b +
                          "'></a><select id='" +
                          b +
                          "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                          e.querySelectorAll("[msallowcapture^='']").length &&
                            v.push("[*^$]=" + M + "*(?:''|\"\")"),
                          e.querySelectorAll("[selected]").length ||
                            v.push("\\[" + M + "*(?:value|" + R + ")"),
                          e.querySelectorAll("[id~=" + b + "-]").length ||
                            v.push("~="),
                          (t = d.createElement("input")).setAttribute(
                            "name",
                            "",
                          ),
                          e.appendChild(t),
                          e.querySelectorAll("[name='']").length ||
                            v.push(
                              "\\[" +
                                M +
                                "*name" +
                                M +
                                "*=" +
                                M +
                                "*(?:''|\"\")",
                            ),
                          e.querySelectorAll(":checked").length ||
                            v.push(":checked"),
                          e.querySelectorAll("a#" + b + "+*").length ||
                            v.push(".#.+[+~]"),
                          e.querySelectorAll("\\\f"),
                          v.push("[\\r\\n\\f]");
                      }),
                      ce(function (e) {
                        e.innerHTML =
                          "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                        var t = d.createElement("input");
                        t.setAttribute("type", "hidden"),
                          e.appendChild(t).setAttribute("name", "D"),
                          e.querySelectorAll("[name=d]").length &&
                            v.push("name" + M + "*[*^$|!~]?="),
                          2 !== e.querySelectorAll(":enabled").length &&
                            v.push(":enabled", ":disabled"),
                          (h.appendChild(e).disabled = !0),
                          2 !== e.querySelectorAll(":disabled").length &&
                            v.push(":enabled", ":disabled"),
                          e.querySelectorAll("*,:x"),
                          v.push(",.*:");
                      })),
                    (n.matchesSelector = K.test(
                      (m =
                        h.matches ||
                        h.webkitMatchesSelector ||
                        h.mozMatchesSelector ||
                        h.oMatchesSelector ||
                        h.msMatchesSelector),
                    )) &&
                      ce(function (e) {
                        (n.disconnectedMatch = m.call(e, "*")),
                          m.call(e, "[s!='']:x"),
                          y.push("!=", F);
                      }),
                    (v = v.length && new RegExp(v.join("|"))),
                    (y = y.length && new RegExp(y.join("|"))),
                    (t = K.test(h.compareDocumentPosition)),
                    (x =
                      t || K.test(h.contains)
                        ? function (e, t) {
                            var n = 9 === e.nodeType ? e.documentElement : e,
                              r = t && t.parentNode;
                            return (
                              e === r ||
                              !(
                                !r ||
                                1 !== r.nodeType ||
                                !(n.contains
                                  ? n.contains(r)
                                  : e.compareDocumentPosition &&
                                    16 & e.compareDocumentPosition(r))
                              )
                            );
                          }
                        : function (e, t) {
                            if (t)
                              for (; (t = t.parentNode); )
                                if (t === e) return !0;
                            return !1;
                          }),
                    (N = t
                      ? function (e, t) {
                          if (e === t) return (f = !0), 0;
                          var r =
                            !e.compareDocumentPosition -
                            !t.compareDocumentPosition;
                          return (
                            r ||
                            (1 &
                              (r =
                                (e.ownerDocument || e) == (t.ownerDocument || t)
                                  ? e.compareDocumentPosition(t)
                                  : 1) ||
                            (!n.sortDetached &&
                              t.compareDocumentPosition(e) === r)
                              ? e == d || (e.ownerDocument == w && x(w, e))
                                ? -1
                                : t == d || (t.ownerDocument == w && x(w, t))
                                ? 1
                                : c
                                ? P(c, e) - P(c, t)
                                : 0
                              : 4 & r
                              ? -1
                              : 1)
                          );
                        }
                      : function (e, t) {
                          if (e === t) return (f = !0), 0;
                          var n,
                            r = 0,
                            i = e.parentNode,
                            o = t.parentNode,
                            a = [e],
                            s = [t];
                          if (!i || !o)
                            return e == d
                              ? -1
                              : t == d
                              ? 1
                              : i
                              ? -1
                              : o
                              ? 1
                              : c
                              ? P(c, e) - P(c, t)
                              : 0;
                          if (i === o) return pe(e, t);
                          for (n = e; (n = n.parentNode); ) a.unshift(n);
                          for (n = t; (n = n.parentNode); ) s.unshift(n);
                          for (; a[r] === s[r]; ) r++;
                          return r
                            ? pe(a[r], s[r])
                            : a[r] == w
                            ? -1
                            : s[r] == w
                            ? 1
                            : 0;
                        }),
                    d)
                  : d;
              }),
            (se.matches = function (e, t) {
              return se(e, null, null, t);
            }),
            (se.matchesSelector = function (e, t) {
              if (
                (p(e),
                n.matchesSelector &&
                  g &&
                  !A[t + " "] &&
                  (!y || !y.test(t)) &&
                  (!v || !v.test(t)))
              )
                try {
                  var r = m.call(e, t);
                  if (
                    r ||
                    n.disconnectedMatch ||
                    (e.document && 11 !== e.document.nodeType)
                  )
                    return r;
                } catch (Se) {
                  A(t, !0);
                }
              return se(t, d, null, [e]).length > 0;
            }),
            (se.contains = function (e, t) {
              return (e.ownerDocument || e) != d && p(e), x(e, t);
            }),
            (se.attr = function (e, t) {
              (e.ownerDocument || e) != d && p(e);
              var i = r.attrHandle[t.toLowerCase()],
                o =
                  i && j.call(r.attrHandle, t.toLowerCase())
                    ? i(e, t, !g)
                    : void 0;
              return void 0 !== o
                ? o
                : n.attributes || !g
                ? e.getAttribute(t)
                : (o = e.getAttributeNode(t)) && o.specified
                ? o.value
                : null;
            }),
            (se.escape = function (e) {
              return (e + "").replace(re, ie);
            }),
            (se.error = function (e) {
              throw new Error("Syntax error, unrecognized expression: " + e);
            }),
            (se.uniqueSort = function (e) {
              var t,
                r = [],
                i = 0,
                o = 0;
              if (
                ((f = !n.detectDuplicates),
                (c = !n.sortStable && e.slice(0)),
                e.sort(N),
                f)
              ) {
                for (; (t = e[o++]); ) t === e[o] && (i = r.push(o));
                for (; i--; ) e.splice(r[i], 1);
              }
              return (c = null), e;
            }),
            (i = se.getText =
              function (e) {
                var t,
                  n = "",
                  r = 0,
                  o = e.nodeType;
                if (o) {
                  if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += i(e);
                  } else if (3 === o || 4 === o) return e.nodeValue;
                } else for (; (t = e[r++]); ) n += i(t);
                return n;
              }),
            ((r = se.selectors =
              {
                cacheLength: 50,
                createPseudo: le,
                match: G,
                attrHandle: {},
                find: {},
                relative: {
                  ">": { dir: "parentNode", first: !0 },
                  " ": { dir: "parentNode" },
                  "+": { dir: "previousSibling", first: !0 },
                  "~": { dir: "previousSibling" },
                },
                preFilter: {
                  ATTR: function (e) {
                    return (
                      (e[1] = e[1].replace(te, ne)),
                      (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)),
                      "~=" === e[2] && (e[3] = " " + e[3] + " "),
                      e.slice(0, 4)
                    );
                  },
                  CHILD: function (e) {
                    return (
                      (e[1] = e[1].toLowerCase()),
                      "nth" === e[1].slice(0, 3)
                        ? (e[3] || se.error(e[0]),
                          (e[4] = +(e[4]
                            ? e[5] + (e[6] || 1)
                            : 2 * ("even" === e[3] || "odd" === e[3]))),
                          (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                        : e[3] && se.error(e[0]),
                      e
                    );
                  },
                  PSEUDO: function (e) {
                    var t,
                      n = !e[6] && e[2];
                    return G.CHILD.test(e[0])
                      ? null
                      : (e[3]
                          ? (e[2] = e[4] || e[5] || "")
                          : n &&
                            X.test(n) &&
                            (t = a(n, !0)) &&
                            (t = n.indexOf(")", n.length - t) - n.length) &&
                            ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                        e.slice(0, 3));
                  },
                },
                filter: {
                  TAG: function (e) {
                    var t = e.replace(te, ne).toLowerCase();
                    return "*" === e
                      ? function () {
                          return !0;
                        }
                      : function (e) {
                          return e.nodeName && e.nodeName.toLowerCase() === t;
                        };
                  },
                  CLASS: function (e) {
                    var t = E[e + " "];
                    return (
                      t ||
                      ((t = new RegExp(
                        "(^|" + M + ")" + e + "(" + M + "|$)",
                      )) &&
                        E(e, function (e) {
                          return t.test(
                            ("string" == typeof e.className && e.className) ||
                              (void 0 !== e.getAttribute &&
                                e.getAttribute("class")) ||
                              "",
                          );
                        }))
                    );
                  },
                  ATTR: function (e, t, n) {
                    return function (r) {
                      var i = se.attr(r, e);
                      return null == i
                        ? "!=" === t
                        : !t ||
                            ((i += ""),
                            "=" === t
                              ? i === n
                              : "!=" === t
                              ? i !== n
                              : "^=" === t
                              ? n && 0 === i.indexOf(n)
                              : "*=" === t
                              ? n && i.indexOf(n) > -1
                              : "$=" === t
                              ? n && i.slice(-n.length) === n
                              : "~=" === t
                              ? (" " + i.replace(B, " ") + " ").indexOf(n) > -1
                              : "|=" === t &&
                                (i === n ||
                                  i.slice(0, n.length + 1) === n + "-"));
                    };
                  },
                  CHILD: function (e, t, n, r, i) {
                    var o = "nth" !== e.slice(0, 3),
                      a = "last" !== e.slice(-4),
                      s = "of-type" === t;
                    return 1 === r && 0 === i
                      ? function (e) {
                          return !!e.parentNode;
                        }
                      : function (t, n, u) {
                          var l,
                            c,
                            f,
                            p,
                            d,
                            h,
                            g = o !== a ? "nextSibling" : "previousSibling",
                            v = t.parentNode,
                            y = s && t.nodeName.toLowerCase(),
                            m = !u && !s,
                            x = !1;
                          if (v) {
                            if (o) {
                              for (; g; ) {
                                for (p = t; (p = p[g]); )
                                  if (
                                    s
                                      ? p.nodeName.toLowerCase() === y
                                      : 1 === p.nodeType
                                  )
                                    return !1;
                                h = g = "only" === e && !h && "nextSibling";
                              }
                              return !0;
                            }
                            if (
                              ((h = [a ? v.firstChild : v.lastChild]), a && m)
                            ) {
                              for (
                                x =
                                  (d =
                                    (l =
                                      (c =
                                        (f = (p = v)[b] || (p[b] = {}))[
                                          p.uniqueID
                                        ] || (f[p.uniqueID] = {}))[e] ||
                                      [])[0] === T && l[1]) && l[2],
                                  p = d && v.childNodes[d];
                                (p =
                                  (++d && p && p[g]) || (x = d = 0) || h.pop());

                              )
                                if (1 === p.nodeType && ++x && p === t) {
                                  c[e] = [T, d, x];
                                  break;
                                }
                            } else if (
                              (m &&
                                (x = d =
                                  (l =
                                    (c =
                                      (f = (p = t)[b] || (p[b] = {}))[
                                        p.uniqueID
                                      ] || (f[p.uniqueID] = {}))[e] ||
                                    [])[0] === T && l[1]),
                              !1 === x)
                            )
                              for (
                                ;
                                (p =
                                  (++d && p && p[g]) ||
                                  (x = d = 0) ||
                                  h.pop()) &&
                                ((s
                                  ? p.nodeName.toLowerCase() !== y
                                  : 1 !== p.nodeType) ||
                                  !++x ||
                                  (m &&
                                    ((c =
                                      (f = p[b] || (p[b] = {}))[p.uniqueID] ||
                                      (f[p.uniqueID] = {}))[e] = [T, x]),
                                  p !== t));

                              );
                            return (x -= i) === r || (x % r == 0 && x / r >= 0);
                          }
                        };
                  },
                  PSEUDO: function (e, t) {
                    var n,
                      i =
                        r.pseudos[e] ||
                        r.setFilters[e.toLowerCase()] ||
                        se.error("unsupported pseudo: " + e);
                    return i[b]
                      ? i(t)
                      : i.length > 1
                      ? ((n = [e, e, "", t]),
                        r.setFilters.hasOwnProperty(e.toLowerCase())
                          ? le(function (e, n) {
                              for (var r, o = i(e, t), a = o.length; a--; )
                                e[(r = P(e, o[a]))] = !(n[r] = o[a]);
                            })
                          : function (e) {
                              return i(e, 0, n);
                            })
                      : i;
                  },
                },
                pseudos: {
                  not: le(function (e) {
                    var t = [],
                      n = [],
                      r = s(e.replace($, "$1"));
                    return r[b]
                      ? le(function (e, t, n, i) {
                          for (
                            var o, a = r(e, null, i, []), s = e.length;
                            s--;

                          )
                            (o = a[s]) && (e[s] = !(t[s] = o));
                        })
                      : function (e, i, o) {
                          return (
                            (t[0] = e),
                            r(t, null, o, n),
                            (t[0] = null),
                            !n.pop()
                          );
                        };
                  }),
                  has: le(function (e) {
                    return function (t) {
                      return se(e, t).length > 0;
                    };
                  }),
                  contains: le(function (e) {
                    return (
                      (e = e.replace(te, ne)),
                      function (t) {
                        return (t.textContent || i(t)).indexOf(e) > -1;
                      }
                    );
                  }),
                  lang: le(function (e) {
                    return (
                      V.test(e || "") || se.error("unsupported lang: " + e),
                      (e = e.replace(te, ne).toLowerCase()),
                      function (t) {
                        var n;
                        do {
                          if (
                            (n = g
                              ? t.lang
                              : t.getAttribute("xml:lang") ||
                                t.getAttribute("lang"))
                          )
                            return (
                              (n = n.toLowerCase()) === e ||
                              0 === n.indexOf(e + "-")
                            );
                        } while ((t = t.parentNode) && 1 === t.nodeType);
                        return !1;
                      }
                    );
                  }),
                  target: function (t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id;
                  },
                  root: function (e) {
                    return e === h;
                  },
                  focus: function (e) {
                    return (
                      e === d.activeElement &&
                      (!d.hasFocus || d.hasFocus()) &&
                      !!(e.type || e.href || ~e.tabIndex)
                    );
                  },
                  enabled: ge(!1),
                  disabled: ge(!0),
                  checked: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return (
                      ("input" === t && !!e.checked) ||
                      ("option" === t && !!e.selected)
                    );
                  },
                  selected: function (e) {
                    return (
                      e.parentNode && e.parentNode.selectedIndex,
                      !0 === e.selected
                    );
                  },
                  empty: function (e) {
                    for (e = e.firstChild; e; e = e.nextSibling)
                      if (e.nodeType < 6) return !1;
                    return !0;
                  },
                  parent: function (e) {
                    return !r.pseudos.empty(e);
                  },
                  header: function (e) {
                    return J.test(e.nodeName);
                  },
                  input: function (e) {
                    return Q.test(e.nodeName);
                  },
                  button: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return (
                      ("input" === t && "button" === e.type) || "button" === t
                    );
                  },
                  text: function (e) {
                    var t;
                    return (
                      "input" === e.nodeName.toLowerCase() &&
                      "text" === e.type &&
                      (null == (t = e.getAttribute("type")) ||
                        "text" === t.toLowerCase())
                    );
                  },
                  first: ve(function () {
                    return [0];
                  }),
                  last: ve(function (e, t) {
                    return [t - 1];
                  }),
                  eq: ve(function (e, t, n) {
                    return [n < 0 ? n + t : n];
                  }),
                  even: ve(function (e, t) {
                    for (var n = 0; n < t; n += 2) e.push(n);
                    return e;
                  }),
                  odd: ve(function (e, t) {
                    for (var n = 1; n < t; n += 2) e.push(n);
                    return e;
                  }),
                  lt: ve(function (e, t, n) {
                    for (var r = n < 0 ? n + t : n > t ? t : n; --r >= 0; )
                      e.push(r);
                    return e;
                  }),
                  gt: ve(function (e, t, n) {
                    for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
                    return e;
                  }),
                },
              }).pseudos.nth = r.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
              r.pseudos[t] = de(t);
            for (t in { submit: !0, reset: !0 }) r.pseudos[t] = he(t);
            function me() {}
            function xe(e) {
              for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
              return r;
            }
            function be(e, t, n) {
              var r = t.dir,
                i = t.next,
                o = i || r,
                a = n && "parentNode" === o,
                s = C++;
              return t.first
                ? function (t, n, i) {
                    for (; (t = t[r]); )
                      if (1 === t.nodeType || a) return e(t, n, i);
                    return !1;
                  }
                : function (t, n, u) {
                    var l,
                      c,
                      f,
                      p = [T, s];
                    if (u) {
                      for (; (t = t[r]); )
                        if ((1 === t.nodeType || a) && e(t, n, u)) return !0;
                    } else
                      for (; (t = t[r]); )
                        if (1 === t.nodeType || a)
                          if (
                            ((c =
                              (f = t[b] || (t[b] = {}))[t.uniqueID] ||
                              (f[t.uniqueID] = {})),
                            i && i === t.nodeName.toLowerCase())
                          )
                            t = t[r] || t;
                          else {
                            if ((l = c[o]) && l[0] === T && l[1] === s)
                              return (p[2] = l[2]);
                            if (((c[o] = p), (p[2] = e(t, n, u)))) return !0;
                          }
                    return !1;
                  };
            }
            function we(e) {
              return e.length > 1
                ? function (t, n, r) {
                    for (var i = e.length; i--; ) if (!e[i](t, n, r)) return !1;
                    return !0;
                  }
                : e[0];
            }
            function Te(e, t, n, r, i) {
              for (
                var o, a = [], s = 0, u = e.length, l = null != t;
                s < u;
                s++
              )
                (o = e[s]) &&
                  ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
              return a;
            }
            function Ce(e, t, n, r, i, o) {
              return (
                r && !r[b] && (r = Ce(r)),
                i && !i[b] && (i = Ce(i, o)),
                le(function (o, a, s, u) {
                  var l,
                    c,
                    f,
                    p = [],
                    d = [],
                    h = a.length,
                    g =
                      o ||
                      (function (e, t, n) {
                        for (var r = 0, i = t.length; r < i; r++)
                          se(e, t[r], n);
                        return n;
                      })(t || "*", s.nodeType ? [s] : s, []),
                    v = !e || (!o && t) ? g : Te(g, p, e, s, u),
                    y = n ? (i || (o ? e : h || r) ? [] : a) : v;
                  if ((n && n(v, y, s, u), r))
                    for (l = Te(y, d), r(l, [], s, u), c = l.length; c--; )
                      (f = l[c]) && (y[d[c]] = !(v[d[c]] = f));
                  if (o) {
                    if (i || e) {
                      if (i) {
                        for (l = [], c = y.length; c--; )
                          (f = y[c]) && l.push((v[c] = f));
                        i(null, (y = []), l, u);
                      }
                      for (c = y.length; c--; )
                        (f = y[c]) &&
                          (l = i ? P(o, f) : p[c]) > -1 &&
                          (o[l] = !(a[l] = f));
                    }
                  } else (y = Te(y === a ? y.splice(h, y.length) : y)), i ? i(null, a, y, u) : H.apply(a, y);
                })
              );
            }
            function Ee(e) {
              for (
                var t,
                  n,
                  i,
                  o = e.length,
                  a = r.relative[e[0].type],
                  s = a || r.relative[" "],
                  u = a ? 1 : 0,
                  c = be(
                    function (e) {
                      return e === t;
                    },
                    s,
                    !0,
                  ),
                  f = be(
                    function (e) {
                      return P(t, e) > -1;
                    },
                    s,
                    !0,
                  ),
                  p = [
                    function (e, n, r) {
                      var i =
                        (!a && (r || n !== l)) ||
                        ((t = n).nodeType ? c(e, n, r) : f(e, n, r));
                      return (t = null), i;
                    },
                  ];
                u < o;
                u++
              )
                if ((n = r.relative[e[u].type])) p = [be(we(p), n)];
                else {
                  if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
                    for (i = ++u; i < o && !r.relative[e[i].type]; i++);
                    return Ce(
                      u > 1 && we(p),
                      u > 1 &&
                        xe(
                          e
                            .slice(0, u - 1)
                            .concat({
                              value: " " === e[u - 2].type ? "*" : "",
                            }),
                        ).replace($, "$1"),
                      n,
                      u < i && Ee(e.slice(u, i)),
                      i < o && Ee((e = e.slice(i))),
                      i < o && xe(e),
                    );
                  }
                  p.push(n);
                }
              return we(p);
            }
            return (
              (me.prototype = r.filters = r.pseudos),
              (r.setFilters = new me()),
              (a = se.tokenize =
                function (e, t) {
                  var n,
                    i,
                    o,
                    a,
                    s,
                    u,
                    l,
                    c = S[e + " "];
                  if (c) return t ? 0 : c.slice(0);
                  for (s = e, u = [], l = r.preFilter; s; ) {
                    for (a in ((n && !(i = _.exec(s))) ||
                      (i && (s = s.slice(i[0].length) || s), u.push((o = []))),
                    (n = !1),
                    (i = z.exec(s)) &&
                      ((n = i.shift()),
                      o.push({ value: n, type: i[0].replace($, " ") }),
                      (s = s.slice(n.length))),
                    r.filter))
                      !(i = G[a].exec(s)) ||
                        (l[a] && !(i = l[a](i))) ||
                        ((n = i.shift()),
                        o.push({ value: n, type: a, matches: i }),
                        (s = s.slice(n.length)));
                    if (!n) break;
                  }
                  return t ? s.length : s ? se.error(e) : S(e, u).slice(0);
                }),
              (s = se.compile =
                function (e, t) {
                  var n,
                    i = [],
                    o = [],
                    s = k[e + " "];
                  if (!s) {
                    for (t || (t = a(e)), n = t.length; n--; )
                      (s = Ee(t[n]))[b] ? i.push(s) : o.push(s);
                    (s = k(
                      e,
                      (function (e, t) {
                        var n = t.length > 0,
                          i = e.length > 0,
                          o = function (o, a, s, u, c) {
                            var f,
                              h,
                              v,
                              y = 0,
                              m = "0",
                              x = o && [],
                              b = [],
                              w = l,
                              C = o || (i && r.find.TAG("*", c)),
                              E = (T += null == w ? 1 : Math.random() || 0.1),
                              S = C.length;
                            for (
                              c && (l = a == d || a || c);
                              m !== S && null != (f = C[m]);
                              m++
                            ) {
                              if (i && f) {
                                for (
                                  h = 0,
                                    a ||
                                      f.ownerDocument == d ||
                                      (p(f), (s = !g));
                                  (v = e[h++]);

                                )
                                  if (v(f, a || d, s)) {
                                    u.push(f);
                                    break;
                                  }
                                c && (T = E);
                              }
                              n && ((f = !v && f) && y--, o && x.push(f));
                            }
                            if (((y += m), n && m !== y)) {
                              for (h = 0; (v = t[h++]); ) v(x, b, a, s);
                              if (o) {
                                if (y > 0)
                                  for (; m--; )
                                    x[m] || b[m] || (b[m] = q.call(u));
                                b = Te(b);
                              }
                              H.apply(u, b),
                                c &&
                                  !o &&
                                  b.length > 0 &&
                                  y + t.length > 1 &&
                                  se.uniqueSort(u);
                            }
                            return c && ((T = E), (l = w)), x;
                          };
                        return n ? le(o) : o;
                      })(o, i),
                    )).selector = e;
                  }
                  return s;
                }),
              (u = se.select =
                function (e, t, n, i) {
                  var o,
                    u,
                    l,
                    c,
                    f,
                    p = "function" == typeof e && e,
                    d = !i && a((e = p.selector || e));
                  if (((n = n || []), 1 === d.length)) {
                    if (
                      (u = d[0] = d[0].slice(0)).length > 2 &&
                      "ID" === (l = u[0]).type &&
                      9 === t.nodeType &&
                      g &&
                      r.relative[u[1].type]
                    ) {
                      if (
                        !(t = (r.find.ID(l.matches[0].replace(te, ne), t) ||
                          [])[0])
                      )
                        return n;
                      p && (t = t.parentNode),
                        (e = e.slice(u.shift().value.length));
                    }
                    for (
                      o = G.needsContext.test(e) ? 0 : u.length;
                      o-- && ((l = u[o]), !r.relative[(c = l.type)]);

                    )
                      if (
                        (f = r.find[c]) &&
                        (i = f(
                          l.matches[0].replace(te, ne),
                          (ee.test(u[0].type) && ye(t.parentNode)) || t,
                        ))
                      ) {
                        if ((u.splice(o, 1), !(e = i.length && xe(u))))
                          return H.apply(n, i), n;
                        break;
                      }
                  }
                  return (
                    (p || s(e, d))(
                      i,
                      t,
                      !g,
                      n,
                      !t || (ee.test(e) && ye(t.parentNode)) || t,
                    ),
                    n
                  );
                }),
              (n.sortStable = b.split("").sort(N).join("") === b),
              (n.detectDuplicates = !!f),
              p(),
              (n.sortDetached = ce(function (e) {
                return (
                  1 & e.compareDocumentPosition(d.createElement("fieldset"))
                );
              })),
              ce(function (e) {
                return (
                  (e.innerHTML = "<a href='#'></a>"),
                  "#" === e.firstChild.getAttribute("href")
                );
              }) ||
                fe("type|href|height|width", function (e, t, n) {
                  if (!n)
                    return e.getAttribute(
                      t,
                      "type" === t.toLowerCase() ? 1 : 2,
                    );
                }),
              (n.attributes &&
                ce(function (e) {
                  return (
                    (e.innerHTML = "<input/>"),
                    e.firstChild.setAttribute("value", ""),
                    "" === e.firstChild.getAttribute("value")
                  );
                })) ||
                fe("value", function (e, t, n) {
                  if (!n && "input" === e.nodeName.toLowerCase())
                    return e.defaultValue;
                }),
              ce(function (e) {
                return null == e.getAttribute("disabled");
              }) ||
                fe(R, function (e, t, n) {
                  var r;
                  if (!n)
                    return !0 === e[t]
                      ? t.toLowerCase()
                      : (r = e.getAttributeNode(t)) && r.specified
                      ? r.value
                      : null;
                }),
              se
            );
          })(t);
          (w.find = C),
            (w.expr = C.selectors),
            (w.expr[":"] = w.expr.pseudos),
            (w.uniqueSort = w.unique = C.uniqueSort),
            (w.text = C.getText),
            (w.isXMLDoc = C.isXML),
            (w.contains = C.contains),
            (w.escapeSelector = C.escape);
          var E = function (e, t, n) {
              for (
                var r = [], i = void 0 !== n;
                (e = e[t]) && 9 !== e.nodeType;

              )
                if (1 === e.nodeType) {
                  if (i && w(e).is(n)) break;
                  r.push(e);
                }
              return r;
            },
            S = function (e, t) {
              for (var n = []; e; e = e.nextSibling)
                1 === e.nodeType && e !== t && n.push(e);
              return n;
            },
            k = w.expr.match.needsContext;
          function A(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
          }
          var N =
            /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
          function j(e, t, n) {
            return g(t)
              ? w.grep(e, function (e, r) {
                  return !!t.call(e, r, e) !== n;
                })
              : t.nodeType
              ? w.grep(e, function (e) {
                  return (e === t) !== n;
                })
              : "string" != typeof t
              ? w.grep(e, function (e) {
                  return u.call(t, e) > -1 !== n;
                })
              : w.filter(t, e, n);
          }
          (w.filter = function (e, t, n) {
            var r = t[0];
            return (
              n && (e = ":not(" + e + ")"),
              1 === t.length && 1 === r.nodeType
                ? w.find.matchesSelector(r, e)
                  ? [r]
                  : []
                : w.find.matches(
                    e,
                    w.grep(t, function (e) {
                      return 1 === e.nodeType;
                    }),
                  )
            );
          }),
            w.fn.extend({
              find: function (e) {
                var t,
                  n,
                  r = this.length,
                  i = this;
                if ("string" != typeof e)
                  return this.pushStack(
                    w(e).filter(function () {
                      for (t = 0; t < r; t++)
                        if (w.contains(i[t], this)) return !0;
                    }),
                  );
                for (n = this.pushStack([]), t = 0; t < r; t++)
                  w.find(e, i[t], n);
                return r > 1 ? w.uniqueSort(n) : n;
              },
              filter: function (e) {
                return this.pushStack(j(this, e || [], !1));
              },
              not: function (e) {
                return this.pushStack(j(this, e || [], !0));
              },
              is: function (e) {
                return !!j(
                  this,
                  "string" == typeof e && k.test(e) ? w(e) : e || [],
                  !1,
                ).length;
              },
            });
          var D,
            q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
          ((w.fn.init = function (e, t, n) {
            var r, i;
            if (!e) return this;
            if (((n = n || D), "string" == typeof e)) {
              if (
                !(r =
                  "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
                    ? [null, e, null]
                    : q.exec(e)) ||
                (!r[1] && t)
              )
                return !t || t.jquery
                  ? (t || n).find(e)
                  : this.constructor(t).find(e);
              if (r[1]) {
                if (
                  ((t = t instanceof w ? t[0] : t),
                  w.merge(
                    this,
                    w.parseHTML(
                      r[1],
                      t && t.nodeType ? t.ownerDocument || t : y,
                      !0,
                    ),
                  ),
                  N.test(r[1]) && w.isPlainObject(t))
                )
                  for (r in t) g(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                return this;
              }
              return (
                (i = y.getElementById(r[2])) &&
                  ((this[0] = i), (this.length = 1)),
                this
              );
            }
            return e.nodeType
              ? ((this[0] = e), (this.length = 1), this)
              : g(e)
              ? void 0 !== n.ready
                ? n.ready(e)
                : e(w)
              : w.makeArray(e, this);
          }).prototype = w.fn),
            (D = w(y));
          var L = /^(?:parents|prev(?:Until|All))/,
            H = { children: !0, contents: !0, next: !0, prev: !0 };
          function O(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType; );
            return e;
          }
          w.fn.extend({
            has: function (e) {
              var t = w(e, this),
                n = t.length;
              return this.filter(function () {
                for (var e = 0; e < n; e++)
                  if (w.contains(this, t[e])) return !0;
              });
            },
            closest: function (e, t) {
              var n,
                r = 0,
                i = this.length,
                o = [],
                a = "string" != typeof e && w(e);
              if (!k.test(e))
                for (; r < i; r++)
                  for (n = this[r]; n && n !== t; n = n.parentNode)
                    if (
                      n.nodeType < 11 &&
                      (a
                        ? a.index(n) > -1
                        : 1 === n.nodeType && w.find.matchesSelector(n, e))
                    ) {
                      o.push(n);
                      break;
                    }
              return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o);
            },
            index: function (e) {
              return e
                ? "string" == typeof e
                  ? u.call(w(e), this[0])
                  : u.call(this, e.jquery ? e[0] : e)
                : this[0] && this[0].parentNode
                ? this.first().prevAll().length
                : -1;
            },
            add: function (e, t) {
              return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))));
            },
            addBack: function (e) {
              return this.add(
                null == e ? this.prevObject : this.prevObject.filter(e),
              );
            },
          }),
            w.each(
              {
                parent: function (e) {
                  var t = e.parentNode;
                  return t && 11 !== t.nodeType ? t : null;
                },
                parents: function (e) {
                  return E(e, "parentNode");
                },
                parentsUntil: function (e, t, n) {
                  return E(e, "parentNode", n);
                },
                next: function (e) {
                  return O(e, "nextSibling");
                },
                prev: function (e) {
                  return O(e, "previousSibling");
                },
                nextAll: function (e) {
                  return E(e, "nextSibling");
                },
                prevAll: function (e) {
                  return E(e, "previousSibling");
                },
                nextUntil: function (e, t, n) {
                  return E(e, "nextSibling", n);
                },
                prevUntil: function (e, t, n) {
                  return E(e, "previousSibling", n);
                },
                siblings: function (e) {
                  return S((e.parentNode || {}).firstChild, e);
                },
                children: function (e) {
                  return S(e.firstChild);
                },
                contents: function (e) {
                  return null != e.contentDocument && i(e.contentDocument)
                    ? e.contentDocument
                    : (A(e, "template") && (e = e.content || e),
                      w.merge([], e.childNodes));
                },
              },
              function (e, t) {
                w.fn[e] = function (n, r) {
                  var i = w.map(this, t, n);
                  return (
                    "Until" !== e.slice(-5) && (r = n),
                    r && "string" == typeof r && (i = w.filter(r, i)),
                    this.length > 1 &&
                      (H[e] || w.uniqueSort(i), L.test(e) && i.reverse()),
                    this.pushStack(i)
                  );
                };
              },
            );
          var P = /[^\x20\t\r\n\f]+/g;
          function R(e) {
            return e;
          }
          function M(e) {
            throw e;
          }
          function I(e, t, n, r) {
            var i;
            try {
              e && g((i = e.promise))
                ? i.call(e).done(t).fail(n)
                : e && g((i = e.then))
                ? i.call(e, t, n)
                : t.apply(void 0, [e].slice(r));
            } catch (e) {
              n.apply(void 0, [e]);
            }
          }
          (w.Callbacks = function (e) {
            e =
              "string" == typeof e
                ? (function (e) {
                    var t = {};
                    return (
                      w.each(e.match(P) || [], function (e, n) {
                        t[n] = !0;
                      }),
                      t
                    );
                  })(e)
                : w.extend({}, e);
            var t,
              n,
              r,
              i,
              o = [],
              a = [],
              s = -1,
              u = function () {
                for (i = i || e.once, r = t = !0; a.length; s = -1)
                  for (n = a.shift(); ++s < o.length; )
                    !1 === o[s].apply(n[0], n[1]) &&
                      e.stopOnFalse &&
                      ((s = o.length), (n = !1));
                e.memory || (n = !1), (t = !1), i && (o = n ? [] : "");
              },
              l = {
                add: function () {
                  return (
                    o &&
                      (n && !t && ((s = o.length - 1), a.push(n)),
                      (function t(n) {
                        w.each(n, function (n, r) {
                          g(r)
                            ? (e.unique && l.has(r)) || o.push(r)
                            : r && r.length && "string" !== b(r) && t(r);
                        });
                      })(arguments),
                      n && !t && u()),
                    this
                  );
                },
                remove: function () {
                  return (
                    w.each(arguments, function (e, t) {
                      for (var n; (n = w.inArray(t, o, n)) > -1; )
                        o.splice(n, 1), n <= s && s--;
                    }),
                    this
                  );
                },
                has: function (e) {
                  return e ? w.inArray(e, o) > -1 : o.length > 0;
                },
                empty: function () {
                  return o && (o = []), this;
                },
                disable: function () {
                  return (i = a = []), (o = n = ""), this;
                },
                disabled: function () {
                  return !o;
                },
                lock: function () {
                  return (i = a = []), n || t || (o = n = ""), this;
                },
                locked: function () {
                  return !!i;
                },
                fireWith: function (e, n) {
                  return (
                    i ||
                      ((n = [e, (n = n || []).slice ? n.slice() : n]),
                      a.push(n),
                      t || u()),
                    this
                  );
                },
                fire: function () {
                  return l.fireWith(this, arguments), this;
                },
                fired: function () {
                  return !!r;
                },
              };
            return l;
          }),
            w.extend({
              Deferred: function (e) {
                var n = [
                    [
                      "notify",
                      "progress",
                      w.Callbacks("memory"),
                      w.Callbacks("memory"),
                      2,
                    ],
                    [
                      "resolve",
                      "done",
                      w.Callbacks("once memory"),
                      w.Callbacks("once memory"),
                      0,
                      "resolved",
                    ],
                    [
                      "reject",
                      "fail",
                      w.Callbacks("once memory"),
                      w.Callbacks("once memory"),
                      1,
                      "rejected",
                    ],
                  ],
                  r = "pending",
                  i = {
                    state: function () {
                      return r;
                    },
                    always: function () {
                      return o.done(arguments).fail(arguments), this;
                    },
                    catch: function (e) {
                      return i.then(null, e);
                    },
                    pipe: function () {
                      var e = arguments;
                      return w
                        .Deferred(function (t) {
                          w.each(n, function (n, r) {
                            var i = g(e[r[4]]) && e[r[4]];
                            o[r[1]](function () {
                              var e = i && i.apply(this, arguments);
                              e && g(e.promise)
                                ? e
                                    .promise()
                                    .progress(t.notify)
                                    .done(t.resolve)
                                    .fail(t.reject)
                                : t[r[0] + "With"](this, i ? [e] : arguments);
                            });
                          }),
                            (e = null);
                        })
                        .promise();
                    },
                    then: function (e, r, i) {
                      var o = 0;
                      function a(e, n, r, i) {
                        return function () {
                          var s = this,
                            u = arguments,
                            l = function () {
                              var t, l;
                              if (!(e < o)) {
                                if ((t = r.apply(s, u)) === n.promise())
                                  throw new TypeError(
                                    "Thenable self-resolution",
                                  );
                                (l =
                                  t &&
                                  ("object" == typeof t ||
                                    "function" == typeof t) &&
                                  t.then),
                                  g(l)
                                    ? i
                                      ? l.call(t, a(o, n, R, i), a(o, n, M, i))
                                      : (o++,
                                        l.call(
                                          t,
                                          a(o, n, R, i),
                                          a(o, n, M, i),
                                          a(o, n, R, n.notifyWith),
                                        ))
                                    : (r !== R && ((s = void 0), (u = [t])),
                                      (i || n.resolveWith)(s, u));
                              }
                            },
                            c = i
                              ? l
                              : function () {
                                  try {
                                    l();
                                  } catch (t) {
                                    w.Deferred.exceptionHook &&
                                      w.Deferred.exceptionHook(t, c.stackTrace),
                                      e + 1 >= o &&
                                        (r !== M && ((s = void 0), (u = [t])),
                                        n.rejectWith(s, u));
                                  }
                                };
                          e
                            ? c()
                            : (w.Deferred.getStackHook &&
                                (c.stackTrace = w.Deferred.getStackHook()),
                              t.setTimeout(c));
                        };
                      }
                      return w
                        .Deferred(function (t) {
                          n[0][3].add(a(0, t, g(i) ? i : R, t.notifyWith)),
                            n[1][3].add(a(0, t, g(e) ? e : R)),
                            n[2][3].add(a(0, t, g(r) ? r : M));
                        })
                        .promise();
                    },
                    promise: function (e) {
                      return null != e ? w.extend(e, i) : i;
                    },
                  },
                  o = {};
                return (
                  w.each(n, function (e, t) {
                    var a = t[2],
                      s = t[5];
                    (i[t[1]] = a.add),
                      s &&
                        a.add(
                          function () {
                            r = s;
                          },
                          n[3 - e][2].disable,
                          n[3 - e][3].disable,
                          n[0][2].lock,
                          n[0][3].lock,
                        ),
                      a.add(t[3].fire),
                      (o[t[0]] = function () {
                        return (
                          o[t[0] + "With"](
                            this === o ? void 0 : this,
                            arguments,
                          ),
                          this
                        );
                      }),
                      (o[t[0] + "With"] = a.fireWith);
                  }),
                  i.promise(o),
                  e && e.call(o, o),
                  o
                );
              },
              when: function (e) {
                var t = arguments.length,
                  n = t,
                  r = Array(n),
                  i = o.call(arguments),
                  a = w.Deferred(),
                  s = function (e) {
                    return function (n) {
                      (r[e] = this),
                        (i[e] = arguments.length > 1 ? o.call(arguments) : n),
                        --t || a.resolveWith(r, i);
                    };
                  };
                if (
                  t <= 1 &&
                  (I(e, a.done(s(n)).resolve, a.reject, !t),
                  "pending" === a.state() || g(i[n] && i[n].then))
                )
                  return a.then();
                for (; n--; ) I(i[n], s(n), a.reject);
                return a.promise();
              },
            });
          var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
          (w.Deferred.exceptionHook = function (e, n) {
            t.console &&
              t.console.warn &&
              e &&
              W.test(e.name) &&
              t.console.warn(
                "jQuery.Deferred exception: " + e.message,
                e.stack,
                n,
              );
          }),
            (w.readyException = function (e) {
              t.setTimeout(function () {
                throw e;
              });
            });
          var F = w.Deferred();
          function B() {
            y.removeEventListener("DOMContentLoaded", B),
              t.removeEventListener("load", B),
              w.ready();
          }
          (w.fn.ready = function (e) {
            return (
              F.then(e).catch(function (e) {
                w.readyException(e);
              }),
              this
            );
          }),
            w.extend({
              isReady: !1,
              readyWait: 1,
              ready: function (e) {
                (!0 === e ? --w.readyWait : w.isReady) ||
                  ((w.isReady = !0),
                  (!0 !== e && --w.readyWait > 0) || F.resolveWith(y, [w]));
              },
            }),
            (w.ready.then = F.then),
            "complete" === y.readyState ||
            ("loading" !== y.readyState && !y.documentElement.doScroll)
              ? t.setTimeout(w.ready)
              : (y.addEventListener("DOMContentLoaded", B),
                t.addEventListener("load", B));
          var $ = function (e, t, n, r, i, o, a) {
              var s = 0,
                u = e.length,
                l = null == n;
              if ("object" === b(n))
                for (s in ((i = !0), n)) $(e, t, s, n[s], !0, o, a);
              else if (
                void 0 !== r &&
                ((i = !0),
                g(r) || (a = !0),
                l &&
                  (a
                    ? (t.call(e, r), (t = null))
                    : ((l = t),
                      (t = function (e, t, n) {
                        return l.call(w(e), n);
                      }))),
                t)
              )
                for (; s < u; s++)
                  t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
              return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
            },
            _ = /^-ms-/,
            z = /-([a-z])/g;
          function U(e, t) {
            return t.toUpperCase();
          }
          function X(e) {
            return e.replace(_, "ms-").replace(z, U);
          }
          var V = function (e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
          };
          function G() {
            this.expando = w.expando + G.uid++;
          }
          (G.uid = 1),
            (G.prototype = {
              cache: function (e) {
                var t = e[this.expando];
                return (
                  t ||
                    ((t = {}),
                    V(e) &&
                      (e.nodeType
                        ? (e[this.expando] = t)
                        : Object.defineProperty(e, this.expando, {
                            value: t,
                            configurable: !0,
                          }))),
                  t
                );
              },
              set: function (e, t, n) {
                var r,
                  i = this.cache(e);
                if ("string" == typeof t) i[X(t)] = n;
                else for (r in t) i[X(r)] = t[r];
                return i;
              },
              get: function (e, t) {
                return void 0 === t
                  ? this.cache(e)
                  : e[this.expando] && e[this.expando][X(t)];
              },
              access: function (e, t, n) {
                return void 0 === t ||
                  (t && "string" == typeof t && void 0 === n)
                  ? this.get(e, t)
                  : (this.set(e, t, n), void 0 !== n ? n : t);
              },
              remove: function (e, t) {
                var n,
                  r = e[this.expando];
                if (void 0 !== r) {
                  if (void 0 !== t) {
                    n = (t = Array.isArray(t)
                      ? t.map(X)
                      : (t = X(t)) in r
                      ? [t]
                      : t.match(P) || []).length;
                    for (; n--; ) delete r[t[n]];
                  }
                  (void 0 === t || w.isEmptyObject(r)) &&
                    (e.nodeType
                      ? (e[this.expando] = void 0)
                      : delete e[this.expando]);
                }
              },
              hasData: function (e) {
                var t = e[this.expando];
                return void 0 !== t && !w.isEmptyObject(t);
              },
            });
          var Y = new G(),
            Q = new G(),
            J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            K = /[A-Z]/g;
          function Z(e, t, n) {
            var r;
            if (void 0 === n && 1 === e.nodeType)
              if (
                ((r = "data-" + t.replace(K, "-$&").toLowerCase()),
                "string" == typeof (n = e.getAttribute(r)))
              ) {
                try {
                  n = (function (e) {
                    return (
                      "true" === e ||
                      ("false" !== e &&
                        ("null" === e
                          ? null
                          : e === +e + ""
                          ? +e
                          : J.test(e)
                          ? JSON.parse(e)
                          : e))
                    );
                  })(n);
                } catch (i) {}
                Q.set(e, t, n);
              } else n = void 0;
            return n;
          }
          w.extend({
            hasData: function (e) {
              return Q.hasData(e) || Y.hasData(e);
            },
            data: function (e, t, n) {
              return Q.access(e, t, n);
            },
            removeData: function (e, t) {
              Q.remove(e, t);
            },
            _data: function (e, t, n) {
              return Y.access(e, t, n);
            },
            _removeData: function (e, t) {
              Y.remove(e, t);
            },
          }),
            w.fn.extend({
              data: function (e, t) {
                var n,
                  r,
                  i,
                  o = this[0],
                  a = o && o.attributes;
                if (void 0 === e) {
                  if (
                    this.length &&
                    ((i = Q.get(o)),
                    1 === o.nodeType && !Y.get(o, "hasDataAttrs"))
                  ) {
                    for (n = a.length; n--; )
                      a[n] &&
                        0 === (r = a[n].name).indexOf("data-") &&
                        ((r = X(r.slice(5))), Z(o, r, i[r]));
                    Y.set(o, "hasDataAttrs", !0);
                  }
                  return i;
                }
                return "object" == typeof e
                  ? this.each(function () {
                      Q.set(this, e);
                    })
                  : $(
                      this,
                      function (t) {
                        var n;
                        if (o && void 0 === t)
                          return void 0 !== (n = Q.get(o, e))
                            ? n
                            : void 0 !== (n = Z(o, e))
                            ? n
                            : void 0;
                        this.each(function () {
                          Q.set(this, e, t);
                        });
                      },
                      null,
                      t,
                      arguments.length > 1,
                      null,
                      !0,
                    );
              },
              removeData: function (e) {
                return this.each(function () {
                  Q.remove(this, e);
                });
              },
            }),
            w.extend({
              queue: function (e, t, n) {
                var r;
                if (e)
                  return (
                    (t = (t || "fx") + "queue"),
                    (r = Y.get(e, t)),
                    n &&
                      (!r || Array.isArray(n)
                        ? (r = Y.access(e, t, w.makeArray(n)))
                        : r.push(n)),
                    r || []
                  );
              },
              dequeue: function (e, t) {
                t = t || "fx";
                var n = w.queue(e, t),
                  r = n.length,
                  i = n.shift(),
                  o = w._queueHooks(e, t);
                "inprogress" === i && ((i = n.shift()), r--),
                  i &&
                    ("fx" === t && n.unshift("inprogress"),
                    delete o.stop,
                    i.call(
                      e,
                      function () {
                        w.dequeue(e, t);
                      },
                      o,
                    )),
                  !r && o && o.empty.fire();
              },
              _queueHooks: function (e, t) {
                var n = t + "queueHooks";
                return (
                  Y.get(e, n) ||
                  Y.access(e, n, {
                    empty: w.Callbacks("once memory").add(function () {
                      Y.remove(e, [t + "queue", n]);
                    }),
                  })
                );
              },
            }),
            w.fn.extend({
              queue: function (e, t) {
                var n = 2;
                return (
                  "string" != typeof e && ((t = e), (e = "fx"), n--),
                  arguments.length < n
                    ? w.queue(this[0], e)
                    : void 0 === t
                    ? this
                    : this.each(function () {
                        var n = w.queue(this, e, t);
                        w._queueHooks(this, e),
                          "fx" === e &&
                            "inprogress" !== n[0] &&
                            w.dequeue(this, e);
                      })
                );
              },
              dequeue: function (e) {
                return this.each(function () {
                  w.dequeue(this, e);
                });
              },
              clearQueue: function (e) {
                return this.queue(e || "fx", []);
              },
              promise: function (e, t) {
                var n,
                  r = 1,
                  i = w.Deferred(),
                  o = this,
                  a = this.length,
                  s = function () {
                    --r || i.resolveWith(o, [o]);
                  };
                for (
                  "string" != typeof e && ((t = e), (e = void 0)),
                    e = e || "fx";
                  a--;

                )
                  (n = Y.get(o[a], e + "queueHooks")) &&
                    n.empty &&
                    (r++, n.empty.add(s));
                return s(), i.promise(t);
              },
            });
          var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
            ne = ["Top", "Right", "Bottom", "Left"],
            re = y.documentElement,
            ie = function (e) {
              return w.contains(e.ownerDocument, e);
            },
            oe = { composed: !0 };
          re.getRootNode &&
            (ie = function (e) {
              return (
                w.contains(e.ownerDocument, e) ||
                e.getRootNode(oe) === e.ownerDocument
              );
            });
          var ae = function (e, t) {
            return (
              "none" === (e = t || e).style.display ||
              ("" === e.style.display &&
                ie(e) &&
                "none" === w.css(e, "display"))
            );
          };
          function se(e, t, n, r) {
            var i,
              o,
              a = 20,
              s = r
                ? function () {
                    return r.cur();
                  }
                : function () {
                    return w.css(e, t, "");
                  },
              u = s(),
              l = (n && n[3]) || (w.cssNumber[t] ? "" : "px"),
              c =
                e.nodeType &&
                (w.cssNumber[t] || ("px" !== l && +u)) &&
                te.exec(w.css(e, t));
            if (c && c[3] !== l) {
              for (u /= 2, l = l || c[3], c = +u || 1; a--; )
                w.style(e, t, c + l),
                  (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0),
                  (c /= o);
              (c *= 2), w.style(e, t, c + l), (n = n || []);
            }
            return (
              n &&
                ((c = +c || +u || 0),
                (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
                r && ((r.unit = l), (r.start = c), (r.end = i))),
              i
            );
          }
          var ue = {};
          function le(e) {
            var t,
              n = e.ownerDocument,
              r = e.nodeName,
              i = ue[r];
            return (
              i ||
              ((t = n.body.appendChild(n.createElement(r))),
              (i = w.css(t, "display")),
              t.parentNode.removeChild(t),
              "none" === i && (i = "block"),
              (ue[r] = i),
              i)
            );
          }
          function ce(e, t) {
            for (var n, r, i = [], o = 0, a = e.length; o < a; o++)
              (r = e[o]).style &&
                ((n = r.style.display),
                t
                  ? ("none" === n &&
                      ((i[o] = Y.get(r, "display") || null),
                      i[o] || (r.style.display = "")),
                    "" === r.style.display && ae(r) && (i[o] = le(r)))
                  : "none" !== n && ((i[o] = "none"), Y.set(r, "display", n)));
            for (o = 0; o < a; o++) null != i[o] && (e[o].style.display = i[o]);
            return e;
          }
          w.fn.extend({
            show: function () {
              return ce(this, !0);
            },
            hide: function () {
              return ce(this);
            },
            toggle: function (e) {
              return "boolean" == typeof e
                ? e
                  ? this.show()
                  : this.hide()
                : this.each(function () {
                    ae(this) ? w(this).show() : w(this).hide();
                  });
            },
          });
          var fe,
            pe,
            de = /^(?:checkbox|radio)$/i,
            he = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            ge = /^$|^module$|\/(?:java|ecma)script/i;
          (fe = y.createDocumentFragment().appendChild(y.createElement("div"))),
            (pe = y.createElement("input")).setAttribute("type", "radio"),
            pe.setAttribute("checked", "checked"),
            pe.setAttribute("name", "t"),
            fe.appendChild(pe),
            (h.checkClone = fe.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (fe.innerHTML = "<textarea>x</textarea>"),
            (h.noCloneChecked = !!fe.cloneNode(!0).lastChild.defaultValue),
            (fe.innerHTML = "<option></option>"),
            (h.option = !!fe.lastChild);
          var ve = {
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""],
          };
          function ye(e, t) {
            var n;
            return (
              (n =
                void 0 !== e.getElementsByTagName
                  ? e.getElementsByTagName(t || "*")
                  : void 0 !== e.querySelectorAll
                  ? e.querySelectorAll(t || "*")
                  : []),
              void 0 === t || (t && A(e, t)) ? w.merge([e], n) : n
            );
          }
          function me(e, t) {
            for (var n = 0, r = e.length; n < r; n++)
              Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"));
          }
          (ve.tbody = ve.tfoot = ve.colgroup = ve.caption = ve.thead),
            (ve.th = ve.td),
            h.option ||
              (ve.optgroup = ve.option =
                [1, "<select multiple='multiple'>", "</select>"]);
          var xe = /<|&#?\w+;/;
          function be(e, t, n, r, i) {
            for (
              var o,
                a,
                s,
                u,
                l,
                c,
                f = t.createDocumentFragment(),
                p = [],
                d = 0,
                h = e.length;
              d < h;
              d++
            )
              if ((o = e[d]) || 0 === o)
                if ("object" === b(o)) w.merge(p, o.nodeType ? [o] : o);
                else if (xe.test(o)) {
                  for (
                    a = a || f.appendChild(t.createElement("div")),
                      s = (he.exec(o) || ["", ""])[1].toLowerCase(),
                      u = ve[s] || ve._default,
                      a.innerHTML = u[1] + w.htmlPrefilter(o) + u[2],
                      c = u[0];
                    c--;

                  )
                    a = a.lastChild;
                  w.merge(p, a.childNodes),
                    ((a = f.firstChild).textContent = "");
                } else p.push(t.createTextNode(o));
            for (f.textContent = "", d = 0; (o = p[d++]); )
              if (r && w.inArray(o, r) > -1) i && i.push(o);
              else if (
                ((l = ie(o)),
                (a = ye(f.appendChild(o), "script")),
                l && me(a),
                n)
              )
                for (c = 0; (o = a[c++]); ) ge.test(o.type || "") && n.push(o);
            return f;
          }
          var we = /^([^.]*)(?:\.(.+)|)/;
          function Te() {
            return !0;
          }
          function Ce() {
            return !1;
          }
          function Ee(e, t) {
            return (
              (e ===
                (function () {
                  try {
                    return y.activeElement;
                  } catch (e) {}
                })()) ==
              ("focus" === t)
            );
          }
          function Se(e, t, n, r, i, o) {
            var a, s;
            if ("object" == typeof t) {
              for (s in ("string" != typeof n && ((r = r || n), (n = void 0)),
              t))
                Se(e, s, n, r, t[s], o);
              return e;
            }
            if (
              (null == r && null == i
                ? ((i = n), (r = n = void 0))
                : null == i &&
                  ("string" == typeof n
                    ? ((i = r), (r = void 0))
                    : ((i = r), (r = n), (n = void 0))),
              !1 === i)
            )
              i = Ce;
            else if (!i) return e;
            return (
              1 === o &&
                ((a = i),
                ((i = function (e) {
                  return w().off(e), a.apply(this, arguments);
                }).guid = a.guid || (a.guid = w.guid++))),
              e.each(function () {
                w.event.add(this, t, i, r, n);
              })
            );
          }
          function ke(e, t, n) {
            n
              ? (Y.set(e, t, !1),
                w.event.add(e, t, {
                  namespace: !1,
                  handler: function (e) {
                    var r,
                      i,
                      a = Y.get(this, t);
                    if (1 & e.isTrigger && this[t]) {
                      if (a.length)
                        (w.event.special[t] || {}).delegateType &&
                          e.stopPropagation();
                      else if (
                        ((a = o.call(arguments)),
                        Y.set(this, t, a),
                        (r = n(this, t)),
                        this[t](),
                        a !== (i = Y.get(this, t)) || r
                          ? Y.set(this, t, !1)
                          : (i = {}),
                        a !== i)
                      )
                        return (
                          e.stopImmediatePropagation(),
                          e.preventDefault(),
                          i && i.value
                        );
                    } else
                      a.length &&
                        (Y.set(this, t, {
                          value: w.event.trigger(
                            w.extend(a[0], w.Event.prototype),
                            a.slice(1),
                            this,
                          ),
                        }),
                        e.stopImmediatePropagation());
                  },
                }))
              : void 0 === Y.get(e, t) && w.event.add(e, t, Te);
          }
          (w.event = {
            global: {},
            add: function (e, t, n, r, i) {
              var o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                d,
                h,
                g,
                v = Y.get(e);
              if (V(e))
                for (
                  n.handler && ((n = (o = n).handler), (i = o.selector)),
                    i && w.find.matchesSelector(re, i),
                    n.guid || (n.guid = w.guid++),
                    (u = v.events) || (u = v.events = Object.create(null)),
                    (a = v.handle) ||
                      (a = v.handle =
                        function (t) {
                          return void 0 !== w && w.event.triggered !== t.type
                            ? w.event.dispatch.apply(e, arguments)
                            : void 0;
                        }),
                    l = (t = (t || "").match(P) || [""]).length;
                  l--;

                )
                  (d = g = (s = we.exec(t[l]) || [])[1]),
                    (h = (s[2] || "").split(".").sort()),
                    d &&
                      ((f = w.event.special[d] || {}),
                      (d = (i ? f.delegateType : f.bindType) || d),
                      (f = w.event.special[d] || {}),
                      (c = w.extend(
                        {
                          type: d,
                          origType: g,
                          data: r,
                          handler: n,
                          guid: n.guid,
                          selector: i,
                          needsContext: i && w.expr.match.needsContext.test(i),
                          namespace: h.join("."),
                        },
                        o,
                      )),
                      (p = u[d]) ||
                        (((p = u[d] = []).delegateCount = 0),
                        (f.setup && !1 !== f.setup.call(e, r, h, a)) ||
                          (e.addEventListener && e.addEventListener(d, a))),
                      f.add &&
                        (f.add.call(e, c),
                        c.handler.guid || (c.handler.guid = n.guid)),
                      i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                      (w.event.global[d] = !0));
            },
            remove: function (e, t, n, r, i) {
              var o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                d,
                h,
                g,
                v = Y.hasData(e) && Y.get(e);
              if (v && (u = v.events)) {
                for (l = (t = (t || "").match(P) || [""]).length; l--; )
                  if (
                    ((d = g = (s = we.exec(t[l]) || [])[1]),
                    (h = (s[2] || "").split(".").sort()),
                    d)
                  ) {
                    for (
                      f = w.event.special[d] || {},
                        p =
                          u[(d = (r ? f.delegateType : f.bindType) || d)] || [],
                        s =
                          s[2] &&
                          new RegExp(
                            "(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)",
                          ),
                        a = o = p.length;
                      o--;

                    )
                      (c = p[o]),
                        (!i && g !== c.origType) ||
                          (n && n.guid !== c.guid) ||
                          (s && !s.test(c.namespace)) ||
                          (r &&
                            r !== c.selector &&
                            ("**" !== r || !c.selector)) ||
                          (p.splice(o, 1),
                          c.selector && p.delegateCount--,
                          f.remove && f.remove.call(e, c));
                    a &&
                      !p.length &&
                      ((f.teardown && !1 !== f.teardown.call(e, h, v.handle)) ||
                        w.removeEvent(e, d, v.handle),
                      delete u[d]);
                  } else for (d in u) w.event.remove(e, d + t[l], n, r, !0);
                w.isEmptyObject(u) && Y.remove(e, "handle events");
              }
            },
            dispatch: function (e) {
              var t,
                n,
                r,
                i,
                o,
                a,
                s = new Array(arguments.length),
                u = w.event.fix(e),
                l =
                  (Y.get(this, "events") || Object.create(null))[u.type] || [],
                c = w.event.special[u.type] || {};
              for (s[0] = u, t = 1; t < arguments.length; t++)
                s[t] = arguments[t];
              if (
                ((u.delegateTarget = this),
                !c.preDispatch || !1 !== c.preDispatch.call(this, u))
              ) {
                for (
                  a = w.event.handlers.call(this, u, l), t = 0;
                  (i = a[t++]) && !u.isPropagationStopped();

                )
                  for (
                    u.currentTarget = i.elem, n = 0;
                    (o = i.handlers[n++]) && !u.isImmediatePropagationStopped();

                  )
                    (u.rnamespace &&
                      !1 !== o.namespace &&
                      !u.rnamespace.test(o.namespace)) ||
                      ((u.handleObj = o),
                      (u.data = o.data),
                      void 0 !==
                        (r = (
                          (w.event.special[o.origType] || {}).handle ||
                          o.handler
                        ).apply(i.elem, s)) &&
                        !1 === (u.result = r) &&
                        (u.preventDefault(), u.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, u), u.result;
              }
            },
            handlers: function (e, t) {
              var n,
                r,
                i,
                o,
                a,
                s = [],
                u = t.delegateCount,
                l = e.target;
              if (u && l.nodeType && !("click" === e.type && e.button >= 1))
                for (; l !== this; l = l.parentNode || this)
                  if (
                    1 === l.nodeType &&
                    ("click" !== e.type || !0 !== l.disabled)
                  ) {
                    for (o = [], a = {}, n = 0; n < u; n++)
                      void 0 === a[(i = (r = t[n]).selector + " ")] &&
                        (a[i] = r.needsContext
                          ? w(i, this).index(l) > -1
                          : w.find(i, this, null, [l]).length),
                        a[i] && o.push(r);
                    o.length && s.push({ elem: l, handlers: o });
                  }
              return (
                (l = this),
                u < t.length && s.push({ elem: l, handlers: t.slice(u) }),
                s
              );
            },
            addProp: function (e, t) {
              Object.defineProperty(w.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: g(t)
                  ? function () {
                      if (this.originalEvent) return t(this.originalEvent);
                    }
                  : function () {
                      if (this.originalEvent) return this.originalEvent[e];
                    },
                set: function (t) {
                  Object.defineProperty(this, e, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: t,
                  });
                },
              });
            },
            fix: function (e) {
              return e[w.expando] ? e : new w.Event(e);
            },
            special: {
              load: { noBubble: !0 },
              click: {
                setup: function (e) {
                  var t = this || e;
                  return (
                    de.test(t.type) &&
                      t.click &&
                      A(t, "input") &&
                      ke(t, "click", Te),
                    !1
                  );
                },
                trigger: function (e) {
                  var t = this || e;
                  return (
                    de.test(t.type) &&
                      t.click &&
                      A(t, "input") &&
                      ke(t, "click"),
                    !0
                  );
                },
                _default: function (e) {
                  var t = e.target;
                  return (
                    (de.test(t.type) &&
                      t.click &&
                      A(t, "input") &&
                      Y.get(t, "click")) ||
                    A(t, "a")
                  );
                },
              },
              beforeunload: {
                postDispatch: function (e) {
                  void 0 !== e.result &&
                    e.originalEvent &&
                    (e.originalEvent.returnValue = e.result);
                },
              },
            },
          }),
            (w.removeEvent = function (e, t, n) {
              e.removeEventListener && e.removeEventListener(t, n);
            }),
            (w.Event = function (e, t) {
              if (!(this instanceof w.Event)) return new w.Event(e, t);
              e && e.type
                ? ((this.originalEvent = e),
                  (this.type = e.type),
                  (this.isDefaultPrevented =
                    e.defaultPrevented ||
                    (void 0 === e.defaultPrevented && !1 === e.returnValue)
                      ? Te
                      : Ce),
                  (this.target =
                    e.target && 3 === e.target.nodeType
                      ? e.target.parentNode
                      : e.target),
                  (this.currentTarget = e.currentTarget),
                  (this.relatedTarget = e.relatedTarget))
                : (this.type = e),
                t && w.extend(this, t),
                (this.timeStamp = (e && e.timeStamp) || Date.now()),
                (this[w.expando] = !0);
            }),
            (w.Event.prototype = {
              constructor: w.Event,
              isDefaultPrevented: Ce,
              isPropagationStopped: Ce,
              isImmediatePropagationStopped: Ce,
              isSimulated: !1,
              preventDefault: function () {
                var e = this.originalEvent;
                (this.isDefaultPrevented = Te),
                  e && !this.isSimulated && e.preventDefault();
              },
              stopPropagation: function () {
                var e = this.originalEvent;
                (this.isPropagationStopped = Te),
                  e && !this.isSimulated && e.stopPropagation();
              },
              stopImmediatePropagation: function () {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = Te),
                  e && !this.isSimulated && e.stopImmediatePropagation(),
                  this.stopPropagation();
              },
            }),
            w.each(
              {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: !0,
              },
              w.event.addProp,
            ),
            w.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
              w.event.special[e] = {
                setup: function () {
                  return ke(this, e, Ee), !1;
                },
                trigger: function () {
                  return ke(this, e), !0;
                },
                _default: function () {
                  return !0;
                },
                delegateType: t,
              };
            }),
            w.each(
              {
                mouseenter: "mouseover",
                mouseleave: "mouseout",
                pointerenter: "pointerover",
                pointerleave: "pointerout",
              },
              function (e, t) {
                w.event.special[e] = {
                  delegateType: t,
                  bindType: t,
                  handle: function (e) {
                    var n,
                      r = e.relatedTarget,
                      i = e.handleObj;
                    return (
                      (r && (r === this || w.contains(this, r))) ||
                        ((e.type = i.origType),
                        (n = i.handler.apply(this, arguments)),
                        (e.type = t)),
                      n
                    );
                  },
                };
              },
            ),
            w.fn.extend({
              on: function (e, t, n, r) {
                return Se(this, e, t, n, r);
              },
              one: function (e, t, n, r) {
                return Se(this, e, t, n, r, 1);
              },
              off: function (e, t, n) {
                var r, i;
                if (e && e.preventDefault && e.handleObj)
                  return (
                    (r = e.handleObj),
                    w(e.delegateTarget).off(
                      r.namespace ? r.origType + "." + r.namespace : r.origType,
                      r.selector,
                      r.handler,
                    ),
                    this
                  );
                if ("object" == typeof e) {
                  for (i in e) this.off(i, t, e[i]);
                  return this;
                }
                return (
                  (!1 !== t && "function" != typeof t) ||
                    ((n = t), (t = void 0)),
                  !1 === n && (n = Ce),
                  this.each(function () {
                    w.event.remove(this, e, n, t);
                  })
                );
              },
            });
          var Ae = /<script|<style|<link/i,
            Ne = /checked\s*(?:[^=]|=\s*.checked.)/i,
            je = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
          function De(e, t) {
            return (
              (A(e, "table") &&
                A(11 !== t.nodeType ? t : t.firstChild, "tr") &&
                w(e).children("tbody")[0]) ||
              e
            );
          }
          function qe(e) {
            return (
              (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e
            );
          }
          function Le(e) {
            return (
              "true/" === (e.type || "").slice(0, 5)
                ? (e.type = e.type.slice(5))
                : e.removeAttribute("type"),
              e
            );
          }
          function He(e, t) {
            var n, r, i, o, a, s;
            if (1 === t.nodeType) {
              if (Y.hasData(e) && (s = Y.get(e).events))
                for (i in (Y.remove(t, "handle events"), s))
                  for (n = 0, r = s[i].length; n < r; n++)
                    w.event.add(t, i, s[i][n]);
              Q.hasData(e) &&
                ((o = Q.access(e)), (a = w.extend({}, o)), Q.set(t, a));
            }
          }
          function Oe(e, t, n, r) {
            t = a(t);
            var i,
              o,
              s,
              u,
              l,
              c,
              f = 0,
              p = e.length,
              d = p - 1,
              v = t[0],
              y = g(v);
            if (
              y ||
              (p > 1 && "string" == typeof v && !h.checkClone && Ne.test(v))
            )
              return e.each(function (i) {
                var o = e.eq(i);
                y && (t[0] = v.call(this, i, o.html())), Oe(o, t, n, r);
              });
            if (
              p &&
              ((o = (i = be(t, e[0].ownerDocument, !1, e, r)).firstChild),
              1 === i.childNodes.length && (i = o),
              o || r)
            ) {
              for (u = (s = w.map(ye(i, "script"), qe)).length; f < p; f++)
                (l = i),
                  f !== d &&
                    ((l = w.clone(l, !0, !0)),
                    u && w.merge(s, ye(l, "script"))),
                  n.call(e[f], l, f);
              if (u)
                for (
                  c = s[s.length - 1].ownerDocument, w.map(s, Le), f = 0;
                  f < u;
                  f++
                )
                  (l = s[f]),
                    ge.test(l.type || "") &&
                      !Y.access(l, "globalEval") &&
                      w.contains(c, l) &&
                      (l.src && "module" !== (l.type || "").toLowerCase()
                        ? w._evalUrl &&
                          !l.noModule &&
                          w._evalUrl(
                            l.src,
                            { nonce: l.nonce || l.getAttribute("nonce") },
                            c,
                          )
                        : x(l.textContent.replace(je, ""), l, c));
            }
            return e;
          }
          function Pe(e, t, n) {
            for (
              var r, i = t ? w.filter(t, e) : e, o = 0;
              null != (r = i[o]);
              o++
            )
              n || 1 !== r.nodeType || w.cleanData(ye(r)),
                r.parentNode &&
                  (n && ie(r) && me(ye(r, "script")),
                  r.parentNode.removeChild(r));
            return e;
          }
          w.extend({
            htmlPrefilter: function (e) {
              return e;
            },
            clone: function (e, t, n) {
              var r,
                i,
                o,
                a,
                s,
                u,
                l,
                c = e.cloneNode(!0),
                f = ie(e);
              if (
                !(
                  h.noCloneChecked ||
                  (1 !== e.nodeType && 11 !== e.nodeType) ||
                  w.isXMLDoc(e)
                )
              )
                for (a = ye(c), r = 0, i = (o = ye(e)).length; r < i; r++)
                  (s = o[r]),
                    (u = a[r]),
                    (l = void 0),
                    "input" === (l = u.nodeName.toLowerCase()) &&
                    de.test(s.type)
                      ? (u.checked = s.checked)
                      : ("input" !== l && "textarea" !== l) ||
                        (u.defaultValue = s.defaultValue);
              if (t)
                if (n)
                  for (
                    o = o || ye(e), a = a || ye(c), r = 0, i = o.length;
                    r < i;
                    r++
                  )
                    He(o[r], a[r]);
                else He(e, c);
              return (
                (a = ye(c, "script")).length > 0 &&
                  me(a, !f && ye(e, "script")),
                c
              );
            },
            cleanData: function (e) {
              for (
                var t, n, r, i = w.event.special, o = 0;
                void 0 !== (n = e[o]);
                o++
              )
                if (V(n)) {
                  if ((t = n[Y.expando])) {
                    if (t.events)
                      for (r in t.events)
                        i[r]
                          ? w.event.remove(n, r)
                          : w.removeEvent(n, r, t.handle);
                    n[Y.expando] = void 0;
                  }
                  n[Q.expando] && (n[Q.expando] = void 0);
                }
            },
          }),
            w.fn.extend({
              detach: function (e) {
                return Pe(this, e, !0);
              },
              remove: function (e) {
                return Pe(this, e);
              },
              text: function (e) {
                return $(
                  this,
                  function (e) {
                    return void 0 === e
                      ? w.text(this)
                      : this.empty().each(function () {
                          (1 !== this.nodeType &&
                            11 !== this.nodeType &&
                            9 !== this.nodeType) ||
                            (this.textContent = e);
                        });
                  },
                  null,
                  e,
                  arguments.length,
                );
              },
              append: function () {
                return Oe(this, arguments, function (e) {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    De(this, e).appendChild(e);
                });
              },
              prepend: function () {
                return Oe(this, arguments, function (e) {
                  if (
                    1 === this.nodeType ||
                    11 === this.nodeType ||
                    9 === this.nodeType
                  ) {
                    var t = De(this, e);
                    t.insertBefore(e, t.firstChild);
                  }
                });
              },
              before: function () {
                return Oe(this, arguments, function (e) {
                  this.parentNode && this.parentNode.insertBefore(e, this);
                });
              },
              after: function () {
                return Oe(this, arguments, function (e) {
                  this.parentNode &&
                    this.parentNode.insertBefore(e, this.nextSibling);
                });
              },
              empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++)
                  1 === e.nodeType &&
                    (w.cleanData(ye(e, !1)), (e.textContent = ""));
                return this;
              },
              clone: function (e, t) {
                return (
                  (e = null != e && e),
                  (t = null == t ? e : t),
                  this.map(function () {
                    return w.clone(this, e, t);
                  })
                );
              },
              html: function (e) {
                return $(
                  this,
                  function (e) {
                    var t = this[0] || {},
                      n = 0,
                      r = this.length;
                    if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                    if (
                      "string" == typeof e &&
                      !Ae.test(e) &&
                      !ve[(he.exec(e) || ["", ""])[1].toLowerCase()]
                    ) {
                      e = w.htmlPrefilter(e);
                      try {
                        for (; n < r; n++)
                          1 === (t = this[n] || {}).nodeType &&
                            (w.cleanData(ye(t, !1)), (t.innerHTML = e));
                        t = 0;
                      } catch (i) {}
                    }
                    t && this.empty().append(e);
                  },
                  null,
                  e,
                  arguments.length,
                );
              },
              replaceWith: function () {
                var e = [];
                return Oe(
                  this,
                  arguments,
                  function (t) {
                    var n = this.parentNode;
                    w.inArray(this, e) < 0 &&
                      (w.cleanData(ye(this)), n && n.replaceChild(t, this));
                  },
                  e,
                );
              },
            }),
            w.each(
              {
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith",
              },
              function (e, t) {
                w.fn[e] = function (e) {
                  for (
                    var n, r = [], i = w(e), o = i.length - 1, a = 0;
                    a <= o;
                    a++
                  )
                    (n = a === o ? this : this.clone(!0)),
                      w(i[a])[t](n),
                      s.apply(r, n.get());
                  return this.pushStack(r);
                };
              },
            );
          var Re = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
            Me = function (e) {
              var n = e.ownerDocument.defaultView;
              return (n && n.opener) || (n = t), n.getComputedStyle(e);
            },
            Ie = function (e, t, n) {
              var r,
                i,
                o = {};
              for (i in t) (o[i] = e.style[i]), (e.style[i] = t[i]);
              for (i in ((r = n.call(e)), t)) e.style[i] = o[i];
              return r;
            },
            We = new RegExp(ne.join("|"), "i");
          function Fe(e, t, n) {
            var r,
              i,
              o,
              a,
              s = e.style;
            return (
              (n = n || Me(e)) &&
                ("" !== (a = n.getPropertyValue(t) || n[t]) ||
                  ie(e) ||
                  (a = w.style(e, t)),
                !h.pixelBoxStyles() &&
                  Re.test(a) &&
                  We.test(t) &&
                  ((r = s.width),
                  (i = s.minWidth),
                  (o = s.maxWidth),
                  (s.minWidth = s.maxWidth = s.width = a),
                  (a = n.width),
                  (s.width = r),
                  (s.minWidth = i),
                  (s.maxWidth = o))),
              void 0 !== a ? a + "" : a
            );
          }
          function Be(e, t) {
            return {
              get: function () {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
              },
            };
          }
          !(function () {
            function e() {
              if (c) {
                (l.style.cssText =
                  "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                  (c.style.cssText =
                    "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                  re.appendChild(l).appendChild(c);
                var e = t.getComputedStyle(c);
                (r = "1%" !== e.top),
                  (u = 12 === n(e.marginLeft)),
                  (c.style.right = "60%"),
                  (a = 36 === n(e.right)),
                  (i = 36 === n(e.width)),
                  (c.style.position = "absolute"),
                  (o = 12 === n(c.offsetWidth / 3)),
                  re.removeChild(l),
                  (c = null);
              }
            }
            function n(e) {
              return Math.round(parseFloat(e));
            }
            var r,
              i,
              o,
              a,
              s,
              u,
              l = y.createElement("div"),
              c = y.createElement("div");
            c.style &&
              ((c.style.backgroundClip = "content-box"),
              (c.cloneNode(!0).style.backgroundClip = ""),
              (h.clearCloneStyle = "content-box" === c.style.backgroundClip),
              w.extend(h, {
                boxSizingReliable: function () {
                  return e(), i;
                },
                pixelBoxStyles: function () {
                  return e(), a;
                },
                pixelPosition: function () {
                  return e(), r;
                },
                reliableMarginLeft: function () {
                  return e(), u;
                },
                scrollboxSize: function () {
                  return e(), o;
                },
                reliableTrDimensions: function () {
                  var e, n, r, i;
                  return (
                    null == s &&
                      ((e = y.createElement("table")),
                      (n = y.createElement("tr")),
                      (r = y.createElement("div")),
                      (e.style.cssText =
                        "position:absolute;left:-11111px;border-collapse:separate"),
                      (n.style.cssText = "border:1px solid"),
                      (n.style.height = "1px"),
                      (r.style.height = "9px"),
                      (r.style.display = "block"),
                      re.appendChild(e).appendChild(n).appendChild(r),
                      (i = t.getComputedStyle(n)),
                      (s =
                        parseInt(i.height, 10) +
                          parseInt(i.borderTopWidth, 10) +
                          parseInt(i.borderBottomWidth, 10) ===
                        n.offsetHeight),
                      re.removeChild(e)),
                    s
                  );
                },
              }));
          })();
          var $e = ["Webkit", "Moz", "ms"],
            _e = y.createElement("div").style,
            ze = {};
          function Ue(e) {
            var t = w.cssProps[e] || ze[e];
            return (
              t ||
              (e in _e
                ? e
                : (ze[e] =
                    (function (e) {
                      for (
                        var t = e[0].toUpperCase() + e.slice(1), n = $e.length;
                        n--;

                      )
                        if ((e = $e[n] + t) in _e) return e;
                    })(e) || e))
            );
          }
          var Xe = /^(none|table(?!-c[ea]).+)/,
            Ve = /^--/,
            Ge = {
              position: "absolute",
              visibility: "hidden",
              display: "block",
            },
            Ye = { letterSpacing: "0", fontWeight: "400" };
          function Qe(e, t, n) {
            var r = te.exec(t);
            return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
          }
          function Je(e, t, n, r, i, o) {
            var a = "width" === t ? 1 : 0,
              s = 0,
              u = 0;
            if (n === (r ? "border" : "content")) return 0;
            for (; a < 4; a += 2)
              "margin" === n && (u += w.css(e, n + ne[a], !0, i)),
                r
                  ? ("content" === n &&
                      (u -= w.css(e, "padding" + ne[a], !0, i)),
                    "margin" !== n &&
                      (u -= w.css(e, "border" + ne[a] + "Width", !0, i)))
                  : ((u += w.css(e, "padding" + ne[a], !0, i)),
                    "padding" !== n
                      ? (u += w.css(e, "border" + ne[a] + "Width", !0, i))
                      : (s += w.css(e, "border" + ne[a] + "Width", !0, i)));
            return (
              !r &&
                o >= 0 &&
                (u +=
                  Math.max(
                    0,
                    Math.ceil(
                      e["offset" + t[0].toUpperCase() + t.slice(1)] -
                        o -
                        u -
                        s -
                        0.5,
                    ),
                  ) || 0),
              u
            );
          }
          function Ke(e, t, n) {
            var r = Me(e),
              i =
                (!h.boxSizingReliable() || n) &&
                "border-box" === w.css(e, "boxSizing", !1, r),
              o = i,
              a = Fe(e, t, r),
              s = "offset" + t[0].toUpperCase() + t.slice(1);
            if (Re.test(a)) {
              if (!n) return a;
              a = "auto";
            }
            return (
              ((!h.boxSizingReliable() && i) ||
                (!h.reliableTrDimensions() && A(e, "tr")) ||
                "auto" === a ||
                (!parseFloat(a) && "inline" === w.css(e, "display", !1, r))) &&
                e.getClientRects().length &&
                ((i = "border-box" === w.css(e, "boxSizing", !1, r)),
                (o = s in e) && (a = e[s])),
              (a = parseFloat(a) || 0) +
                Je(e, t, n || (i ? "border" : "content"), o, r, a) +
                "px"
            );
          }
          function Ze(e, t, n, r, i) {
            return new Ze.prototype.init(e, t, n, r, i);
          }
          w.extend({
            cssHooks: {
              opacity: {
                get: function (e, t) {
                  if (t) {
                    var n = Fe(e, "opacity");
                    return "" === n ? "1" : n;
                  }
                },
              },
            },
            cssNumber: {
              animationIterationCount: !0,
              columnCount: !0,
              fillOpacity: !0,
              flexGrow: !0,
              flexShrink: !0,
              fontWeight: !0,
              gridArea: !0,
              gridColumn: !0,
              gridColumnEnd: !0,
              gridColumnStart: !0,
              gridRow: !0,
              gridRowEnd: !0,
              gridRowStart: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0,
            },
            cssProps: {},
            style: function (e, t, n, r) {
              if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i,
                  o,
                  a,
                  s = X(t),
                  u = Ve.test(t),
                  l = e.style;
                if (
                  (u || (t = Ue(s)),
                  (a = w.cssHooks[t] || w.cssHooks[s]),
                  void 0 === n)
                )
                  return a && "get" in a && void 0 !== (i = a.get(e, !1, r))
                    ? i
                    : l[t];
                "string" === (o = typeof n) &&
                  (i = te.exec(n)) &&
                  i[1] &&
                  ((n = se(e, t, i)), (o = "number")),
                  null != n &&
                    n == n &&
                    ("number" !== o ||
                      u ||
                      (n += (i && i[3]) || (w.cssNumber[s] ? "" : "px")),
                    h.clearCloneStyle ||
                      "" !== n ||
                      0 !== t.indexOf("background") ||
                      (l[t] = "inherit"),
                    (a && "set" in a && void 0 === (n = a.set(e, n, r))) ||
                      (u ? l.setProperty(t, n) : (l[t] = n)));
              }
            },
            css: function (e, t, n, r) {
              var i,
                o,
                a,
                s = X(t);
              return (
                Ve.test(t) || (t = Ue(s)),
                (a = w.cssHooks[t] || w.cssHooks[s]) &&
                  "get" in a &&
                  (i = a.get(e, !0, n)),
                void 0 === i && (i = Fe(e, t, r)),
                "normal" === i && t in Ye && (i = Ye[t]),
                "" === n || n
                  ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i)
                  : i
              );
            },
          }),
            w.each(["height", "width"], function (e, t) {
              w.cssHooks[t] = {
                get: function (e, n, r) {
                  if (n)
                    return !Xe.test(w.css(e, "display")) ||
                      (e.getClientRects().length &&
                        e.getBoundingClientRect().width)
                      ? Ke(e, t, r)
                      : Ie(e, Ge, function () {
                          return Ke(e, t, r);
                        });
                },
                set: function (e, n, r) {
                  var i,
                    o = Me(e),
                    a = !h.scrollboxSize() && "absolute" === o.position,
                    s =
                      (a || r) && "border-box" === w.css(e, "boxSizing", !1, o),
                    u = r ? Je(e, t, r, s, o) : 0;
                  return (
                    s &&
                      a &&
                      (u -= Math.ceil(
                        e["offset" + t[0].toUpperCase() + t.slice(1)] -
                          parseFloat(o[t]) -
                          Je(e, t, "border", !1, o) -
                          0.5,
                      )),
                    u &&
                      (i = te.exec(n)) &&
                      "px" !== (i[3] || "px") &&
                      ((e.style[t] = n), (n = w.css(e, t))),
                    Qe(0, n, u)
                  );
                },
              };
            }),
            (w.cssHooks.marginLeft = Be(h.reliableMarginLeft, function (e, t) {
              if (t)
                return (
                  (parseFloat(Fe(e, "marginLeft")) ||
                    e.getBoundingClientRect().left -
                      Ie(e, { marginLeft: 0 }, function () {
                        return e.getBoundingClientRect().left;
                      })) + "px"
                );
            })),
            w.each(
              { margin: "", padding: "", border: "Width" },
              function (e, t) {
                (w.cssHooks[e + t] = {
                  expand: function (n) {
                    for (
                      var r = 0,
                        i = {},
                        o = "string" == typeof n ? n.split(" ") : [n];
                      r < 4;
                      r++
                    )
                      i[e + ne[r] + t] = o[r] || o[r - 2] || o[0];
                    return i;
                  },
                }),
                  "margin" !== e && (w.cssHooks[e + t].set = Qe);
              },
            ),
            w.fn.extend({
              css: function (e, t) {
                return $(
                  this,
                  function (e, t, n) {
                    var r,
                      i,
                      o = {},
                      a = 0;
                    if (Array.isArray(t)) {
                      for (r = Me(e), i = t.length; a < i; a++)
                        o[t[a]] = w.css(e, t[a], !1, r);
                      return o;
                    }
                    return void 0 !== n ? w.style(e, t, n) : w.css(e, t);
                  },
                  e,
                  t,
                  arguments.length > 1,
                );
              },
            }),
            (w.Tween = Ze),
            (Ze.prototype = {
              constructor: Ze,
              init: function (e, t, n, r, i, o) {
                (this.elem = e),
                  (this.prop = n),
                  (this.easing = i || w.easing._default),
                  (this.options = t),
                  (this.start = this.now = this.cur()),
                  (this.end = r),
                  (this.unit = o || (w.cssNumber[n] ? "" : "px"));
              },
              cur: function () {
                var e = Ze.propHooks[this.prop];
                return e && e.get
                  ? e.get(this)
                  : Ze.propHooks._default.get(this);
              },
              run: function (e) {
                var t,
                  n = Ze.propHooks[this.prop];
                return (
                  this.options.duration
                    ? (this.pos = t =
                        w.easing[this.easing](
                          e,
                          this.options.duration * e,
                          0,
                          1,
                          this.options.duration,
                        ))
                    : (this.pos = t = e),
                  (this.now = (this.end - this.start) * t + this.start),
                  this.options.step &&
                    this.options.step.call(this.elem, this.now, this),
                  n && n.set ? n.set(this) : Ze.propHooks._default.set(this),
                  this
                );
              },
            }),
            (Ze.prototype.init.prototype = Ze.prototype),
            (Ze.propHooks = {
              _default: {
                get: function (e) {
                  var t;
                  return 1 !== e.elem.nodeType ||
                    (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                    ? e.elem[e.prop]
                    : (t = w.css(e.elem, e.prop, "")) && "auto" !== t
                    ? t
                    : 0;
                },
                set: function (e) {
                  w.fx.step[e.prop]
                    ? w.fx.step[e.prop](e)
                    : 1 !== e.elem.nodeType ||
                      (!w.cssHooks[e.prop] && null == e.elem.style[Ue(e.prop)])
                    ? (e.elem[e.prop] = e.now)
                    : w.style(e.elem, e.prop, e.now + e.unit);
                },
              },
            }),
            (Ze.propHooks.scrollTop = Ze.propHooks.scrollLeft =
              {
                set: function (e) {
                  e.elem.nodeType &&
                    e.elem.parentNode &&
                    (e.elem[e.prop] = e.now);
                },
              }),
            (w.easing = {
              linear: function (e) {
                return e;
              },
              swing: function (e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
              },
              _default: "swing",
            }),
            (w.fx = Ze.prototype.init),
            (w.fx.step = {});
          var et,
            tt,
            nt = /^(?:toggle|show|hide)$/,
            rt = /queueHooks$/;
          function it() {
            tt &&
              (!1 === y.hidden && t.requestAnimationFrame
                ? t.requestAnimationFrame(it)
                : t.setTimeout(it, w.fx.interval),
              w.fx.tick());
          }
          function ot() {
            return (
              t.setTimeout(function () {
                et = void 0;
              }),
              (et = Date.now())
            );
          }
          function at(e, t) {
            var n,
              r = 0,
              i = { height: e };
            for (t = t ? 1 : 0; r < 4; r += 2 - t)
              i["margin" + (n = ne[r])] = i["padding" + n] = e;
            return t && (i.opacity = i.width = e), i;
          }
          function st(e, t, n) {
            for (
              var r,
                i = (ut.tweeners[t] || []).concat(ut.tweeners["*"]),
                o = 0,
                a = i.length;
              o < a;
              o++
            )
              if ((r = i[o].call(n, t, e))) return r;
          }
          function ut(e, t, n) {
            var r,
              i,
              o = 0,
              a = ut.prefilters.length,
              s = w.Deferred().always(function () {
                delete u.elem;
              }),
              u = function () {
                if (i) return !1;
                for (
                  var t = et || ot(),
                    n = Math.max(0, l.startTime + l.duration - t),
                    r = 1 - (n / l.duration || 0),
                    o = 0,
                    a = l.tweens.length;
                  o < a;
                  o++
                )
                  l.tweens[o].run(r);
                return (
                  s.notifyWith(e, [l, r, n]),
                  r < 1 && a
                    ? n
                    : (a || s.notifyWith(e, [l, 1, 0]),
                      s.resolveWith(e, [l]),
                      !1)
                );
              },
              l = s.promise({
                elem: e,
                props: w.extend({}, t),
                opts: w.extend(
                  !0,
                  { specialEasing: {}, easing: w.easing._default },
                  n,
                ),
                originalProperties: t,
                originalOptions: n,
                startTime: et || ot(),
                duration: n.duration,
                tweens: [],
                createTween: function (t, n) {
                  var r = w.Tween(
                    e,
                    l.opts,
                    t,
                    n,
                    l.opts.specialEasing[t] || l.opts.easing,
                  );
                  return l.tweens.push(r), r;
                },
                stop: function (t) {
                  var n = 0,
                    r = t ? l.tweens.length : 0;
                  if (i) return this;
                  for (i = !0; n < r; n++) l.tweens[n].run(1);
                  return (
                    t
                      ? (s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l, t]))
                      : s.rejectWith(e, [l, t]),
                    this
                  );
                },
              }),
              c = l.props;
            for (
              !(function (e, t) {
                var n, r, i, o, a;
                for (n in e)
                  if (
                    ((i = t[(r = X(n))]),
                    (o = e[n]),
                    Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
                    n !== r && ((e[r] = o), delete e[n]),
                    (a = w.cssHooks[r]) && ("expand" in a))
                  )
                    for (n in ((o = a.expand(o)), delete e[r], o))
                      (n in e) || ((e[n] = o[n]), (t[n] = i));
                  else t[r] = i;
              })(c, l.opts.specialEasing);
              o < a;
              o++
            )
              if ((r = ut.prefilters[o].call(l, e, c, l.opts)))
                return (
                  g(r.stop) &&
                    (w._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)),
                  r
                );
            return (
              w.map(c, st, l),
              g(l.opts.start) && l.opts.start.call(e, l),
              l
                .progress(l.opts.progress)
                .done(l.opts.done, l.opts.complete)
                .fail(l.opts.fail)
                .always(l.opts.always),
              w.fx.timer(
                w.extend(u, { elem: e, anim: l, queue: l.opts.queue }),
              ),
              l
            );
          }
          (w.Animation = w.extend(ut, {
            tweeners: {
              "*": [
                function (e, t) {
                  var n = this.createTween(e, t);
                  return se(n.elem, e, te.exec(t), n), n;
                },
              ],
            },
            tweener: function (e, t) {
              g(e) ? ((t = e), (e = ["*"])) : (e = e.match(P));
              for (var n, r = 0, i = e.length; r < i; r++)
                (n = e[r]),
                  (ut.tweeners[n] = ut.tweeners[n] || []),
                  ut.tweeners[n].unshift(t);
            },
            prefilters: [
              function (e, t, n) {
                var r,
                  i,
                  o,
                  a,
                  s,
                  u,
                  l,
                  c,
                  f = "width" in t || "height" in t,
                  p = this,
                  d = {},
                  h = e.style,
                  g = e.nodeType && ae(e),
                  v = Y.get(e, "fxshow");
                for (r in (n.queue ||
                  (null == (a = w._queueHooks(e, "fx")).unqueued &&
                    ((a.unqueued = 0),
                    (s = a.empty.fire),
                    (a.empty.fire = function () {
                      a.unqueued || s();
                    })),
                  a.unqueued++,
                  p.always(function () {
                    p.always(function () {
                      a.unqueued--, w.queue(e, "fx").length || a.empty.fire();
                    });
                  })),
                t))
                  if (((i = t[r]), nt.test(i))) {
                    if (
                      (delete t[r],
                      (o = o || "toggle" === i),
                      i === (g ? "hide" : "show"))
                    ) {
                      if ("show" !== i || !v || void 0 === v[r]) continue;
                      g = !0;
                    }
                    d[r] = (v && v[r]) || w.style(e, r);
                  }
                if ((u = !w.isEmptyObject(t)) || !w.isEmptyObject(d))
                  for (r in (f &&
                    1 === e.nodeType &&
                    ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                    null == (l = v && v.display) && (l = Y.get(e, "display")),
                    "none" === (c = w.css(e, "display")) &&
                      (l
                        ? (c = l)
                        : (ce([e], !0),
                          (l = e.style.display || l),
                          (c = w.css(e, "display")),
                          ce([e]))),
                    ("inline" === c || ("inline-block" === c && null != l)) &&
                      "none" === w.css(e, "float") &&
                      (u ||
                        (p.done(function () {
                          h.display = l;
                        }),
                        null == l &&
                          ((c = h.display), (l = "none" === c ? "" : c))),
                      (h.display = "inline-block"))),
                  n.overflow &&
                    ((h.overflow = "hidden"),
                    p.always(function () {
                      (h.overflow = n.overflow[0]),
                        (h.overflowX = n.overflow[1]),
                        (h.overflowY = n.overflow[2]);
                    })),
                  (u = !1),
                  d))
                    u ||
                      (v
                        ? "hidden" in v && (g = v.hidden)
                        : (v = Y.access(e, "fxshow", { display: l })),
                      o && (v.hidden = !g),
                      g && ce([e], !0),
                      p.done(function () {
                        for (r in (g || ce([e]), Y.remove(e, "fxshow"), d))
                          w.style(e, r, d[r]);
                      })),
                      (u = st(g ? v[r] : 0, r, p)),
                      r in v ||
                        ((v[r] = u.start),
                        g && ((u.end = u.start), (u.start = 0)));
              },
            ],
            prefilter: function (e, t) {
              t ? ut.prefilters.unshift(e) : ut.prefilters.push(e);
            },
          })),
            (w.speed = function (e, t, n) {
              var r =
                e && "object" == typeof e
                  ? w.extend({}, e)
                  : {
                      complete: n || (!n && t) || (g(e) && e),
                      duration: e,
                      easing: (n && t) || (t && !g(t) && t),
                    };
              return (
                w.fx.off
                  ? (r.duration = 0)
                  : "number" != typeof r.duration &&
                    (r.duration in w.fx.speeds
                      ? (r.duration = w.fx.speeds[r.duration])
                      : (r.duration = w.fx.speeds._default)),
                (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
                (r.old = r.complete),
                (r.complete = function () {
                  g(r.old) && r.old.call(this),
                    r.queue && w.dequeue(this, r.queue);
                }),
                r
              );
            }),
            w.fn.extend({
              fadeTo: function (e, t, n, r) {
                return this.filter(ae)
                  .css("opacity", 0)
                  .show()
                  .end()
                  .animate({ opacity: t }, e, n, r);
              },
              animate: function (e, t, n, r) {
                var i = w.isEmptyObject(e),
                  o = w.speed(t, n, r),
                  a = function () {
                    var t = ut(this, w.extend({}, e), o);
                    (i || Y.get(this, "finish")) && t.stop(!0);
                  };
                return (
                  (a.finish = a),
                  i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
                );
              },
              stop: function (e, t, n) {
                var r = function (e) {
                  var t = e.stop;
                  delete e.stop, t(n);
                };
                return (
                  "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                  t && this.queue(e || "fx", []),
                  this.each(function () {
                    var t = !0,
                      i = null != e && e + "queueHooks",
                      o = w.timers,
                      a = Y.get(this);
                    if (i) a[i] && a[i].stop && r(a[i]);
                    else
                      for (i in a) a[i] && a[i].stop && rt.test(i) && r(a[i]);
                    for (i = o.length; i--; )
                      o[i].elem !== this ||
                        (null != e && o[i].queue !== e) ||
                        (o[i].anim.stop(n), (t = !1), o.splice(i, 1));
                    (!t && n) || w.dequeue(this, e);
                  })
                );
              },
              finish: function (e) {
                return (
                  !1 !== e && (e = e || "fx"),
                  this.each(function () {
                    var t,
                      n = Y.get(this),
                      r = n[e + "queue"],
                      i = n[e + "queueHooks"],
                      o = w.timers,
                      a = r ? r.length : 0;
                    for (
                      n.finish = !0,
                        w.queue(this, e, []),
                        i && i.stop && i.stop.call(this, !0),
                        t = o.length;
                      t--;

                    )
                      o[t].elem === this &&
                        o[t].queue === e &&
                        (o[t].anim.stop(!0), o.splice(t, 1));
                    for (t = 0; t < a; t++)
                      r[t] && r[t].finish && r[t].finish.call(this);
                    delete n.finish;
                  })
                );
              },
            }),
            w.each(["toggle", "show", "hide"], function (e, t) {
              var n = w.fn[t];
              w.fn[t] = function (e, r, i) {
                return null == e || "boolean" == typeof e
                  ? n.apply(this, arguments)
                  : this.animate(at(t, !0), e, r, i);
              };
            }),
            w.each(
              {
                slideDown: at("show"),
                slideUp: at("hide"),
                slideToggle: at("toggle"),
                fadeIn: { opacity: "show" },
                fadeOut: { opacity: "hide" },
                fadeToggle: { opacity: "toggle" },
              },
              function (e, t) {
                w.fn[e] = function (e, n, r) {
                  return this.animate(t, e, n, r);
                };
              },
            ),
            (w.timers = []),
            (w.fx.tick = function () {
              var e,
                t = 0,
                n = w.timers;
              for (et = Date.now(); t < n.length; t++)
                (e = n[t])() || n[t] !== e || n.splice(t--, 1);
              n.length || w.fx.stop(), (et = void 0);
            }),
            (w.fx.timer = function (e) {
              w.timers.push(e), w.fx.start();
            }),
            (w.fx.interval = 13),
            (w.fx.start = function () {
              tt || ((tt = !0), it());
            }),
            (w.fx.stop = function () {
              tt = null;
            }),
            (w.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (w.fn.delay = function (e, n) {
              return (
                (e = (w.fx && w.fx.speeds[e]) || e),
                (n = n || "fx"),
                this.queue(n, function (n, r) {
                  var i = t.setTimeout(n, e);
                  r.stop = function () {
                    t.clearTimeout(i);
                  };
                })
              );
            }),
            (function () {
              var e = y.createElement("input"),
                t = y
                  .createElement("select")
                  .appendChild(y.createElement("option"));
              (e.type = "checkbox"),
                (h.checkOn = "" !== e.value),
                (h.optSelected = t.selected),
                ((e = y.createElement("input")).value = "t"),
                (e.type = "radio"),
                (h.radioValue = "t" === e.value);
            })();
          var lt,
            ct = w.expr.attrHandle;
          w.fn.extend({
            attr: function (e, t) {
              return $(this, w.attr, e, t, arguments.length > 1);
            },
            removeAttr: function (e) {
              return this.each(function () {
                w.removeAttr(this, e);
              });
            },
          }),
            w.extend({
              attr: function (e, t, n) {
                var r,
                  i,
                  o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                  return void 0 === e.getAttribute
                    ? w.prop(e, t, n)
                    : ((1 === o && w.isXMLDoc(e)) ||
                        (i =
                          w.attrHooks[t.toLowerCase()] ||
                          (w.expr.match.bool.test(t) ? lt : void 0)),
                      void 0 !== n
                        ? null === n
                          ? void w.removeAttr(e, t)
                          : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                          ? r
                          : (e.setAttribute(t, n + ""), n)
                        : i && "get" in i && null !== (r = i.get(e, t))
                        ? r
                        : null == (r = w.find.attr(e, t))
                        ? void 0
                        : r);
              },
              attrHooks: {
                type: {
                  set: function (e, t) {
                    if (!h.radioValue && "radio" === t && A(e, "input")) {
                      var n = e.value;
                      return e.setAttribute("type", t), n && (e.value = n), t;
                    }
                  },
                },
              },
              removeAttr: function (e, t) {
                var n,
                  r = 0,
                  i = t && t.match(P);
                if (i && 1 === e.nodeType)
                  for (; (n = i[r++]); ) e.removeAttribute(n);
              },
            }),
            (lt = {
              set: function (e, t, n) {
                return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n), n;
              },
            }),
            w.each(w.expr.match.bool.source.match(/\w+/g), function (e, t) {
              var n = ct[t] || w.find.attr;
              ct[t] = function (e, t, r) {
                var i,
                  o,
                  a = t.toLowerCase();
                return (
                  r ||
                    ((o = ct[a]),
                    (ct[a] = i),
                    (i = null != n(e, t, r) ? a : null),
                    (ct[a] = o)),
                  i
                );
              };
            });
          var ft = /^(?:input|select|textarea|button)$/i,
            pt = /^(?:a|area)$/i;
          function dt(e) {
            return (e.match(P) || []).join(" ");
          }
          function ht(e) {
            return (e.getAttribute && e.getAttribute("class")) || "";
          }
          function gt(e) {
            return Array.isArray(e)
              ? e
              : ("string" == typeof e && e.match(P)) || [];
          }
          w.fn.extend({
            prop: function (e, t) {
              return $(this, w.prop, e, t, arguments.length > 1);
            },
            removeProp: function (e) {
              return this.each(function () {
                delete this[w.propFix[e] || e];
              });
            },
          }),
            w.extend({
              prop: function (e, t, n) {
                var r,
                  i,
                  o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                  return (
                    (1 === o && w.isXMLDoc(e)) ||
                      ((t = w.propFix[t] || t), (i = w.propHooks[t])),
                    void 0 !== n
                      ? i && "set" in i && void 0 !== (r = i.set(e, n, t))
                        ? r
                        : (e[t] = n)
                      : i && "get" in i && null !== (r = i.get(e, t))
                      ? r
                      : e[t]
                  );
              },
              propHooks: {
                tabIndex: {
                  get: function (e) {
                    var t = w.find.attr(e, "tabindex");
                    return t
                      ? parseInt(t, 10)
                      : ft.test(e.nodeName) || (pt.test(e.nodeName) && e.href)
                      ? 0
                      : -1;
                  },
                },
              },
              propFix: { for: "htmlFor", class: "className" },
            }),
            h.optSelected ||
              (w.propHooks.selected = {
                get: function (e) {
                  var t = e.parentNode;
                  return t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function (e) {
                  var t = e.parentNode;
                  t &&
                    (t.selectedIndex,
                    t.parentNode && t.parentNode.selectedIndex);
                },
              }),
            w.each(
              [
                "tabIndex",
                "readOnly",
                "maxLength",
                "cellSpacing",
                "cellPadding",
                "rowSpan",
                "colSpan",
                "useMap",
                "frameBorder",
                "contentEditable",
              ],
              function () {
                w.propFix[this.toLowerCase()] = this;
              },
            ),
            w.fn.extend({
              addClass: function (e) {
                var t,
                  n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  u = 0;
                if (g(e))
                  return this.each(function (t) {
                    w(this).addClass(e.call(this, t, ht(this)));
                  });
                if ((t = gt(e)).length)
                  for (; (n = this[u++]); )
                    if (
                      ((i = ht(n)), (r = 1 === n.nodeType && " " + dt(i) + " "))
                    ) {
                      for (a = 0; (o = t[a++]); )
                        r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                      i !== (s = dt(r)) && n.setAttribute("class", s);
                    }
                return this;
              },
              removeClass: function (e) {
                var t,
                  n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  u = 0;
                if (g(e))
                  return this.each(function (t) {
                    w(this).removeClass(e.call(this, t, ht(this)));
                  });
                if (!arguments.length) return this.attr("class", "");
                if ((t = gt(e)).length)
                  for (; (n = this[u++]); )
                    if (
                      ((i = ht(n)), (r = 1 === n.nodeType && " " + dt(i) + " "))
                    ) {
                      for (a = 0; (o = t[a++]); )
                        for (; r.indexOf(" " + o + " ") > -1; )
                          r = r.replace(" " + o + " ", " ");
                      i !== (s = dt(r)) && n.setAttribute("class", s);
                    }
                return this;
              },
              toggleClass: function (e, t) {
                var n = typeof e,
                  r = "string" === n || Array.isArray(e);
                return "boolean" == typeof t && r
                  ? t
                    ? this.addClass(e)
                    : this.removeClass(e)
                  : g(e)
                  ? this.each(function (n) {
                      w(this).toggleClass(e.call(this, n, ht(this), t), t);
                    })
                  : this.each(function () {
                      var t, i, o, a;
                      if (r)
                        for (i = 0, o = w(this), a = gt(e); (t = a[i++]); )
                          o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                      else
                        (void 0 !== e && "boolean" !== n) ||
                          ((t = ht(this)) && Y.set(this, "__className__", t),
                          this.setAttribute &&
                            this.setAttribute(
                              "class",
                              t || !1 === e
                                ? ""
                                : Y.get(this, "__className__") || "",
                            ));
                    });
              },
              hasClass: function (e) {
                var t,
                  n,
                  r = 0;
                for (t = " " + e + " "; (n = this[r++]); )
                  if (
                    1 === n.nodeType &&
                    (" " + dt(ht(n)) + " ").indexOf(t) > -1
                  )
                    return !0;
                return !1;
              },
            });
          var vt = /\r/g;
          w.fn.extend({
            val: function (e) {
              var t,
                n,
                r,
                i = this[0];
              return arguments.length
                ? ((r = g(e)),
                  this.each(function (n) {
                    var i;
                    1 === this.nodeType &&
                      (null == (i = r ? e.call(this, n, w(this).val()) : e)
                        ? (i = "")
                        : "number" == typeof i
                        ? (i += "")
                        : Array.isArray(i) &&
                          (i = w.map(i, function (e) {
                            return null == e ? "" : e + "";
                          })),
                      ((t =
                        w.valHooks[this.type] ||
                        w.valHooks[this.nodeName.toLowerCase()]) &&
                        "set" in t &&
                        void 0 !== t.set(this, i, "value")) ||
                        (this.value = i));
                  }))
                : i
                ? (t =
                    w.valHooks[i.type] ||
                    w.valHooks[i.nodeName.toLowerCase()]) &&
                  "get" in t &&
                  void 0 !== (n = t.get(i, "value"))
                  ? n
                  : "string" == typeof (n = i.value)
                  ? n.replace(vt, "")
                  : null == n
                  ? ""
                  : n
                : void 0;
            },
          }),
            w.extend({
              valHooks: {
                option: {
                  get: function (e) {
                    var t = w.find.attr(e, "value");
                    return null != t ? t : dt(w.text(e));
                  },
                },
                select: {
                  get: function (e) {
                    var t,
                      n,
                      r,
                      i = e.options,
                      o = e.selectedIndex,
                      a = "select-one" === e.type,
                      s = a ? null : [],
                      u = a ? o + 1 : i.length;
                    for (r = o < 0 ? u : a ? o : 0; r < u; r++)
                      if (
                        ((n = i[r]).selected || r === o) &&
                        !n.disabled &&
                        (!n.parentNode.disabled || !A(n.parentNode, "optgroup"))
                      ) {
                        if (((t = w(n).val()), a)) return t;
                        s.push(t);
                      }
                    return s;
                  },
                  set: function (e, t) {
                    for (
                      var n, r, i = e.options, o = w.makeArray(t), a = i.length;
                      a--;

                    )
                      ((r = i[a]).selected =
                        w.inArray(w.valHooks.option.get(r), o) > -1) &&
                        (n = !0);
                    return n || (e.selectedIndex = -1), o;
                  },
                },
              },
            }),
            w.each(["radio", "checkbox"], function () {
              (w.valHooks[this] = {
                set: function (e, t) {
                  if (Array.isArray(t))
                    return (e.checked = w.inArray(w(e).val(), t) > -1);
                },
              }),
                h.checkOn ||
                  (w.valHooks[this].get = function (e) {
                    return null === e.getAttribute("value") ? "on" : e.value;
                  });
            }),
            (h.focusin = "onfocusin" in t);
          var yt = /^(?:focusinfocus|focusoutblur)$/,
            mt = function (e) {
              e.stopPropagation();
            };
          w.extend(w.event, {
            trigger: function (e, n, r, i) {
              var o,
                a,
                s,
                u,
                l,
                c,
                p,
                d,
                h = [r || y],
                m = f.call(e, "type") ? e.type : e,
                x = f.call(e, "namespace") ? e.namespace.split(".") : [];
              if (
                ((a = d = s = r = r || y),
                3 !== r.nodeType &&
                  8 !== r.nodeType &&
                  !yt.test(m + w.event.triggered) &&
                  (m.indexOf(".") > -1 &&
                    ((x = m.split(".")), (m = x.shift()), x.sort()),
                  (l = m.indexOf(":") < 0 && "on" + m),
                  ((e = e[w.expando]
                    ? e
                    : new w.Event(m, "object" == typeof e && e)).isTrigger = i
                    ? 2
                    : 3),
                  (e.namespace = x.join(".")),
                  (e.rnamespace = e.namespace
                    ? new RegExp(
                        "(^|\\.)" + x.join("\\.(?:.*\\.|)") + "(\\.|$)",
                      )
                    : null),
                  (e.result = void 0),
                  e.target || (e.target = r),
                  (n = null == n ? [e] : w.makeArray(n, [e])),
                  (p = w.event.special[m] || {}),
                  i || !p.trigger || !1 !== p.trigger.apply(r, n)))
              ) {
                if (!i && !p.noBubble && !v(r)) {
                  for (
                    u = p.delegateType || m,
                      yt.test(u + m) || (a = a.parentNode);
                    a;
                    a = a.parentNode
                  )
                    h.push(a), (s = a);
                  s === (r.ownerDocument || y) &&
                    h.push(s.defaultView || s.parentWindow || t);
                }
                for (o = 0; (a = h[o++]) && !e.isPropagationStopped(); )
                  (d = a),
                    (e.type = o > 1 ? u : p.bindType || m),
                    (c =
                      (Y.get(a, "events") || Object.create(null))[e.type] &&
                      Y.get(a, "handle")) && c.apply(a, n),
                    (c = l && a[l]) &&
                      c.apply &&
                      V(a) &&
                      ((e.result = c.apply(a, n)),
                      !1 === e.result && e.preventDefault());
                return (
                  (e.type = m),
                  i ||
                    e.isDefaultPrevented() ||
                    (p._default && !1 !== p._default.apply(h.pop(), n)) ||
                    !V(r) ||
                    (l &&
                      g(r[m]) &&
                      !v(r) &&
                      ((s = r[l]) && (r[l] = null),
                      (w.event.triggered = m),
                      e.isPropagationStopped() && d.addEventListener(m, mt),
                      r[m](),
                      e.isPropagationStopped() && d.removeEventListener(m, mt),
                      (w.event.triggered = void 0),
                      s && (r[l] = s))),
                  e.result
                );
              }
            },
            simulate: function (e, t, n) {
              var r = w.extend(new w.Event(), n, { type: e, isSimulated: !0 });
              w.event.trigger(r, null, t);
            },
          }),
            w.fn.extend({
              trigger: function (e, t) {
                return this.each(function () {
                  w.event.trigger(e, t, this);
                });
              },
              triggerHandler: function (e, t) {
                var n = this[0];
                if (n) return w.event.trigger(e, t, n, !0);
              },
            }),
            h.focusin ||
              w.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                var n = function (e) {
                  w.event.simulate(t, e.target, w.event.fix(e));
                };
                w.event.special[t] = {
                  setup: function () {
                    var r = this.ownerDocument || this.document || this,
                      i = Y.access(r, t);
                    i || r.addEventListener(e, n, !0),
                      Y.access(r, t, (i || 0) + 1);
                  },
                  teardown: function () {
                    var r = this.ownerDocument || this.document || this,
                      i = Y.access(r, t) - 1;
                    i
                      ? Y.access(r, t, i)
                      : (r.removeEventListener(e, n, !0), Y.remove(r, t));
                  },
                };
              });
          var xt = t.location,
            bt = { guid: Date.now() },
            wt = /\?/;
          w.parseXML = function (e) {
            var n, r;
            if (!e || "string" != typeof e) return null;
            try {
              n = new t.DOMParser().parseFromString(e, "text/xml");
            } catch (i) {}
            return (
              (r = n && n.getElementsByTagName("parsererror")[0]),
              (n && !r) ||
                w.error(
                  "Invalid XML: " +
                    (r
                      ? w
                          .map(r.childNodes, function (e) {
                            return e.textContent;
                          })
                          .join("\n")
                      : e),
                ),
              n
            );
          };
          var Tt = /\[\]$/,
            Ct = /\r?\n/g,
            Et = /^(?:submit|button|image|reset|file)$/i,
            St = /^(?:input|select|textarea|keygen)/i;
          function kt(e, t, n, r) {
            var i;
            if (Array.isArray(t))
              w.each(t, function (t, i) {
                n || Tt.test(e)
                  ? r(e, i)
                  : kt(
                      e +
                        "[" +
                        ("object" == typeof i && null != i ? t : "") +
                        "]",
                      i,
                      n,
                      r,
                    );
              });
            else if (n || "object" !== b(t)) r(e, t);
            else for (i in t) kt(e + "[" + i + "]", t[i], n, r);
          }
          (w.param = function (e, t) {
            var n,
              r = [],
              i = function (e, t) {
                var n = g(t) ? t() : t;
                r[r.length] =
                  encodeURIComponent(e) +
                  "=" +
                  encodeURIComponent(null == n ? "" : n);
              };
            if (null == e) return "";
            if (Array.isArray(e) || (e.jquery && !w.isPlainObject(e)))
              w.each(e, function () {
                i(this.name, this.value);
              });
            else for (n in e) kt(n, e[n], t, i);
            return r.join("&");
          }),
            w.fn.extend({
              serialize: function () {
                return w.param(this.serializeArray());
              },
              serializeArray: function () {
                return this.map(function () {
                  var e = w.prop(this, "elements");
                  return e ? w.makeArray(e) : this;
                })
                  .filter(function () {
                    var e = this.type;
                    return (
                      this.name &&
                      !w(this).is(":disabled") &&
                      St.test(this.nodeName) &&
                      !Et.test(e) &&
                      (this.checked || !de.test(e))
                    );
                  })
                  .map(function (e, t) {
                    var n = w(this).val();
                    return null == n
                      ? null
                      : Array.isArray(n)
                      ? w.map(n, function (e) {
                          return { name: t.name, value: e.replace(Ct, "\r\n") };
                        })
                      : { name: t.name, value: n.replace(Ct, "\r\n") };
                  })
                  .get();
              },
            });
          var At = /%20/g,
            Nt = /#.*$/,
            jt = /([?&])_=[^&]*/,
            Dt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            qt = /^(?:GET|HEAD)$/,
            Lt = /^\/\//,
            Ht = {},
            Ot = {},
            Pt = "*/".concat("*"),
            Rt = y.createElement("a");
          function Mt(e) {
            return function (t, n) {
              "string" != typeof t && ((n = t), (t = "*"));
              var r,
                i = 0,
                o = t.toLowerCase().match(P) || [];
              if (g(n))
                for (; (r = o[i++]); )
                  "+" === r[0]
                    ? ((r = r.slice(1) || "*"), (e[r] = e[r] || []).unshift(n))
                    : (e[r] = e[r] || []).push(n);
            };
          }
          function It(e, t, n, r) {
            var i = {},
              o = e === Ot;
            function a(s) {
              var u;
              return (
                (i[s] = !0),
                w.each(e[s] || [], function (e, s) {
                  var l = s(t, n, r);
                  return "string" != typeof l || o || i[l]
                    ? o
                      ? !(u = l)
                      : void 0
                    : (t.dataTypes.unshift(l), a(l), !1);
                }),
                u
              );
            }
            return a(t.dataTypes[0]) || (!i["*"] && a("*"));
          }
          function Wt(e, t) {
            var n,
              r,
              i = w.ajaxSettings.flatOptions || {};
            for (n in t)
              void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
            return r && w.extend(!0, e, r), e;
          }
          (Rt.href = xt.href),
            w.extend({
              active: 0,
              lastModified: {},
              etag: {},
              ajaxSettings: {
                url: xt.href,
                type: "GET",
                isLocal:
                  /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
                    xt.protocol,
                  ),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                  "*": Pt,
                  text: "text/plain",
                  html: "text/html",
                  xml: "application/xml, text/xml",
                  json: "application/json, text/javascript",
                },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: {
                  xml: "responseXML",
                  text: "responseText",
                  json: "responseJSON",
                },
                converters: {
                  "* text": String,
                  "text html": !0,
                  "text json": JSON.parse,
                  "text xml": w.parseXML,
                },
                flatOptions: { url: !0, context: !0 },
              },
              ajaxSetup: function (e, t) {
                return t ? Wt(Wt(e, w.ajaxSettings), t) : Wt(w.ajaxSettings, e);
              },
              ajaxPrefilter: Mt(Ht),
              ajaxTransport: Mt(Ot),
              ajax: function (e, n) {
                "object" == typeof e && ((n = e), (e = void 0)), (n = n || {});
                var r,
                  i,
                  o,
                  a,
                  s,
                  u,
                  l,
                  c,
                  f,
                  p,
                  d = w.ajaxSetup({}, n),
                  h = d.context || d,
                  g = d.context && (h.nodeType || h.jquery) ? w(h) : w.event,
                  v = w.Deferred(),
                  m = w.Callbacks("once memory"),
                  x = d.statusCode || {},
                  b = {},
                  T = {},
                  C = "canceled",
                  E = {
                    readyState: 0,
                    getResponseHeader: function (e) {
                      var t;
                      if (l) {
                        if (!a)
                          for (a = {}; (t = Dt.exec(o)); )
                            a[t[1].toLowerCase() + " "] = (
                              a[t[1].toLowerCase() + " "] || []
                            ).concat(t[2]);
                        t = a[e.toLowerCase() + " "];
                      }
                      return null == t ? null : t.join(", ");
                    },
                    getAllResponseHeaders: function () {
                      return l ? o : null;
                    },
                    setRequestHeader: function (e, t) {
                      return (
                        null == l &&
                          ((e = T[e.toLowerCase()] = T[e.toLowerCase()] || e),
                          (b[e] = t)),
                        this
                      );
                    },
                    overrideMimeType: function (e) {
                      return null == l && (d.mimeType = e), this;
                    },
                    statusCode: function (e) {
                      var t;
                      if (e)
                        if (l) E.always(e[E.status]);
                        else for (t in e) x[t] = [x[t], e[t]];
                      return this;
                    },
                    abort: function (e) {
                      var t = e || C;
                      return r && r.abort(t), S(0, t), this;
                    },
                  };
                if (
                  (v.promise(E),
                  (d.url = ((e || d.url || xt.href) + "").replace(
                    Lt,
                    xt.protocol + "//",
                  )),
                  (d.type = n.method || n.type || d.method || d.type),
                  (d.dataTypes = (d.dataType || "*").toLowerCase().match(P) || [
                    "",
                  ]),
                  null == d.crossDomain)
                ) {
                  u = y.createElement("a");
                  try {
                    (u.href = d.url),
                      (u.href = u.href),
                      (d.crossDomain =
                        Rt.protocol + "//" + Rt.host !=
                        u.protocol + "//" + u.host);
                  } catch (k) {
                    d.crossDomain = !0;
                  }
                }
                if (
                  (d.data &&
                    d.processData &&
                    "string" != typeof d.data &&
                    (d.data = w.param(d.data, d.traditional)),
                  It(Ht, d, n, E),
                  l)
                )
                  return E;
                for (f in ((c = w.event && d.global) &&
                  0 == w.active++ &&
                  w.event.trigger("ajaxStart"),
                (d.type = d.type.toUpperCase()),
                (d.hasContent = !qt.test(d.type)),
                (i = d.url.replace(Nt, "")),
                d.hasContent
                  ? d.data &&
                    d.processData &&
                    0 ===
                      (d.contentType || "").indexOf(
                        "application/x-www-form-urlencoded",
                      ) &&
                    (d.data = d.data.replace(At, "+"))
                  : ((p = d.url.slice(i.length)),
                    d.data &&
                      (d.processData || "string" == typeof d.data) &&
                      ((i += (wt.test(i) ? "&" : "?") + d.data), delete d.data),
                    !1 === d.cache &&
                      ((i = i.replace(jt, "$1")),
                      (p = (wt.test(i) ? "&" : "?") + "_=" + bt.guid++ + p)),
                    (d.url = i + p)),
                d.ifModified &&
                  (w.lastModified[i] &&
                    E.setRequestHeader("If-Modified-Since", w.lastModified[i]),
                  w.etag[i] && E.setRequestHeader("If-None-Match", w.etag[i])),
                ((d.data && d.hasContent && !1 !== d.contentType) ||
                  n.contentType) &&
                  E.setRequestHeader("Content-Type", d.contentType),
                E.setRequestHeader(
                  "Accept",
                  d.dataTypes[0] && d.accepts[d.dataTypes[0]]
                    ? d.accepts[d.dataTypes[0]] +
                        ("*" !== d.dataTypes[0] ? ", " + Pt + "; q=0.01" : "")
                    : d.accepts["*"],
                ),
                d.headers))
                  E.setRequestHeader(f, d.headers[f]);
                if (d.beforeSend && (!1 === d.beforeSend.call(h, E, d) || l))
                  return E.abort();
                if (
                  ((C = "abort"),
                  m.add(d.complete),
                  E.done(d.success),
                  E.fail(d.error),
                  (r = It(Ot, d, n, E)))
                ) {
                  if (
                    ((E.readyState = 1), c && g.trigger("ajaxSend", [E, d]), l)
                  )
                    return E;
                  d.async &&
                    d.timeout > 0 &&
                    (s = t.setTimeout(function () {
                      E.abort("timeout");
                    }, d.timeout));
                  try {
                    (l = !1), r.send(b, S);
                  } catch (k) {
                    if (l) throw k;
                    S(-1, k);
                  }
                } else S(-1, "No Transport");
                function S(e, n, a, u) {
                  var f,
                    p,
                    y,
                    b,
                    T,
                    C = n;
                  l ||
                    ((l = !0),
                    s && t.clearTimeout(s),
                    (r = void 0),
                    (o = u || ""),
                    (E.readyState = e > 0 ? 4 : 0),
                    (f = (e >= 200 && e < 300) || 304 === e),
                    a &&
                      (b = (function (e, t, n) {
                        for (
                          var r, i, o, a, s = e.contents, u = e.dataTypes;
                          "*" === u[0];

                        )
                          u.shift(),
                            void 0 === r &&
                              (r =
                                e.mimeType ||
                                t.getResponseHeader("Content-Type"));
                        if (r)
                          for (i in s)
                            if (s[i] && s[i].test(r)) {
                              u.unshift(i);
                              break;
                            }
                        if (u[0] in n) o = u[0];
                        else {
                          for (i in n) {
                            if (!u[0] || e.converters[i + " " + u[0]]) {
                              o = i;
                              break;
                            }
                            a || (a = i);
                          }
                          o = o || a;
                        }
                        if (o) return o !== u[0] && u.unshift(o), n[o];
                      })(d, E, a)),
                    !f &&
                      w.inArray("script", d.dataTypes) > -1 &&
                      w.inArray("json", d.dataTypes) < 0 &&
                      (d.converters["text script"] = function () {}),
                    (b = (function (e, t, n, r) {
                      var i,
                        o,
                        a,
                        s,
                        u,
                        l = {},
                        c = e.dataTypes.slice();
                      if (c[1])
                        for (a in e.converters)
                          l[a.toLowerCase()] = e.converters[a];
                      for (o = c.shift(); o; )
                        if (
                          (e.responseFields[o] && (n[e.responseFields[o]] = t),
                          !u &&
                            r &&
                            e.dataFilter &&
                            (t = e.dataFilter(t, e.dataType)),
                          (u = o),
                          (o = c.shift()))
                        )
                          if ("*" === o) o = u;
                          else if ("*" !== u && u !== o) {
                            if (!(a = l[u + " " + o] || l["* " + o]))
                              for (i in l)
                                if (
                                  (s = i.split(" "))[1] === o &&
                                  (a = l[u + " " + s[0]] || l["* " + s[0]])
                                ) {
                                  !0 === a
                                    ? (a = l[i])
                                    : !0 !== l[i] &&
                                      ((o = s[0]), c.unshift(s[1]));
                                  break;
                                }
                            if (!0 !== a)
                              if (a && e.throws) t = a(t);
                              else
                                try {
                                  t = a(t);
                                } catch (k) {
                                  return {
                                    state: "parsererror",
                                    error: a
                                      ? k
                                      : "No conversion from " + u + " to " + o,
                                  };
                                }
                          }
                      return { state: "success", data: t };
                    })(d, b, E, f)),
                    f
                      ? (d.ifModified &&
                          ((T = E.getResponseHeader("Last-Modified")) &&
                            (w.lastModified[i] = T),
                          (T = E.getResponseHeader("etag")) && (w.etag[i] = T)),
                        204 === e || "HEAD" === d.type
                          ? (C = "nocontent")
                          : 304 === e
                          ? (C = "notmodified")
                          : ((C = b.state), (p = b.data), (f = !(y = b.error))))
                      : ((y = C),
                        (!e && C) || ((C = "error"), e < 0 && (e = 0))),
                    (E.status = e),
                    (E.statusText = (n || C) + ""),
                    f
                      ? v.resolveWith(h, [p, C, E])
                      : v.rejectWith(h, [E, C, y]),
                    E.statusCode(x),
                    (x = void 0),
                    c &&
                      g.trigger(f ? "ajaxSuccess" : "ajaxError", [
                        E,
                        d,
                        f ? p : y,
                      ]),
                    m.fireWith(h, [E, C]),
                    c &&
                      (g.trigger("ajaxComplete", [E, d]),
                      --w.active || w.event.trigger("ajaxStop")));
                }
                return E;
              },
              getJSON: function (e, t, n) {
                return w.get(e, t, n, "json");
              },
              getScript: function (e, t) {
                return w.get(e, void 0, t, "script");
              },
            }),
            w.each(["get", "post"], function (e, t) {
              w[t] = function (e, n, r, i) {
                return (
                  g(n) && ((i = i || r), (r = n), (n = void 0)),
                  w.ajax(
                    w.extend(
                      { url: e, type: t, dataType: i, data: n, success: r },
                      w.isPlainObject(e) && e,
                    ),
                  )
                );
              };
            }),
            w.ajaxPrefilter(function (e) {
              var t;
              for (t in e.headers)
                "content-type" === t.toLowerCase() &&
                  (e.contentType = e.headers[t] || "");
            }),
            (w._evalUrl = function (e, t, n) {
              return w.ajax({
                url: e,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function () {} },
                dataFilter: function (e) {
                  w.globalEval(e, t, n);
                },
              });
            }),
            w.fn.extend({
              wrapAll: function (e) {
                var t;
                return (
                  this[0] &&
                    (g(e) && (e = e.call(this[0])),
                    (t = w(e, this[0].ownerDocument).eq(0).clone(!0)),
                    this[0].parentNode && t.insertBefore(this[0]),
                    t
                      .map(function () {
                        for (var e = this; e.firstElementChild; )
                          e = e.firstElementChild;
                        return e;
                      })
                      .append(this)),
                  this
                );
              },
              wrapInner: function (e) {
                return g(e)
                  ? this.each(function (t) {
                      w(this).wrapInner(e.call(this, t));
                    })
                  : this.each(function () {
                      var t = w(this),
                        n = t.contents();
                      n.length ? n.wrapAll(e) : t.append(e);
                    });
              },
              wrap: function (e) {
                var t = g(e);
                return this.each(function (n) {
                  w(this).wrapAll(t ? e.call(this, n) : e);
                });
              },
              unwrap: function (e) {
                return (
                  this.parent(e)
                    .not("body")
                    .each(function () {
                      w(this).replaceWith(this.childNodes);
                    }),
                  this
                );
              },
            }),
            (w.expr.pseudos.hidden = function (e) {
              return !w.expr.pseudos.visible(e);
            }),
            (w.expr.pseudos.visible = function (e) {
              return !!(
                e.offsetWidth ||
                e.offsetHeight ||
                e.getClientRects().length
              );
            }),
            (w.ajaxSettings.xhr = function () {
              try {
                return new t.XMLHttpRequest();
              } catch (e) {}
            });
          var Ft = { 0: 200, 1223: 204 },
            Bt = w.ajaxSettings.xhr();
          (h.cors = !!Bt && "withCredentials" in Bt),
            (h.ajax = Bt = !!Bt),
            w.ajaxTransport(function (e) {
              var n, r;
              if (h.cors || (Bt && !e.crossDomain))
                return {
                  send: function (i, o) {
                    var a,
                      s = e.xhr();
                    if (
                      (s.open(e.type, e.url, e.async, e.username, e.password),
                      e.xhrFields)
                    )
                      for (a in e.xhrFields) s[a] = e.xhrFields[a];
                    for (a in (e.mimeType &&
                      s.overrideMimeType &&
                      s.overrideMimeType(e.mimeType),
                    e.crossDomain ||
                      i["X-Requested-With"] ||
                      (i["X-Requested-With"] = "XMLHttpRequest"),
                    i))
                      s.setRequestHeader(a, i[a]);
                    (n = function (e) {
                      return function () {
                        n &&
                          ((n =
                            r =
                            s.onload =
                            s.onerror =
                            s.onabort =
                            s.ontimeout =
                            s.onreadystatechange =
                              null),
                          "abort" === e
                            ? s.abort()
                            : "error" === e
                            ? "number" != typeof s.status
                              ? o(0, "error")
                              : o(s.status, s.statusText)
                            : o(
                                Ft[s.status] || s.status,
                                s.statusText,
                                "text" !== (s.responseType || "text") ||
                                  "string" != typeof s.responseText
                                  ? { binary: s.response }
                                  : { text: s.responseText },
                                s.getAllResponseHeaders(),
                              ));
                      };
                    }),
                      (s.onload = n()),
                      (r = s.onerror = s.ontimeout = n("error")),
                      void 0 !== s.onabort
                        ? (s.onabort = r)
                        : (s.onreadystatechange = function () {
                            4 === s.readyState &&
                              t.setTimeout(function () {
                                n && r();
                              });
                          }),
                      (n = n("abort"));
                    try {
                      s.send((e.hasContent && e.data) || null);
                    } catch (u) {
                      if (n) throw u;
                    }
                  },
                  abort: function () {
                    n && n();
                  },
                };
            }),
            w.ajaxPrefilter(function (e) {
              e.crossDomain && (e.contents.script = !1);
            }),
            w.ajaxSetup({
              accepts: {
                script:
                  "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
              },
              contents: { script: /\b(?:java|ecma)script\b/ },
              converters: {
                "text script": function (e) {
                  return w.globalEval(e), e;
                },
              },
            }),
            w.ajaxPrefilter("script", function (e) {
              void 0 === e.cache && (e.cache = !1),
                e.crossDomain && (e.type = "GET");
            }),
            w.ajaxTransport("script", function (e) {
              var t, n;
              if (e.crossDomain || e.scriptAttrs)
                return {
                  send: function (r, i) {
                    (t = w("<script>")
                      .attr(e.scriptAttrs || {})
                      .prop({ charset: e.scriptCharset, src: e.url })
                      .on(
                        "load error",
                        (n = function (e) {
                          t.remove(),
                            (n = null),
                            e && i("error" === e.type ? 404 : 200, e.type);
                        }),
                      )),
                      y.head.appendChild(t[0]);
                  },
                  abort: function () {
                    n && n();
                  },
                };
            });
          var $t,
            _t = [],
            zt = /(=)\?(?=&|$)|\?\?/;
          w.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
              var e = _t.pop() || w.expando + "_" + bt.guid++;
              return (this[e] = !0), e;
            },
          }),
            w.ajaxPrefilter("json jsonp", function (e, n, r) {
              var i,
                o,
                a,
                s =
                  !1 !== e.jsonp &&
                  (zt.test(e.url)
                    ? "url"
                    : "string" == typeof e.data &&
                      0 ===
                        (e.contentType || "").indexOf(
                          "application/x-www-form-urlencoded",
                        ) &&
                      zt.test(e.data) &&
                      "data");
              if (s || "jsonp" === e.dataTypes[0])
                return (
                  (i = e.jsonpCallback =
                    g(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                  s
                    ? (e[s] = e[s].replace(zt, "$1" + i))
                    : !1 !== e.jsonp &&
                      (e.url +=
                        (wt.test(e.url) ? "&" : "?") + e.jsonp + "=" + i),
                  (e.converters["script json"] = function () {
                    return a || w.error(i + " was not called"), a[0];
                  }),
                  (e.dataTypes[0] = "json"),
                  (o = t[i]),
                  (t[i] = function () {
                    a = arguments;
                  }),
                  r.always(function () {
                    void 0 === o ? w(t).removeProp(i) : (t[i] = o),
                      e[i] && ((e.jsonpCallback = n.jsonpCallback), _t.push(i)),
                      a && g(o) && o(a[0]),
                      (a = o = void 0);
                  }),
                  "script"
                );
            }),
            (h.createHTMLDocument =
              ((($t = y.implementation.createHTMLDocument("").body).innerHTML =
                "<form></form><form></form>"),
              2 === $t.childNodes.length)),
            (w.parseHTML = function (e, t, n) {
              return "string" != typeof e
                ? []
                : ("boolean" == typeof t && ((n = t), (t = !1)),
                  t ||
                    (h.createHTMLDocument
                      ? (((r = (t =
                          y.implementation.createHTMLDocument(
                            "",
                          )).createElement("base")).href = y.location.href),
                        t.head.appendChild(r))
                      : (t = y)),
                  (o = !n && []),
                  (i = N.exec(e))
                    ? [t.createElement(i[1])]
                    : ((i = be([e], t, o)),
                      o && o.length && w(o).remove(),
                      w.merge([], i.childNodes)));
              var r, i, o;
            }),
            (w.fn.load = function (e, t, n) {
              var r,
                i,
                o,
                a = this,
                s = e.indexOf(" ");
              return (
                s > -1 && ((r = dt(e.slice(s))), (e = e.slice(0, s))),
                g(t)
                  ? ((n = t), (t = void 0))
                  : t && "object" == typeof t && (i = "POST"),
                a.length > 0 &&
                  w
                    .ajax({
                      url: e,
                      type: i || "GET",
                      dataType: "html",
                      data: t,
                    })
                    .done(function (e) {
                      (o = arguments),
                        a.html(
                          r ? w("<div>").append(w.parseHTML(e)).find(r) : e,
                        );
                    })
                    .always(
                      n &&
                        function (e, t) {
                          a.each(function () {
                            n.apply(this, o || [e.responseText, t, e]);
                          });
                        },
                    ),
                this
              );
            }),
            (w.expr.pseudos.animated = function (e) {
              return w.grep(w.timers, function (t) {
                return e === t.elem;
              }).length;
            }),
            (w.offset = {
              setOffset: function (e, t, n) {
                var r,
                  i,
                  o,
                  a,
                  s,
                  u,
                  l = w.css(e, "position"),
                  c = w(e),
                  f = {};
                "static" === l && (e.style.position = "relative"),
                  (s = c.offset()),
                  (o = w.css(e, "top")),
                  (u = w.css(e, "left")),
                  ("absolute" === l || "fixed" === l) &&
                  (o + u).indexOf("auto") > -1
                    ? ((a = (r = c.position()).top), (i = r.left))
                    : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
                  g(t) && (t = t.call(e, n, w.extend({}, s))),
                  null != t.top && (f.top = t.top - s.top + a),
                  null != t.left && (f.left = t.left - s.left + i),
                  "using" in t ? t.using.call(e, f) : c.css(f);
              },
            }),
            w.fn.extend({
              offset: function (e) {
                if (arguments.length)
                  return void 0 === e
                    ? this
                    : this.each(function (t) {
                        w.offset.setOffset(this, e, t);
                      });
                var t,
                  n,
                  r = this[0];
                return r
                  ? r.getClientRects().length
                    ? ((t = r.getBoundingClientRect()),
                      (n = r.ownerDocument.defaultView),
                      {
                        top: t.top + n.pageYOffset,
                        left: t.left + n.pageXOffset,
                      })
                    : { top: 0, left: 0 }
                  : void 0;
              },
              position: function () {
                if (this[0]) {
                  var e,
                    t,
                    n,
                    r = this[0],
                    i = { top: 0, left: 0 };
                  if ("fixed" === w.css(r, "position"))
                    t = r.getBoundingClientRect();
                  else {
                    for (
                      t = this.offset(),
                        n = r.ownerDocument,
                        e = r.offsetParent || n.documentElement;
                      e &&
                      (e === n.body || e === n.documentElement) &&
                      "static" === w.css(e, "position");

                    )
                      e = e.parentNode;
                    e &&
                      e !== r &&
                      1 === e.nodeType &&
                      (((i = w(e).offset()).top += w.css(
                        e,
                        "borderTopWidth",
                        !0,
                      )),
                      (i.left += w.css(e, "borderLeftWidth", !0)));
                  }
                  return {
                    top: t.top - i.top - w.css(r, "marginTop", !0),
                    left: t.left - i.left - w.css(r, "marginLeft", !0),
                  };
                }
              },
              offsetParent: function () {
                return this.map(function () {
                  for (
                    var e = this.offsetParent;
                    e && "static" === w.css(e, "position");

                  )
                    e = e.offsetParent;
                  return e || re;
                });
              },
            }),
            w.each(
              { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
              function (e, t) {
                var n = "pageYOffset" === t;
                w.fn[e] = function (r) {
                  return $(
                    this,
                    function (e, r, i) {
                      var o;
                      if (
                        (v(e)
                          ? (o = e)
                          : 9 === e.nodeType && (o = e.defaultView),
                        void 0 === i)
                      )
                        return o ? o[t] : e[r];
                      o
                        ? o.scrollTo(
                            n ? o.pageXOffset : i,
                            n ? i : o.pageYOffset,
                          )
                        : (e[r] = i);
                    },
                    e,
                    r,
                    arguments.length,
                  );
                };
              },
            ),
            w.each(["top", "left"], function (e, t) {
              w.cssHooks[t] = Be(h.pixelPosition, function (e, n) {
                if (n)
                  return (
                    (n = Fe(e, t)), Re.test(n) ? w(e).position()[t] + "px" : n
                  );
              });
            }),
            w.each({ Height: "height", Width: "width" }, function (e, t) {
              w.each(
                { padding: "inner" + e, content: t, "": "outer" + e },
                function (n, r) {
                  w.fn[r] = function (i, o) {
                    var a = arguments.length && (n || "boolean" != typeof i),
                      s = n || (!0 === i || !0 === o ? "margin" : "border");
                    return $(
                      this,
                      function (t, n, i) {
                        var o;
                        return v(t)
                          ? 0 === r.indexOf("outer")
                            ? t["inner" + e]
                            : t.document.documentElement["client" + e]
                          : 9 === t.nodeType
                          ? ((o = t.documentElement),
                            Math.max(
                              t.body["scroll" + e],
                              o["scroll" + e],
                              t.body["offset" + e],
                              o["offset" + e],
                              o["client" + e],
                            ))
                          : void 0 === i
                          ? w.css(t, n, s)
                          : w.style(t, n, i, s);
                      },
                      t,
                      a ? i : void 0,
                      a,
                    );
                  };
                },
              );
            }),
            w.each(
              [
                "ajaxStart",
                "ajaxStop",
                "ajaxComplete",
                "ajaxError",
                "ajaxSuccess",
                "ajaxSend",
              ],
              function (e, t) {
                w.fn[t] = function (e) {
                  return this.on(t, e);
                };
              },
            ),
            w.fn.extend({
              bind: function (e, t, n) {
                return this.on(e, null, t, n);
              },
              unbind: function (e, t) {
                return this.off(e, null, t);
              },
              delegate: function (e, t, n, r) {
                return this.on(t, e, n, r);
              },
              undelegate: function (e, t, n) {
                return 1 === arguments.length
                  ? this.off(e, "**")
                  : this.off(t, e || "**", n);
              },
              hover: function (e, t) {
                return this.mouseenter(e).mouseleave(t || e);
              },
            }),
            w.each(
              "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
                " ",
              ),
              function (e, t) {
                w.fn[t] = function (e, n) {
                  return arguments.length > 0
                    ? this.on(t, null, e, n)
                    : this.trigger(t);
                };
              },
            );
          var Ut = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
          (w.proxy = function (e, t) {
            var n, r, i;
            if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), g(e)))
              return (
                (r = o.call(arguments, 2)),
                ((i = function () {
                  return e.apply(t || this, r.concat(o.call(arguments)));
                }).guid = e.guid =
                  e.guid || w.guid++),
                i
              );
          }),
            (w.holdReady = function (e) {
              e ? w.readyWait++ : w.ready(!0);
            }),
            (w.isArray = Array.isArray),
            (w.parseJSON = JSON.parse),
            (w.nodeName = A),
            (w.isFunction = g),
            (w.isWindow = v),
            (w.camelCase = X),
            (w.type = b),
            (w.now = Date.now),
            (w.isNumeric = function (e) {
              var t = w.type(e);
              return (
                ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
              );
            }),
            (w.trim = function (e) {
              return null == e ? "" : (e + "").replace(Ut, "");
            }),
            "function" == typeof e &&
              e.amd &&
              e("jquery", [], function () {
                return w;
              });
          var Xt = t.jQuery,
            Vt = t.$;
          return (
            (w.noConflict = function (e) {
              return (
                t.$ === w && (t.$ = Vt),
                e && t.jQuery === w && (t.jQuery = Xt),
                w
              );
            }),
            void 0 === n && (t.jQuery = t.$ = w),
            w
          );
        });
      },
      { process: "../node_modules/process/browser.js" },
    ],
    "modules/header.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = void 0);
        var e = t(require("jquery"));
        function t(e) {
          return e && e.__esModule ? e : { default: e };
        }
        var a = function () {
            var t,
              a,
              s = (0, e.default)("[data-site-header]"),
              o = function () {
                (t = (0, e.default)("[data-top-bar]").outerHeight()),
                  (a =
                    s.hasClass("m-transparent") &&
                    (0, e.default)(window).width() > 989
                      ? t
                      : s.outerHeight()),
                  (0, e.default)("body").css("paddingTop", a + "px"),
                  (0, e.default)(".sections-wrapper").css(
                    "margin-top",
                    a + "px",
                  );
              };
            o(),
              (0, e.default)(window).resize(o),
              (0, e.default)(document).scroll(function (o) {
                (0, e.default)("body").hasClass("is-menu-open")
                  ? o.preventDefault()
                  : (0, e.default)(this).scrollTop() > a
                  ? s
                      .css("transform", "translate(0, -".concat(t, "px)"))
                      .addClass("is-scrolled")
                  : s
                      .css("transform", "translate(0, 0)")
                      .removeClass("is-scrolled");
              }),
              setTimeout(function () {
                o();
              }, 100);
          },
          s = function () {
            (0, e.default)("[data-open-menu]").click(function (t) {
              t.preventDefault(),
                (0, e.default)("body").toggleClass("is-menu-open");
            });
          },
          o = function () {
            a(), s();
          },
          n = o;
        exports.default = n;
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "vendor/cart.min.js": [
      function (require, module, exports) {
        var define;
        var t,
          e = r(require("jquery"));
        function r(t) {
          return t && t.__esModule ? t : { default: t };
        }
        function n(t) {
          return (n =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                  return typeof t;
                }
              : function (t) {
                  return t &&
                    "function" == typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : typeof t;
                })(t);
        }
        (function () {
          var r,
            a,
            i,
            u,
            o,
            s,
            l = function (t, e) {
              return function () {
                return t.apply(e, arguments);
              };
            },
            c =
              [].indexOf ||
              function (t) {
                for (var e = 0, r = this.length; r > e; e++)
                  if (e in this && this[e] === t) return e;
                return -1;
              };
          (a = (function () {
            function t() {
              this.update = l(this.update, this);
            }
            return (
              (t.prototype.update = function (t) {
                var e, r, n;
                for (r in t) (n = t[r]), "items" !== r && (this[r] = n);
                return (this.items = (function () {
                  var r, n, a, i;
                  for (i = [], r = 0, n = (a = t.items).length; n > r; r++)
                    (e = a[r]), i.push(new u(e));
                  return i;
                })());
              }),
              t
            );
          })()),
            (u = (function () {
              function t(t) {
                (this.propertyArray = l(this.propertyArray, this)),
                  (this.update = l(this.update, this)),
                  this.update(t);
              }
              return (
                (t.prototype.update = function (t) {
                  var e, r;
                  for (e in t) (r = t[e]), "properties" !== e && (this[e] = r);
                  return (this.properties = i.Utils.extend({}, t.properties));
                }),
                (t.prototype.propertyArray = function () {
                  var t, e, r, n;
                  for (t in ((n = []), (r = this.properties)))
                    (e = r[t]), n.push({ name: t, value: e });
                  return n;
                }),
                t
              );
            })()),
            ((i = {
              settings: {
                debug: !1,
                dataAPI: !0,
                requestBodyClass: null,
                rivetsModels: {},
                currency: null,
                moneyFormat: null,
                moneyWithCurrencyFormat: null,
                weightUnit: "g",
                weightPrecision: 0,
              },
              cart: new a(),
            }).init = function (t, r) {
              return (
                null == r && (r = {}),
                i.configure(r),
                i.Utils.log("Initialising CartJS."),
                i.cart.update(t),
                i.settings.dataAPI &&
                  (i.Utils.log(
                    '"dataAPI" setting is true, initialising Data API.',
                  ),
                  i.Data.init()),
                i.settings.requestBodyClass &&
                  (i.Utils.log(
                    '"requestBodyClass" set, adding event listeners.',
                  ),
                  (0, e.default)(document).on(
                    "cart.requestStarted",
                    function () {
                      return (0, e.default)("body").addClass(
                        i.settings.requestBodyClass,
                      );
                    },
                  ),
                  (0, e.default)(document).on(
                    "cart.requestComplete",
                    function () {
                      return (0, e.default)("body").removeClass(
                        i.settings.requestBodyClass,
                      );
                    },
                  )),
                i.Rivets.init(),
                (0, e.default)(document).trigger("cart.ready", [i.cart])
              );
            }),
            (i.configure = function (t) {
              return null == t && (t = {}), i.Utils.extend(i.settings, t);
            }),
            null == window.console &&
              ((window.console = {}), (window.console.log = function () {})),
            (i.Utils = {
              log: function () {
                return i.Utils.console(console.log, arguments);
              },
              warn: function () {
                return i.Utils.console(console.warn, arguments);
              },
              error: function () {
                return i.Utils.console(console.error, arguments);
              },
              console: (function (t) {
                function e(e, r) {
                  return t.apply(this, arguments);
                }
                return (
                  (e.toString = function () {
                    return t.toString();
                  }),
                  e
                );
              })(function (t, e) {
                return i.settings.debug &&
                  "undefined" != typeof console &&
                  null !== console
                  ? ((e = Array.prototype.slice.call(e)).unshift("[CartJS]:"),
                    t.apply(console, e))
                  : void 0;
              }),
              wrapKeys: function (t, e, r, n) {
                var a, i, u;
                for (a in (null == e && (e = "properties"),
                null == n && (n = []),
                (u = {}),
                t))
                  (i = t[a]),
                    (u[c.call(n, a) >= 0 ? a : e + "[" + a + "]"] =
                      null != r ? r : i);
                return u;
              },
              unwrapKeys: function (t, e, r) {
                var n, a, i;
                for (n in (null == e && (e = "properties"), (a = {}), t))
                  (i = t[n]),
                    (a[n.replace(e + "[", "").replace("]", "")] =
                      null != r ? r : i);
                return a;
              },
              extend: function (t, e) {
                var r, n;
                for (r in e) (n = e[r]), (t[r] = n);
                return t;
              },
              clone: (function (t) {
                function e(e) {
                  return t.apply(this, arguments);
                }
                return (
                  (e.toString = function () {
                    return t.toString();
                  }),
                  e
                );
              })(function (t) {
                var e, r;
                if (null == t || "object" != n(t)) return t;
                for (e in ((r = new t.constructor()), t)) r[e] = clone(t[e]);
                return r;
              }),
              delete: function (t, e) {
                var r;
                return (r = t[e]), delete t[e], r;
              },
              isArray:
                Array.isArray ||
                function (t) {
                  return "[object Array]" === {}.toString.call(t);
                },
              ensureArray: function (t) {
                return i.Utils.isArray(t) ? t : null != t ? [t] : [];
              },
              formatMoney: function (t, e, r, n) {
                var a, u;
                return (
                  null == n && (n = ""),
                  n || (n = i.settings.currency),
                  null != window.Currency &&
                    n !== i.settings.currency &&
                    ((t = Currency.convert(t, i.settings.currency, n)),
                    null !=
                      (null != (a = window.Currency)
                        ? a.moneyFormats
                        : void 0) &&
                      n in window.Currency.moneyFormats &&
                      (e = window.Currency.moneyFormats[n][r])),
                  null !=
                  (null != (u = window.Shopify) ? u.formatMoney : void 0)
                    ? Shopify.formatMoney(t, e)
                    : (i.Utils.warn(
                        'A money formatting filter was used, but Shopify.formatMoney is not available. See the note "Dependency when formatting monetary values" on this page: https://cartjs.org/pages/guide#getting-started-setup.',
                      ),
                      t)
                );
              },
              getSizedImageUrl: function (t, e) {
                var r, n;
                return null !=
                  (null != (r = window.Shopify) && null != (n = r.Image)
                    ? n.getSizedImageUrl
                    : void 0)
                  ? t
                    ? Shopify.Image.getSizedImageUrl(t, e)
                    : Shopify.Image.getSizedImageUrl(
                        "https://cdn.shopify.com/s/images/admin/no-image-.gif",
                        e,
                      ).replace("-_", "-")
                  : t ||
                      "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
              },
            }),
            (s = []),
            (o = !1),
            (i.Queue = {
              add: function (t, r, n) {
                var a;
                return (
                  null == n && (n = {}),
                  (a = {
                    url: t,
                    data: r,
                    type: n.type || "POST",
                    dataType: n.dataType || "json",
                    cache: !!n.cache,
                    success: i.Utils.ensureArray(n.success),
                    error: i.Utils.ensureArray(n.error),
                    complete: i.Utils.ensureArray(n.complete),
                  }),
                  n.updateCart && a.success.push(i.cart.update),
                  s.push(a),
                  o
                    ? void 0
                    : ((0, e.default)(document).trigger("cart.requestStarted", [
                        i.cart,
                      ]),
                      i.Queue.process())
                );
              },
              process: function () {
                var t;
                return s.length
                  ? ((o = !0),
                    ((t = s.shift()).complete = i.Queue.process),
                    e.default.ajax(t))
                  : ((o = !1),
                    void (0, e.default)(document).trigger(
                      "cart.requestComplete",
                      [i.cart],
                    ));
              },
            }),
            (i.Core = {
              getCart: function (t) {
                return (
                  null == t && (t = {}),
                  (t.type = "GET"),
                  (t.updateCart = !0),
                  i.Queue.add("/cart.js", { v: new Date().getTime() }, t)
                );
              },
              addItem: function (t, e, r, n) {
                var a;
                return (
                  null == e && (e = 1),
                  null == r && (r = {}),
                  null == n && (n = {}),
                  ((a = i.Utils.wrapKeys(r, null, null, ["selling_plan"])).id =
                    t),
                  (a.quantity = e),
                  i.Queue.add("/cart/add.js", a, n),
                  i.Core.getCart()
                );
              },
              addItems: function (t, e) {
                var r;
                return (
                  null == e && (e = {}),
                  (r = { items: t }),
                  i.Queue.add("/cart/add.js", r, e),
                  i.Core.getCart()
                );
              },
              updateItem: function (t, e, r, n) {
                var a;
                return (
                  null == r && (r = {}),
                  null == n && (n = {}),
                  ((a = i.Utils.wrapKeys(r, null, null, [
                    "selling_plan",
                  ])).line = t),
                  null != e && (a.quantity = e),
                  (n.updateCart = !0),
                  i.Queue.add("/cart/change.js", a, n)
                );
              },
              removeItem: function (t, e) {
                return null == e && (e = {}), i.Core.updateItem(t, 0, {}, e);
              },
              updateItemById: function (t, e, r, n) {
                var a;
                return (
                  null == r && (r = {}),
                  null == n && (n = {}),
                  ((a = i.Utils.wrapKeys(r, null, null, ["selling_plan"])).id =
                    t),
                  null != e && (a.quantity = e),
                  (n.updateCart = !0),
                  i.Queue.add("/cart/change.js", a, n)
                );
              },
              updateItemQuantitiesById: function (t, e) {
                return (
                  null == t && (t = {}),
                  null == e && (e = {}),
                  (e.updateCart = !0),
                  i.Queue.add("/cart/update.js", { updates: t }, e)
                );
              },
              removeItemById: function (t, e) {
                var r;
                return (
                  null == e && (e = {}),
                  (r = { id: t, quantity: 0 }),
                  (e.updateCart = !0),
                  i.Queue.add("/cart/change.js", r, e)
                );
              },
              clear: function (t) {
                return (
                  null == t && (t = {}),
                  (t.updateCart = !0),
                  i.Queue.add("/cart/clear.js", {}, t)
                );
              },
              getAttribute: function (t, e) {
                return t in i.cart.attributes ? i.cart.attributes[t] : e;
              },
              setAttribute: function (t, e, r) {
                var n;
                return (
                  null == r && (r = {}),
                  ((n = {})[t] = e),
                  i.Core.setAttributes(n, r)
                );
              },
              getAttributes: function () {
                return i.cart.attributes;
              },
              setAttributes: function (t, e) {
                return (
                  null == t && (t = {}),
                  null == e && (e = {}),
                  (e.updateCart = !0),
                  i.Queue.add(
                    "/cart/update.js",
                    i.Utils.wrapKeys(t, "attributes"),
                    e,
                  )
                );
              },
              clearAttributes: function (t) {
                return (
                  null == t && (t = {}),
                  (t.updateCart = !0),
                  i.Queue.add(
                    "/cart/update.js",
                    i.Utils.wrapKeys(i.Core.getAttributes(), "attributes", ""),
                    t,
                  )
                );
              },
              getNote: function () {
                return i.cart.note;
              },
              setNote: function (t, e) {
                return (
                  null == e && (e = {}),
                  (e.updateCart = !0),
                  i.Queue.add("/cart/update.js", { note: t }, e)
                );
              },
            }),
            (r = null),
            (i.Data = {
              init: function () {
                return (
                  (r = (0, e.default)(document)),
                  i.Data.setEventListeners("on"),
                  i.Data.render(null, i.cart)
                );
              },
              destroy: function () {
                return i.Data.setEventListeners("off");
              },
              setEventListeners: function (t) {
                return (
                  r[t]("click", "[data-cart-add]", i.Data.add),
                  r[t]("click", "[data-cart-remove]", i.Data.remove),
                  r[t]("click", "[data-cart-remove-id]", i.Data.removeById),
                  r[t]("click", "[data-cart-update]", i.Data.update),
                  r[t]("click", "[data-cart-update-id]", i.Data.updateById),
                  r[t]("click", "[data-cart-clear]", i.Data.clear),
                  r[t]("change", "[data-cart-toggle]", i.Data.toggle),
                  r[t](
                    "change",
                    "[data-cart-toggle-attribute]",
                    i.Data.toggleAttribute,
                  ),
                  r[t]("submit", "[data-cart-submit]", i.Data.submit),
                  r[t]("cart.requestComplete", i.Data.render)
                );
              },
              add: function (t) {
                var r, n;
                return (
                  t.preventDefault(),
                  (r = (0, e.default)(this)),
                  ((n = {}).selling_plan = r.attr("data-cart-selling-plan")),
                  i.Core.addItem(
                    r.attr("data-cart-add"),
                    r.attr("data-cart-quantity"),
                    n,
                  )
                );
              },
              remove: function (t) {
                var r;
                return (
                  t.preventDefault(),
                  (r = (0, e.default)(this)),
                  i.Core.removeItem(r.attr("data-cart-remove"))
                );
              },
              removeById: function (t) {
                var r;
                return (
                  t.preventDefault(),
                  (r = (0, e.default)(this)),
                  i.Core.removeItemById(r.attr("data-cart-remove-id"))
                );
              },
              update: function (t) {
                var r, n;
                return (
                  t.preventDefault(),
                  (r = (0, e.default)(this)),
                  ((n = {}).selling_plan = r.attr("data-cart-selling-plan")),
                  i.Core.updateItem(
                    r.attr("data-cart-update"),
                    r.attr("data-cart-quantity"),
                    n,
                  )
                );
              },
              updateById: function (t) {
                var r, n;
                return (
                  t.preventDefault(),
                  (r = (0, e.default)(this)),
                  ((n = {}).selling_plan = r.attr("data-cart-selling-plan")),
                  i.Core.updateItemById(
                    r.attr("data-cart-update-id"),
                    r.attr("data-cart-quantity"),
                    n,
                  )
                );
              },
              clear: function (t) {
                return t.preventDefault(), i.Core.clear();
              },
              toggle: function () {
                var t, r;
                return (
                  (r = (t = (0, e.default)(this)).attr("data-cart-toggle")),
                  t.is(":checked")
                    ? i.Core.addItem(r)
                    : i.Core.removeItemById(r)
                );
              },
              toggleAttribute: function () {
                var t, r;
                return (
                  (r = (t = (0, e.default)(this)).attr(
                    "data-cart-toggle-attribute",
                  )),
                  i.Core.setAttribute(r, t.is(":checked") ? "Yes" : "")
                );
              },
              submit: function (t) {
                var r, n, a, u;
                return (
                  t.preventDefault(),
                  (r = (0, e.default)(this).serializeArray()),
                  (n = void 0),
                  (u = void 0),
                  (a = {}),
                  e.default.each(r, function (t, e) {
                    return "id" === e.name
                      ? (n = e.value)
                      : "quantity" === e.name
                      ? (u = e.value)
                      : "selling_plan" === e.name
                      ? (a.selling_plan = e.value)
                      : e.name.match(/^properties\[[\w-_ ]*\]$/)
                      ? (a[e.name] = e.value)
                      : void 0;
                  }),
                  i.Core.addItem(n, u, i.Utils.unwrapKeys(a))
                );
              },
              render: function (t, r) {
                var n;
                return (
                  (n = {
                    item_count: r.item_count,
                    total_price: r.total_price,
                    total_price_money: i.Utils.formatMoney(
                      r.total_price,
                      i.settings.moneyFormat,
                      "money_format",
                      null !=
                        ("undefined" != typeof Currency && null !== Currency
                          ? Currency.currentCurrency
                          : void 0)
                        ? Currency.currentCurrency
                        : void 0,
                    ),
                    total_price_money_with_currency: i.Utils.formatMoney(
                      r.total_price,
                      i.settings.moneyWithCurrencyFormat,
                      "money_with_currency_format",
                      null !=
                        ("undefined" != typeof Currency && null !== Currency
                          ? Currency.currentCurrency
                          : void 0)
                        ? Currency.currentCurrency
                        : void 0,
                    ),
                  }),
                  (0, e.default)("[data-cart-render]").each(function () {
                    var t;
                    return (t = (0, e.default)(this)).html(
                      n[t.attr("data-cart-render")],
                    );
                  })
                );
              },
            }),
            "undefined" != typeof rivets && null !== rivets
              ? ((i.Rivets = {
                  model: null,
                  boundViews: [],
                  init: function () {
                    return i.Rivets.bindViews();
                  },
                  destroy: function () {
                    return i.Rivets.unbindViews();
                  },
                  bindViews: function () {
                    return (
                      i.Utils.log("Rivets.js is present, binding views."),
                      i.Rivets.unbindViews(),
                      (i.Rivets.model = i.Utils.extend(
                        { cart: i.cart },
                        i.settings.rivetsModels,
                      )),
                      null != window.Currency &&
                        (i.Rivets.model.Currency = window.Currency),
                      (0, e.default)("[data-cart-view]").each(function () {
                        var t;
                        return (
                          (t = rivets.bind(
                            (0, e.default)(this),
                            i.Rivets.model,
                          )),
                          i.Rivets.boundViews.push(t)
                        );
                      })
                    );
                  },
                  unbindViews: function () {
                    var t, e, r;
                    for (
                      t = 0, e = (r = i.Rivets.boundViews).length;
                      e > t;
                      t++
                    )
                      r[t].unbind();
                    return (i.Rivets.boundViews = []);
                  },
                }),
                (rivets.formatters.eq = function (t, e) {
                  return t === e;
                }),
                (rivets.formatters.includes = function (t, e) {
                  return t.indexOf(e) >= 0;
                }),
                (rivets.formatters.match = function (t, e, r) {
                  return t.match(new RegExp(e, r));
                }),
                (rivets.formatters.lt = function (t, e) {
                  return e > t;
                }),
                (rivets.formatters.gt = function (t, e) {
                  return t > e;
                }),
                (rivets.formatters.not = function (t) {
                  return !t;
                }),
                (rivets.formatters.empty = function (t) {
                  return !t.length;
                }),
                (rivets.formatters.plus = function (t, e) {
                  return parseInt(t) + parseInt(e);
                }),
                (rivets.formatters.minus = function (t, e) {
                  return parseInt(t) - parseInt(e);
                }),
                (rivets.formatters.times = function (t, e) {
                  return t * e;
                }),
                (rivets.formatters.divided_by = function (t, e) {
                  return t / e;
                }),
                (rivets.formatters.modulo = function (t, e) {
                  return t % e;
                }),
                (rivets.formatters.prepend = function (t, e) {
                  return e + t;
                }),
                (rivets.formatters.append = function (t, e) {
                  return t + e;
                }),
                (rivets.formatters.slice = function (t, e, r) {
                  return t.slice(e, r);
                }),
                (rivets.formatters.pluralize = function (t, e, r) {
                  return (
                    null == r && (r = e + "s"),
                    i.Utils.isArray(t) && (t = t.length),
                    1 === t ? e : r
                  );
                }),
                (rivets.formatters.array_element = function (t, e) {
                  return t[e];
                }),
                (rivets.formatters.array_first = function (t) {
                  return t[0];
                }),
                (rivets.formatters.array_last = function (t) {
                  return t[t.length - 1];
                }),
                (rivets.formatters.money = function (t, e) {
                  return i.Utils.formatMoney(
                    t,
                    i.settings.moneyFormat,
                    "money_format",
                    e,
                  );
                }),
                (rivets.formatters.money_with_currency = function (t, e) {
                  return i.Utils.formatMoney(
                    t,
                    i.settings.moneyWithCurrencyFormat,
                    "money_with_currency_format",
                    e,
                  );
                }),
                (rivets.formatters.weight = function (t) {
                  switch (i.settings.weightUnit) {
                    case "kg":
                      return (t / 1e3).toFixed(i.settings.weightPrecision);
                    case "oz":
                      return (0.035274 * t).toFixed(i.settings.weightPrecision);
                    case "lb":
                      return (0.00220462 * t).toFixed(
                        i.settings.weightPrecision,
                      );
                    default:
                      return t.toFixed(i.settings.weightPrecision);
                  }
                }),
                (rivets.formatters.weight_with_unit = function (t) {
                  return rivets.formatters.weight(t) + i.settings.weightUnit;
                }),
                (rivets.formatters.product_image_size = function (t, e) {
                  return i.Utils.getSizedImageUrl(t, e);
                }),
                (rivets.formatters.moneyWithCurrency =
                  rivets.formatters.money_with_currency),
                (rivets.formatters.weightWithUnit =
                  rivets.formatters.weight_with_unit),
                (rivets.formatters.productImageSize =
                  rivets.formatters.product_image_size))
              : (i.Rivets = { init: function () {}, destroy: function () {} }),
            (i.factory = function (t) {
              return (
                (t.init = i.init),
                (t.configure = i.configure),
                (t.cart = i.cart),
                (t.settings = i.settings),
                (t.getCart = i.Core.getCart),
                (t.addItem = i.Core.addItem),
                (t.addItems = i.Core.addItems),
                (t.updateItem = i.Core.updateItem),
                (t.updateItemById = i.Core.updateItemById),
                (t.updateItemQuantitiesById = i.Core.updateItemQuantitiesById),
                (t.removeItem = i.Core.removeItem),
                (t.removeItemById = i.Core.removeItemById),
                (t.clear = i.Core.clear),
                (t.getAttribute = i.Core.getAttribute),
                (t.setAttribute = i.Core.setAttribute),
                (t.getAttributes = i.Core.getAttributes),
                (t.setAttributes = i.Core.setAttributes),
                (t.clearAttributes = i.Core.clearAttributes),
                (t.getNote = i.Core.getNote),
                (t.setNote = i.Core.setNote),
                (t.render = i.Data.render)
              );
            }),
            "object" ==
            ("undefined" == typeof exports ? "undefined" : n(exports))
              ? i.factory(exports)
              : "function" == typeof t && t.amd
              ? t(["exports"], function (t) {
                  return i.factory((this.CartJS = t)), t;
                })
              : i.factory((this.CartJS = {}));
        }.call(void 0));
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "modules/qty-selector.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = void 0);
        var e = r(require("jquery")),
          t = r(require("../vendor/cart.min.js"));
        function r(e) {
          return e && e.__esModule ? e : { default: e };
        }
        function a(e, t) {
          return o(e) || c(e, t) || n();
        }
        function n() {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance",
          );
        }
        function c(e, t) {
          if (
            Symbol.iterator in Object(e) ||
            "[object Arguments]" === Object.prototype.toString.call(e)
          ) {
            var r = [],
              a = !0,
              n = !1,
              c = void 0;
            try {
              for (
                var o, l = e[Symbol.iterator]();
                !(a = (o = l.next()).done) &&
                (r.push(o.value), !t || r.length !== t);
                a = !0
              );
            } catch (u) {
              (n = !0), (c = u);
            } finally {
              try {
                a || null == l.return || l.return();
              } finally {
                if (n) throw c;
              }
            }
            return r;
          }
        }
        function o(e) {
          if (Array.isArray(e)) return e;
        }
        var l = function () {
            (0, e.default)(document).on(
              "click",
              "[data-qty-btn]",
              function (t) {
                t.preventDefault();
                var r = a((0, e.default)(this).data("qty-btn").split(", "), 2),
                  n = r[0],
                  c = r[1];
                u(n, c, t), console.log("Click event - check");
              },
            );
          },
          u = function (r, a, n) {
            console.log("Current element is " + a + " - check");
            var c = n.currentTarget.dataset.id,
              o = document.querySelector("#qty-id-" + c),
              l = parseFloat((0, e.default)("#qty-id-" + c).data("cart-qty")),
              u = parseFloat((0, e.default)("#qty-id-" + c).data("max")),
              i = document.querySelector("#qty-id-error-" + c),
              d = document.querySelectorAll("[data-qty-error]");
            if (1 == o.value && "decr" == r) return !1;
            if (
              ("cart" != a && (u -= l), u <= parseFloat(o.value) && "decr" != r)
            )
              return !1;
            if ("cart" == a) {
              console.log('Element parameter as "cart" - check');
              var s = o.dataset.line,
                f = n.currentTarget,
                v = 1 * o.value;
              switch (
                ((f.disabled = !0),
                d.forEach(function (e) {
                  e.classList.add("hide"), (e.innerHTML = "");
                }),
                r)
              ) {
                case "incr":
                  console.log("Incr el - check"),
                    v++,
                    t.default.updateItem(
                      s,
                      v,
                      {},
                      {
                        success: function (e, t, r) {
                          (o.value = v), (f.disabled = !1);
                        },
                        error: function (e, t, r) {
                          console.error("cart add error:", e, t, r),
                            i.classList.remove("hide"),
                            (i.innerHTML =
                              "Sorry, we only have " + v + " in stock"),
                            (f.disabled = !1);
                        },
                      },
                    );
                  break;
                case "decr":
                  v--,
                    t.default.updateItem(
                      s,
                      v,
                      {},
                      {
                        success: function (e, t, r) {
                          (o.value = v), (f.disabled = !1);
                        },
                        error: function (e, t, r) {
                          console.error("cart update error:", e, t, r),
                            (f.disabled = !1);
                        },
                      },
                    );
              }
            }
            if ("product" == a) {
              switch (r) {
                case "incr":
                  o.value++;
                  break;
                case "decr":
                  o.value--;
              }
              (0, e.default)("[name='quantity']").val(o.value);
            }
            (0, e.default)(o).trigger("change");
          },
          i = l;
        exports.default = i;
      },
      {
        jquery: "../node_modules/jquery/dist/jquery.js",
        "../vendor/cart.min.js": "vendor/cart.min.js",
      },
    ],
    "../node_modules/slick-carousel/slick/slick.js": [
      function (require, module, exports) {
        var define;
        var i;
        !(function (e) {
          "use strict";
          "function" == typeof i && i.amd
            ? i(["jquery"], e)
            : "undefined" != typeof exports
            ? (module.exports = e(require("jquery")))
            : e(jQuery);
        })(function (i) {
          "use strict";
          var e = window.Slick || {};
          ((e = (function () {
            var e = 0;
            return function (t, o) {
              var s,
                n = this;
              (n.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: i(t),
                appendDots: i(t),
                arrows: !0,
                asNavFor: null,
                prevArrow:
                  '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow:
                  '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function (e, t) {
                  return i('<button type="button" />').text(t + 1);
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: 0.35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3,
              }),
                (n.initials = {
                  animating: !1,
                  dragging: !1,
                  autoPlayTimer: null,
                  currentDirection: 0,
                  currentLeft: null,
                  currentSlide: 0,
                  direction: 1,
                  $dots: null,
                  listWidth: null,
                  listHeight: null,
                  loadIndex: 0,
                  $nextArrow: null,
                  $prevArrow: null,
                  scrolling: !1,
                  slideCount: null,
                  slideWidth: null,
                  $slideTrack: null,
                  $slides: null,
                  sliding: !1,
                  slideOffset: 0,
                  swipeLeft: null,
                  swiping: !1,
                  $list: null,
                  touchObject: {},
                  transformsEnabled: !1,
                  unslicked: !1,
                }),
                i.extend(n, n.initials),
                (n.activeBreakpoint = null),
                (n.animType = null),
                (n.animProp = null),
                (n.breakpoints = []),
                (n.breakpointSettings = []),
                (n.cssTransitions = !1),
                (n.focussed = !1),
                (n.interrupted = !1),
                (n.hidden = "hidden"),
                (n.paused = !0),
                (n.positionProp = null),
                (n.respondTo = null),
                (n.rowCount = 1),
                (n.shouldClick = !0),
                (n.$slider = i(t)),
                (n.$slidesCache = null),
                (n.transformType = null),
                (n.transitionType = null),
                (n.visibilityChange = "visibilitychange"),
                (n.windowWidth = 0),
                (n.windowTimer = null),
                (s = i(t).data("slick") || {}),
                (n.options = i.extend({}, n.defaults, o, s)),
                (n.currentSlide = n.options.initialSlide),
                (n.originalSettings = n.options),
                void 0 !== document.mozHidden
                  ? ((n.hidden = "mozHidden"),
                    (n.visibilityChange = "mozvisibilitychange"))
                  : void 0 !== document.webkitHidden &&
                    ((n.hidden = "webkitHidden"),
                    (n.visibilityChange = "webkitvisibilitychange")),
                (n.autoPlay = i.proxy(n.autoPlay, n)),
                (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
                (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
                (n.changeSlide = i.proxy(n.changeSlide, n)),
                (n.clickHandler = i.proxy(n.clickHandler, n)),
                (n.selectHandler = i.proxy(n.selectHandler, n)),
                (n.setPosition = i.proxy(n.setPosition, n)),
                (n.swipeHandler = i.proxy(n.swipeHandler, n)),
                (n.dragHandler = i.proxy(n.dragHandler, n)),
                (n.keyHandler = i.proxy(n.keyHandler, n)),
                (n.instanceUid = e++),
                (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                n.registerBreakpoints(),
                n.init(!0);
            };
          })()).prototype.activateADA = function () {
            this.$slideTrack
              .find(".slick-active")
              .attr({ "aria-hidden": "false" })
              .find("a, input, button, select")
              .attr({ tabindex: "0" });
          }),
            (e.prototype.addSlide = e.prototype.slickAdd =
              function (e, t, o) {
                var s = this;
                if ("boolean" == typeof t) (o = t), (t = null);
                else if (t < 0 || t >= s.slideCount) return !1;
                s.unload(),
                  "number" == typeof t
                    ? 0 === t && 0 === s.$slides.length
                      ? i(e).appendTo(s.$slideTrack)
                      : o
                      ? i(e).insertBefore(s.$slides.eq(t))
                      : i(e).insertAfter(s.$slides.eq(t))
                    : !0 === o
                    ? i(e).prependTo(s.$slideTrack)
                    : i(e).appendTo(s.$slideTrack),
                  (s.$slides = s.$slideTrack.children(this.options.slide)),
                  s.$slideTrack.children(this.options.slide).detach(),
                  s.$slideTrack.append(s.$slides),
                  s.$slides.each(function (e, t) {
                    i(t).attr("data-slick-index", e);
                  }),
                  (s.$slidesCache = s.$slides),
                  s.reinit();
              }),
            (e.prototype.animateHeight = function () {
              var i = this;
              if (
                1 === i.options.slidesToShow &&
                !0 === i.options.adaptiveHeight &&
                !1 === i.options.vertical
              ) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.animate({ height: e }, i.options.speed);
              }
            }),
            (e.prototype.animateSlide = function (e, t) {
              var o = {},
                s = this;
              s.animateHeight(),
                !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
                !1 === s.transformsEnabled
                  ? !1 === s.options.vertical
                    ? s.$slideTrack.animate(
                        { left: e },
                        s.options.speed,
                        s.options.easing,
                        t,
                      )
                    : s.$slideTrack.animate(
                        { top: e },
                        s.options.speed,
                        s.options.easing,
                        t,
                      )
                  : !1 === s.cssTransitions
                  ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
                    i({ animStart: s.currentLeft }).animate(
                      { animStart: e },
                      {
                        duration: s.options.speed,
                        easing: s.options.easing,
                        step: function (i) {
                          (i = Math.ceil(i)),
                            !1 === s.options.vertical
                              ? ((o[s.animType] =
                                  "translate(" + i + "px, 0px)"),
                                s.$slideTrack.css(o))
                              : ((o[s.animType] = "translate(0px," + i + "px)"),
                                s.$slideTrack.css(o));
                        },
                        complete: function () {
                          t && t.call();
                        },
                      },
                    ))
                  : (s.applyTransition(),
                    (e = Math.ceil(e)),
                    !1 === s.options.vertical
                      ? (o[s.animType] = "translate3d(" + e + "px, 0px, 0px)")
                      : (o[s.animType] = "translate3d(0px," + e + "px, 0px)"),
                    s.$slideTrack.css(o),
                    t &&
                      setTimeout(function () {
                        s.disableTransition(), t.call();
                      }, s.options.speed));
            }),
            (e.prototype.getNavTarget = function () {
              var e = this.options.asNavFor;
              return e && null !== e && (e = i(e).not(this.$slider)), e;
            }),
            (e.prototype.asNavFor = function (e) {
              var t = this.getNavTarget();
              null !== t &&
                "object" == typeof t &&
                t.each(function () {
                  var t = i(this).slick("getSlick");
                  t.unslicked || t.slideHandler(e, !0);
                });
            }),
            (e.prototype.applyTransition = function (i) {
              var e = this,
                t = {};
              !1 === e.options.fade
                ? (t[e.transitionType] =
                    e.transformType +
                    " " +
                    e.options.speed +
                    "ms " +
                    e.options.cssEase)
                : (t[e.transitionType] =
                    "opacity " + e.options.speed + "ms " + e.options.cssEase),
                !1 === e.options.fade
                  ? e.$slideTrack.css(t)
                  : e.$slides.eq(i).css(t);
            }),
            (e.prototype.autoPlay = function () {
              var i = this;
              i.autoPlayClear(),
                i.slideCount > i.options.slidesToShow &&
                  (i.autoPlayTimer = setInterval(
                    i.autoPlayIterator,
                    i.options.autoplaySpeed,
                  ));
            }),
            (e.prototype.autoPlayClear = function () {
              this.autoPlayTimer && clearInterval(this.autoPlayTimer);
            }),
            (e.prototype.autoPlayIterator = function () {
              var i = this,
                e = i.currentSlide + i.options.slidesToScroll;
              i.paused ||
                i.interrupted ||
                i.focussed ||
                (!1 === i.options.infinite &&
                  (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1
                    ? (i.direction = 0)
                    : 0 === i.direction &&
                      ((e = i.currentSlide - i.options.slidesToScroll),
                      i.currentSlide - 1 == 0 && (i.direction = 1))),
                i.slideHandler(e));
            }),
            (e.prototype.buildArrows = function () {
              var e = this;
              !0 === e.options.arrows &&
                ((e.$prevArrow = i(e.options.prevArrow).addClass(
                  "slick-arrow",
                )),
                (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")),
                e.slideCount > e.options.slidesToShow
                  ? (e.$prevArrow
                      .removeClass("slick-hidden")
                      .removeAttr("aria-hidden tabindex"),
                    e.$nextArrow
                      .removeClass("slick-hidden")
                      .removeAttr("aria-hidden tabindex"),
                    e.htmlExpr.test(e.options.prevArrow) &&
                      e.$prevArrow.prependTo(e.options.appendArrows),
                    e.htmlExpr.test(e.options.nextArrow) &&
                      e.$nextArrow.appendTo(e.options.appendArrows),
                    !0 !== e.options.infinite &&
                      e.$prevArrow
                        .addClass("slick-disabled")
                        .attr("aria-disabled", "true"))
                  : e.$prevArrow
                      .add(e.$nextArrow)
                      .addClass("slick-hidden")
                      .attr({ "aria-disabled": "true", tabindex: "-1" }));
            }),
            (e.prototype.buildDots = function () {
              var e,
                t,
                o = this;
              if (
                !0 === o.options.dots &&
                o.slideCount > o.options.slidesToShow
              ) {
                for (
                  o.$slider.addClass("slick-dotted"),
                    t = i("<ul />").addClass(o.options.dotsClass),
                    e = 0;
                  e <= o.getDotCount();
                  e += 1
                )
                  t.append(
                    i("<li />").append(o.options.customPaging.call(this, o, e)),
                  );
                (o.$dots = t.appendTo(o.options.appendDots)),
                  o.$dots.find("li").first().addClass("slick-active");
              }
            }),
            (e.prototype.buildOut = function () {
              var e = this;
              (e.$slides = e.$slider
                .children(e.options.slide + ":not(.slick-cloned)")
                .addClass("slick-slide")),
                (e.slideCount = e.$slides.length),
                e.$slides.each(function (e, t) {
                  i(t)
                    .attr("data-slick-index", e)
                    .data("originalStyling", i(t).attr("style") || "");
                }),
                e.$slider.addClass("slick-slider"),
                (e.$slideTrack =
                  0 === e.slideCount
                    ? i('<div class="slick-track"/>').appendTo(e.$slider)
                    : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
                (e.$list = e.$slideTrack
                  .wrap('<div class="slick-list"/>')
                  .parent()),
                e.$slideTrack.css("opacity", 0),
                (!0 !== e.options.centerMode &&
                  !0 !== e.options.swipeToSlide) ||
                  (e.options.slidesToScroll = 1),
                i("img[data-lazy]", e.$slider)
                  .not("[src]")
                  .addClass("slick-loading"),
                e.setupInfinite(),
                e.buildArrows(),
                e.buildDots(),
                e.updateDots(),
                e.setSlideClasses(
                  "number" == typeof e.currentSlide ? e.currentSlide : 0,
                ),
                !0 === e.options.draggable && e.$list.addClass("draggable");
            }),
            (e.prototype.buildRows = function () {
              var i,
                e,
                t,
                o,
                s,
                n,
                r,
                l = this;
              if (
                ((o = document.createDocumentFragment()),
                (n = l.$slider.children()),
                l.options.rows > 0)
              ) {
                for (
                  r = l.options.slidesPerRow * l.options.rows,
                    s = Math.ceil(n.length / r),
                    i = 0;
                  i < s;
                  i++
                ) {
                  var d = document.createElement("div");
                  for (e = 0; e < l.options.rows; e++) {
                    var a = document.createElement("div");
                    for (t = 0; t < l.options.slidesPerRow; t++) {
                      var c = i * r + (e * l.options.slidesPerRow + t);
                      n.get(c) && a.appendChild(n.get(c));
                    }
                    d.appendChild(a);
                  }
                  o.appendChild(d);
                }
                l.$slider.empty().append(o),
                  l.$slider
                    .children()
                    .children()
                    .children()
                    .css({
                      width: 100 / l.options.slidesPerRow + "%",
                      display: "inline-block",
                    });
              }
            }),
            (e.prototype.checkResponsive = function (e, t) {
              var o,
                s,
                n,
                r = this,
                l = !1,
                d = r.$slider.width(),
                a = window.innerWidth || i(window).width();
              if (
                ("window" === r.respondTo
                  ? (n = a)
                  : "slider" === r.respondTo
                  ? (n = d)
                  : "min" === r.respondTo && (n = Math.min(a, d)),
                r.options.responsive &&
                  r.options.responsive.length &&
                  null !== r.options.responsive)
              ) {
                for (o in ((s = null), r.breakpoints))
                  r.breakpoints.hasOwnProperty(o) &&
                    (!1 === r.originalSettings.mobileFirst
                      ? n < r.breakpoints[o] && (s = r.breakpoints[o])
                      : n > r.breakpoints[o] && (s = r.breakpoints[o]));
                null !== s
                  ? null !== r.activeBreakpoint
                    ? (s !== r.activeBreakpoint || t) &&
                      ((r.activeBreakpoint = s),
                      "unslick" === r.breakpointSettings[s]
                        ? r.unslick(s)
                        : ((r.options = i.extend(
                            {},
                            r.originalSettings,
                            r.breakpointSettings[s],
                          )),
                          !0 === e && (r.currentSlide = r.options.initialSlide),
                          r.refresh(e)),
                      (l = s))
                    : ((r.activeBreakpoint = s),
                      "unslick" === r.breakpointSettings[s]
                        ? r.unslick(s)
                        : ((r.options = i.extend(
                            {},
                            r.originalSettings,
                            r.breakpointSettings[s],
                          )),
                          !0 === e && (r.currentSlide = r.options.initialSlide),
                          r.refresh(e)),
                      (l = s))
                  : null !== r.activeBreakpoint &&
                    ((r.activeBreakpoint = null),
                    (r.options = r.originalSettings),
                    !0 === e && (r.currentSlide = r.options.initialSlide),
                    r.refresh(e),
                    (l = s)),
                  e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
              }
            }),
            (e.prototype.changeSlide = function (e, t) {
              var o,
                s,
                n = this,
                r = i(e.currentTarget);
              switch (
                (r.is("a") && e.preventDefault(),
                r.is("li") || (r = r.closest("li")),
                (o =
                  n.slideCount % n.options.slidesToScroll != 0
                    ? 0
                    : (n.slideCount - n.currentSlide) %
                      n.options.slidesToScroll),
                e.data.message)
              ) {
                case "previous":
                  (s =
                    0 === o
                      ? n.options.slidesToScroll
                      : n.options.slidesToShow - o),
                    n.slideCount > n.options.slidesToShow &&
                      n.slideHandler(n.currentSlide - s, !1, t);
                  break;
                case "next":
                  (s = 0 === o ? n.options.slidesToScroll : o),
                    n.slideCount > n.options.slidesToShow &&
                      n.slideHandler(n.currentSlide + s, !1, t);
                  break;
                case "index":
                  var l =
                    0 === e.data.index
                      ? 0
                      : e.data.index || r.index() * n.options.slidesToScroll;
                  n.slideHandler(n.checkNavigable(l), !1, t),
                    r.children().trigger("focus");
                  break;
                default:
                  return;
              }
            }),
            (e.prototype.checkNavigable = function (i) {
              var e, t;
              if (((t = 0), i > (e = this.getNavigableIndexes())[e.length - 1]))
                i = e[e.length - 1];
              else
                for (var o in e) {
                  if (i < e[o]) {
                    i = t;
                    break;
                  }
                  t = e[o];
                }
              return i;
            }),
            (e.prototype.cleanUpEvents = function () {
              var e = this;
              e.options.dots &&
                null !== e.$dots &&
                (i("li", e.$dots)
                  .off("click.slick", e.changeSlide)
                  .off("mouseenter.slick", i.proxy(e.interrupt, e, !0))
                  .off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
                !0 === e.options.accessibility &&
                  e.$dots.off("keydown.slick", e.keyHandler)),
                e.$slider.off("focus.slick blur.slick"),
                !0 === e.options.arrows &&
                  e.slideCount > e.options.slidesToShow &&
                  (e.$prevArrow &&
                    e.$prevArrow.off("click.slick", e.changeSlide),
                  e.$nextArrow &&
                    e.$nextArrow.off("click.slick", e.changeSlide),
                  !0 === e.options.accessibility &&
                    (e.$prevArrow &&
                      e.$prevArrow.off("keydown.slick", e.keyHandler),
                    e.$nextArrow &&
                      e.$nextArrow.off("keydown.slick", e.keyHandler))),
                e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
                e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
                e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
                e.$list.off(
                  "touchcancel.slick mouseleave.slick",
                  e.swipeHandler,
                ),
                e.$list.off("click.slick", e.clickHandler),
                i(document).off(e.visibilityChange, e.visibility),
                e.cleanUpSlideEvents(),
                !0 === e.options.accessibility &&
                  e.$list.off("keydown.slick", e.keyHandler),
                !0 === e.options.focusOnSelect &&
                  i(e.$slideTrack)
                    .children()
                    .off("click.slick", e.selectHandler),
                i(window).off(
                  "orientationchange.slick.slick-" + e.instanceUid,
                  e.orientationChange,
                ),
                i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
                i("[draggable!=true]", e.$slideTrack).off(
                  "dragstart",
                  e.preventDefault,
                ),
                i(window).off(
                  "load.slick.slick-" + e.instanceUid,
                  e.setPosition,
                );
            }),
            (e.prototype.cleanUpSlideEvents = function () {
              var e = this;
              e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
                e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
            }),
            (e.prototype.cleanUpRows = function () {
              var i,
                e = this;
              e.options.rows > 0 &&
                ((i = e.$slides.children().children()).removeAttr("style"),
                e.$slider.empty().append(i));
            }),
            (e.prototype.clickHandler = function (i) {
              !1 === this.shouldClick &&
                (i.stopImmediatePropagation(),
                i.stopPropagation(),
                i.preventDefault());
            }),
            (e.prototype.destroy = function (e) {
              var t = this;
              t.autoPlayClear(),
                (t.touchObject = {}),
                t.cleanUpEvents(),
                i(".slick-cloned", t.$slider).detach(),
                t.$dots && t.$dots.remove(),
                t.$prevArrow &&
                  t.$prevArrow.length &&
                  (t.$prevArrow
                    .removeClass("slick-disabled slick-arrow slick-hidden")
                    .removeAttr("aria-hidden aria-disabled tabindex")
                    .css("display", ""),
                  t.htmlExpr.test(t.options.prevArrow) &&
                    t.$prevArrow.remove()),
                t.$nextArrow &&
                  t.$nextArrow.length &&
                  (t.$nextArrow
                    .removeClass("slick-disabled slick-arrow slick-hidden")
                    .removeAttr("aria-hidden aria-disabled tabindex")
                    .css("display", ""),
                  t.htmlExpr.test(t.options.nextArrow) &&
                    t.$nextArrow.remove()),
                t.$slides &&
                  (t.$slides
                    .removeClass(
                      "slick-slide slick-active slick-center slick-visible slick-current",
                    )
                    .removeAttr("aria-hidden")
                    .removeAttr("data-slick-index")
                    .each(function () {
                      i(this).attr("style", i(this).data("originalStyling"));
                    }),
                  t.$slideTrack.children(this.options.slide).detach(),
                  t.$slideTrack.detach(),
                  t.$list.detach(),
                  t.$slider.append(t.$slides)),
                t.cleanUpRows(),
                t.$slider.removeClass("slick-slider"),
                t.$slider.removeClass("slick-initialized"),
                t.$slider.removeClass("slick-dotted"),
                (t.unslicked = !0),
                e || t.$slider.trigger("destroy", [t]);
            }),
            (e.prototype.disableTransition = function (i) {
              var e = this,
                t = {};
              (t[e.transitionType] = ""),
                !1 === e.options.fade
                  ? e.$slideTrack.css(t)
                  : e.$slides.eq(i).css(t);
            }),
            (e.prototype.fadeSlide = function (i, e) {
              var t = this;
              !1 === t.cssTransitions
                ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }),
                  t.$slides
                    .eq(i)
                    .animate(
                      { opacity: 1 },
                      t.options.speed,
                      t.options.easing,
                      e,
                    ))
                : (t.applyTransition(i),
                  t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
                  e &&
                    setTimeout(function () {
                      t.disableTransition(i), e.call();
                    }, t.options.speed));
            }),
            (e.prototype.fadeSlideOut = function (i) {
              var e = this;
              !1 === e.cssTransitions
                ? e.$slides
                    .eq(i)
                    .animate(
                      { opacity: 0, zIndex: e.options.zIndex - 2 },
                      e.options.speed,
                      e.options.easing,
                    )
                : (e.applyTransition(i),
                  e.$slides
                    .eq(i)
                    .css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
            }),
            (e.prototype.filterSlides = e.prototype.slickFilter =
              function (i) {
                var e = this;
                null !== i &&
                  ((e.$slidesCache = e.$slides),
                  e.unload(),
                  e.$slideTrack.children(this.options.slide).detach(),
                  e.$slidesCache.filter(i).appendTo(e.$slideTrack),
                  e.reinit());
              }),
            (e.prototype.focusHandler = function () {
              var e = this;
              e.$slider
                .off("focus.slick blur.slick")
                .on("focus.slick blur.slick", "*", function (t) {
                  t.stopImmediatePropagation();
                  var o = i(this);
                  setTimeout(function () {
                    e.options.pauseOnFocus &&
                      ((e.focussed = o.is(":focus")), e.autoPlay());
                  }, 0);
                });
            }),
            (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
              function () {
                return this.currentSlide;
              }),
            (e.prototype.getDotCount = function () {
              var i = this,
                e = 0,
                t = 0,
                o = 0;
              if (!0 === i.options.infinite)
                if (i.slideCount <= i.options.slidesToShow) ++o;
                else
                  for (; e < i.slideCount; )
                    ++o,
                      (e = t + i.options.slidesToScroll),
                      (t +=
                        i.options.slidesToScroll <= i.options.slidesToShow
                          ? i.options.slidesToScroll
                          : i.options.slidesToShow);
              else if (!0 === i.options.centerMode) o = i.slideCount;
              else if (i.options.asNavFor)
                for (; e < i.slideCount; )
                  ++o,
                    (e = t + i.options.slidesToScroll),
                    (t +=
                      i.options.slidesToScroll <= i.options.slidesToShow
                        ? i.options.slidesToScroll
                        : i.options.slidesToShow);
              else
                o =
                  1 +
                  Math.ceil(
                    (i.slideCount - i.options.slidesToShow) /
                      i.options.slidesToScroll,
                  );
              return o - 1;
            }),
            (e.prototype.getLeft = function (i) {
              var e,
                t,
                o,
                s,
                n = this,
                r = 0;
              return (
                (n.slideOffset = 0),
                (t = n.$slides.first().outerHeight(!0)),
                !0 === n.options.infinite
                  ? (n.slideCount > n.options.slidesToShow &&
                      ((n.slideOffset =
                        n.slideWidth * n.options.slidesToShow * -1),
                      (s = -1),
                      !0 === n.options.vertical &&
                        !0 === n.options.centerMode &&
                        (2 === n.options.slidesToShow
                          ? (s = -1.5)
                          : 1 === n.options.slidesToShow && (s = -2)),
                      (r = t * n.options.slidesToShow * s)),
                    n.slideCount % n.options.slidesToScroll != 0 &&
                      i + n.options.slidesToScroll > n.slideCount &&
                      n.slideCount > n.options.slidesToShow &&
                      (i > n.slideCount
                        ? ((n.slideOffset =
                            (n.options.slidesToShow - (i - n.slideCount)) *
                            n.slideWidth *
                            -1),
                          (r =
                            (n.options.slidesToShow - (i - n.slideCount)) *
                            t *
                            -1))
                        : ((n.slideOffset =
                            (n.slideCount % n.options.slidesToScroll) *
                            n.slideWidth *
                            -1),
                          (r =
                            (n.slideCount % n.options.slidesToScroll) *
                            t *
                            -1))))
                  : i + n.options.slidesToShow > n.slideCount &&
                    ((n.slideOffset =
                      (i + n.options.slidesToShow - n.slideCount) *
                      n.slideWidth),
                    (r = (i + n.options.slidesToShow - n.slideCount) * t)),
                n.slideCount <= n.options.slidesToShow &&
                  ((n.slideOffset = 0), (r = 0)),
                !0 === n.options.centerMode &&
                n.slideCount <= n.options.slidesToShow
                  ? (n.slideOffset =
                      (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 -
                      (n.slideWidth * n.slideCount) / 2)
                  : !0 === n.options.centerMode && !0 === n.options.infinite
                  ? (n.slideOffset +=
                      n.slideWidth * Math.floor(n.options.slidesToShow / 2) -
                      n.slideWidth)
                  : !0 === n.options.centerMode &&
                    ((n.slideOffset = 0),
                    (n.slideOffset +=
                      n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
                (e =
                  !1 === n.options.vertical
                    ? i * n.slideWidth * -1 + n.slideOffset
                    : i * t * -1 + r),
                !0 === n.options.variableWidth &&
                  ((o =
                    n.slideCount <= n.options.slidesToShow ||
                    !1 === n.options.infinite
                      ? n.$slideTrack.children(".slick-slide").eq(i)
                      : n.$slideTrack
                          .children(".slick-slide")
                          .eq(i + n.options.slidesToShow)),
                  (e =
                    !0 === n.options.rtl
                      ? o[0]
                        ? -1 *
                          (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                        : 0
                      : o[0]
                      ? -1 * o[0].offsetLeft
                      : 0),
                  !0 === n.options.centerMode &&
                    ((o =
                      n.slideCount <= n.options.slidesToShow ||
                      !1 === n.options.infinite
                        ? n.$slideTrack.children(".slick-slide").eq(i)
                        : n.$slideTrack
                            .children(".slick-slide")
                            .eq(i + n.options.slidesToShow + 1)),
                    (e =
                      !0 === n.options.rtl
                        ? o[0]
                          ? -1 *
                            (n.$slideTrack.width() -
                              o[0].offsetLeft -
                              o.width())
                          : 0
                        : o[0]
                        ? -1 * o[0].offsetLeft
                        : 0),
                    (e += (n.$list.width() - o.outerWidth()) / 2))),
                e
              );
            }),
            (e.prototype.getOption = e.prototype.slickGetOption =
              function (i) {
                return this.options[i];
              }),
            (e.prototype.getNavigableIndexes = function () {
              var i,
                e = this,
                t = 0,
                o = 0,
                s = [];
              for (
                !1 === e.options.infinite
                  ? (i = e.slideCount)
                  : ((t = -1 * e.options.slidesToScroll),
                    (o = -1 * e.options.slidesToScroll),
                    (i = 2 * e.slideCount));
                t < i;

              )
                s.push(t),
                  (t = o + e.options.slidesToScroll),
                  (o +=
                    e.options.slidesToScroll <= e.options.slidesToShow
                      ? e.options.slidesToScroll
                      : e.options.slidesToShow);
              return s;
            }),
            (e.prototype.getSlick = function () {
              return this;
            }),
            (e.prototype.getSlideCount = function () {
              var e,
                t,
                o = this;
              return (
                (t =
                  !0 === o.options.centerMode
                    ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
                    : 0),
                !0 === o.options.swipeToSlide
                  ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
                      if (
                        n.offsetLeft - t + i(n).outerWidth() / 2 >
                        -1 * o.swipeLeft
                      )
                        return (e = n), !1;
                    }),
                    Math.abs(i(e).attr("data-slick-index") - o.currentSlide) ||
                      1)
                  : o.options.slidesToScroll
              );
            }),
            (e.prototype.goTo = e.prototype.slickGoTo =
              function (i, e) {
                this.changeSlide(
                  { data: { message: "index", index: parseInt(i) } },
                  e,
                );
              }),
            (e.prototype.init = function (e) {
              var t = this;
              i(t.$slider).hasClass("slick-initialized") ||
                (i(t.$slider).addClass("slick-initialized"),
                t.buildRows(),
                t.buildOut(),
                t.setProps(),
                t.startLoad(),
                t.loadSlider(),
                t.initializeEvents(),
                t.updateArrows(),
                t.updateDots(),
                t.checkResponsive(!0),
                t.focusHandler()),
                e && t.$slider.trigger("init", [t]),
                !0 === t.options.accessibility && t.initADA(),
                t.options.autoplay && ((t.paused = !1), t.autoPlay());
            }),
            (e.prototype.initADA = function () {
              var e = this,
                t = Math.ceil(e.slideCount / e.options.slidesToShow),
                o = e.getNavigableIndexes().filter(function (i) {
                  return i >= 0 && i < e.slideCount;
                });
              e.$slides
                .add(e.$slideTrack.find(".slick-cloned"))
                .attr({ "aria-hidden": "true", tabindex: "-1" })
                .find("a, input, button, select")
                .attr({ tabindex: "-1" }),
                null !== e.$dots &&
                  (e.$slides
                    .not(e.$slideTrack.find(".slick-cloned"))
                    .each(function (t) {
                      var s = o.indexOf(t);
                      if (
                        (i(this).attr({
                          role: "tabpanel",
                          id: "slick-slide" + e.instanceUid + t,
                          tabindex: -1,
                        }),
                        -1 !== s)
                      ) {
                        var n = "slick-slide-control" + e.instanceUid + s;
                        i("#" + n).length &&
                          i(this).attr({ "aria-describedby": n });
                      }
                    }),
                  e.$dots
                    .attr("role", "tablist")
                    .find("li")
                    .each(function (s) {
                      var n = o[s];
                      i(this).attr({ role: "presentation" }),
                        i(this)
                          .find("button")
                          .first()
                          .attr({
                            role: "tab",
                            id: "slick-slide-control" + e.instanceUid + s,
                            "aria-controls": "slick-slide" + e.instanceUid + n,
                            "aria-label": s + 1 + " of " + t,
                            "aria-selected": null,
                            tabindex: "-1",
                          });
                    })
                    .eq(e.currentSlide)
                    .find("button")
                    .attr({ "aria-selected": "true", tabindex: "0" })
                    .end());
              for (
                var s = e.currentSlide, n = s + e.options.slidesToShow;
                s < n;
                s++
              )
                e.options.focusOnChange
                  ? e.$slides.eq(s).attr({ tabindex: "0" })
                  : e.$slides.eq(s).removeAttr("tabindex");
              e.activateADA();
            }),
            (e.prototype.initArrowEvents = function () {
              var i = this;
              !0 === i.options.arrows &&
                i.slideCount > i.options.slidesToShow &&
                (i.$prevArrow
                  .off("click.slick")
                  .on("click.slick", { message: "previous" }, i.changeSlide),
                i.$nextArrow
                  .off("click.slick")
                  .on("click.slick", { message: "next" }, i.changeSlide),
                !0 === i.options.accessibility &&
                  (i.$prevArrow.on("keydown.slick", i.keyHandler),
                  i.$nextArrow.on("keydown.slick", i.keyHandler)));
            }),
            (e.prototype.initDotEvents = function () {
              var e = this;
              !0 === e.options.dots &&
                e.slideCount > e.options.slidesToShow &&
                (i("li", e.$dots).on(
                  "click.slick",
                  { message: "index" },
                  e.changeSlide,
                ),
                !0 === e.options.accessibility &&
                  e.$dots.on("keydown.slick", e.keyHandler)),
                !0 === e.options.dots &&
                  !0 === e.options.pauseOnDotsHover &&
                  e.slideCount > e.options.slidesToShow &&
                  i("li", e.$dots)
                    .on("mouseenter.slick", i.proxy(e.interrupt, e, !0))
                    .on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
            }),
            (e.prototype.initSlideEvents = function () {
              var e = this;
              e.options.pauseOnHover &&
                (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
                e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
            }),
            (e.prototype.initializeEvents = function () {
              var e = this;
              e.initArrowEvents(),
                e.initDotEvents(),
                e.initSlideEvents(),
                e.$list.on(
                  "touchstart.slick mousedown.slick",
                  { action: "start" },
                  e.swipeHandler,
                ),
                e.$list.on(
                  "touchmove.slick mousemove.slick",
                  { action: "move" },
                  e.swipeHandler,
                ),
                e.$list.on(
                  "touchend.slick mouseup.slick",
                  { action: "end" },
                  e.swipeHandler,
                ),
                e.$list.on(
                  "touchcancel.slick mouseleave.slick",
                  { action: "end" },
                  e.swipeHandler,
                ),
                e.$list.on("click.slick", e.clickHandler),
                i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
                !0 === e.options.accessibility &&
                  e.$list.on("keydown.slick", e.keyHandler),
                !0 === e.options.focusOnSelect &&
                  i(e.$slideTrack)
                    .children()
                    .on("click.slick", e.selectHandler),
                i(window).on(
                  "orientationchange.slick.slick-" + e.instanceUid,
                  i.proxy(e.orientationChange, e),
                ),
                i(window).on(
                  "resize.slick.slick-" + e.instanceUid,
                  i.proxy(e.resize, e),
                ),
                i("[draggable!=true]", e.$slideTrack).on(
                  "dragstart",
                  e.preventDefault,
                ),
                i(window).on(
                  "load.slick.slick-" + e.instanceUid,
                  e.setPosition,
                ),
                i(e.setPosition);
            }),
            (e.prototype.initUI = function () {
              var i = this;
              !0 === i.options.arrows &&
                i.slideCount > i.options.slidesToShow &&
                (i.$prevArrow.show(), i.$nextArrow.show()),
                !0 === i.options.dots &&
                  i.slideCount > i.options.slidesToShow &&
                  i.$dots.show();
            }),
            (e.prototype.keyHandler = function (i) {
              var e = this;
              i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                (37 === i.keyCode && !0 === e.options.accessibility
                  ? e.changeSlide({
                      data: {
                        message: !0 === e.options.rtl ? "next" : "previous",
                      },
                    })
                  : 39 === i.keyCode &&
                    !0 === e.options.accessibility &&
                    e.changeSlide({
                      data: {
                        message: !0 === e.options.rtl ? "previous" : "next",
                      },
                    }));
            }),
            (e.prototype.lazyLoad = function () {
              var e,
                t,
                o,
                s = this;
              function n(e) {
                i("img[data-lazy]", e).each(function () {
                  var e = i(this),
                    t = i(this).attr("data-lazy"),
                    o = i(this).attr("data-srcset"),
                    n =
                      i(this).attr("data-sizes") ||
                      s.$slider.attr("data-sizes"),
                    r = document.createElement("img");
                  (r.onload = function () {
                    e.animate({ opacity: 0 }, 100, function () {
                      o && (e.attr("srcset", o), n && e.attr("sizes", n)),
                        e
                          .attr("src", t)
                          .animate({ opacity: 1 }, 200, function () {
                            e.removeAttr(
                              "data-lazy data-srcset data-sizes",
                            ).removeClass("slick-loading");
                          }),
                        s.$slider.trigger("lazyLoaded", [s, e, t]);
                    });
                  }),
                    (r.onerror = function () {
                      e
                        .removeAttr("data-lazy")
                        .removeClass("slick-loading")
                        .addClass("slick-lazyload-error"),
                        s.$slider.trigger("lazyLoadError", [s, e, t]);
                    }),
                    (r.src = t);
                });
              }
              if (
                (!0 === s.options.centerMode
                  ? !0 === s.options.infinite
                    ? (o =
                        (t =
                          s.currentSlide + (s.options.slidesToShow / 2 + 1)) +
                        s.options.slidesToShow +
                        2)
                    : ((t = Math.max(
                        0,
                        s.currentSlide - (s.options.slidesToShow / 2 + 1),
                      )),
                      (o = s.options.slidesToShow / 2 + 1 + 2 + s.currentSlide))
                  : ((t = s.options.infinite
                      ? s.options.slidesToShow + s.currentSlide
                      : s.currentSlide),
                    (o = Math.ceil(t + s.options.slidesToShow)),
                    !0 === s.options.fade &&
                      (t > 0 && t--, o <= s.slideCount && o++)),
                (e = s.$slider.find(".slick-slide").slice(t, o)),
                "anticipated" === s.options.lazyLoad)
              )
                for (
                  var r = t - 1,
                    l = o,
                    d = s.$slider.find(".slick-slide"),
                    a = 0;
                  a < s.options.slidesToScroll;
                  a++
                )
                  r < 0 && (r = s.slideCount - 1),
                    (e = (e = e.add(d.eq(r))).add(d.eq(l))),
                    r--,
                    l++;
              n(e),
                s.slideCount <= s.options.slidesToShow
                  ? n(s.$slider.find(".slick-slide"))
                  : s.currentSlide >= s.slideCount - s.options.slidesToShow
                  ? n(
                      s.$slider
                        .find(".slick-cloned")
                        .slice(0, s.options.slidesToShow),
                    )
                  : 0 === s.currentSlide &&
                    n(
                      s.$slider
                        .find(".slick-cloned")
                        .slice(-1 * s.options.slidesToShow),
                    );
            }),
            (e.prototype.loadSlider = function () {
              var i = this;
              i.setPosition(),
                i.$slideTrack.css({ opacity: 1 }),
                i.$slider.removeClass("slick-loading"),
                i.initUI(),
                "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
            }),
            (e.prototype.next = e.prototype.slickNext =
              function () {
                this.changeSlide({ data: { message: "next" } });
              }),
            (e.prototype.orientationChange = function () {
              this.checkResponsive(), this.setPosition();
            }),
            (e.prototype.pause = e.prototype.slickPause =
              function () {
                this.autoPlayClear(), (this.paused = !0);
              }),
            (e.prototype.play = e.prototype.slickPlay =
              function () {
                var i = this;
                i.autoPlay(),
                  (i.options.autoplay = !0),
                  (i.paused = !1),
                  (i.focussed = !1),
                  (i.interrupted = !1);
              }),
            (e.prototype.postSlide = function (e) {
              var t = this;
              t.unslicked ||
                (t.$slider.trigger("afterChange", [t, e]),
                (t.animating = !1),
                t.slideCount > t.options.slidesToShow && t.setPosition(),
                (t.swipeLeft = null),
                t.options.autoplay && t.autoPlay(),
                !0 === t.options.accessibility &&
                  (t.initADA(),
                  t.options.focusOnChange &&
                    i(t.$slides.get(t.currentSlide))
                      .attr("tabindex", 0)
                      .focus()));
            }),
            (e.prototype.prev = e.prototype.slickPrev =
              function () {
                this.changeSlide({ data: { message: "previous" } });
              }),
            (e.prototype.preventDefault = function (i) {
              i.preventDefault();
            }),
            (e.prototype.progressiveLazyLoad = function (e) {
              e = e || 1;
              var t,
                o,
                s,
                n,
                r,
                l = this,
                d = i("img[data-lazy]", l.$slider);
              d.length
                ? ((t = d.first()),
                  (o = t.attr("data-lazy")),
                  (s = t.attr("data-srcset")),
                  (n = t.attr("data-sizes") || l.$slider.attr("data-sizes")),
                  ((r = document.createElement("img")).onload = function () {
                    s && (t.attr("srcset", s), n && t.attr("sizes", n)),
                      t
                        .attr("src", o)
                        .removeAttr("data-lazy data-srcset data-sizes")
                        .removeClass("slick-loading"),
                      !0 === l.options.adaptiveHeight && l.setPosition(),
                      l.$slider.trigger("lazyLoaded", [l, t, o]),
                      l.progressiveLazyLoad();
                  }),
                  (r.onerror = function () {
                    e < 3
                      ? setTimeout(function () {
                          l.progressiveLazyLoad(e + 1);
                        }, 500)
                      : (t
                          .removeAttr("data-lazy")
                          .removeClass("slick-loading")
                          .addClass("slick-lazyload-error"),
                        l.$slider.trigger("lazyLoadError", [l, t, o]),
                        l.progressiveLazyLoad());
                  }),
                  (r.src = o))
                : l.$slider.trigger("allImagesLoaded", [l]);
            }),
            (e.prototype.refresh = function (e) {
              var t,
                o,
                s = this;
              (o = s.slideCount - s.options.slidesToShow),
                !s.options.infinite &&
                  s.currentSlide > o &&
                  (s.currentSlide = o),
                s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
                (t = s.currentSlide),
                s.destroy(!0),
                i.extend(s, s.initials, { currentSlide: t }),
                s.init(),
                e ||
                  s.changeSlide({ data: { message: "index", index: t } }, !1);
            }),
            (e.prototype.registerBreakpoints = function () {
              var e,
                t,
                o,
                s = this,
                n = s.options.responsive || null;
              if ("array" === i.type(n) && n.length) {
                for (e in ((s.respondTo = s.options.respondTo || "window"), n))
                  if (((o = s.breakpoints.length - 1), n.hasOwnProperty(e))) {
                    for (t = n[e].breakpoint; o >= 0; )
                      s.breakpoints[o] &&
                        s.breakpoints[o] === t &&
                        s.breakpoints.splice(o, 1),
                        o--;
                    s.breakpoints.push(t),
                      (s.breakpointSettings[t] = n[e].settings);
                  }
                s.breakpoints.sort(function (i, e) {
                  return s.options.mobileFirst ? i - e : e - i;
                });
              }
            }),
            (e.prototype.reinit = function () {
              var e = this;
              (e.$slides = e.$slideTrack
                .children(e.options.slide)
                .addClass("slick-slide")),
                (e.slideCount = e.$slides.length),
                e.currentSlide >= e.slideCount &&
                  0 !== e.currentSlide &&
                  (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
                e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
                e.registerBreakpoints(),
                e.setProps(),
                e.setupInfinite(),
                e.buildArrows(),
                e.updateArrows(),
                e.initArrowEvents(),
                e.buildDots(),
                e.updateDots(),
                e.initDotEvents(),
                e.cleanUpSlideEvents(),
                e.initSlideEvents(),
                e.checkResponsive(!1, !0),
                !0 === e.options.focusOnSelect &&
                  i(e.$slideTrack)
                    .children()
                    .on("click.slick", e.selectHandler),
                e.setSlideClasses(
                  "number" == typeof e.currentSlide ? e.currentSlide : 0,
                ),
                e.setPosition(),
                e.focusHandler(),
                (e.paused = !e.options.autoplay),
                e.autoPlay(),
                e.$slider.trigger("reInit", [e]);
            }),
            (e.prototype.resize = function () {
              var e = this;
              i(window).width() !== e.windowWidth &&
                (clearTimeout(e.windowDelay),
                (e.windowDelay = window.setTimeout(function () {
                  (e.windowWidth = i(window).width()),
                    e.checkResponsive(),
                    e.unslicked || e.setPosition();
                }, 50)));
            }),
            (e.prototype.removeSlide = e.prototype.slickRemove =
              function (i, e, t) {
                var o = this;
                if (
                  ((i =
                    "boolean" == typeof i
                      ? !0 === (e = i)
                        ? 0
                        : o.slideCount - 1
                      : !0 === e
                      ? --i
                      : i),
                  o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
                )
                  return !1;
                o.unload(),
                  !0 === t
                    ? o.$slideTrack.children().remove()
                    : o.$slideTrack.children(this.options.slide).eq(i).remove(),
                  (o.$slides = o.$slideTrack.children(this.options.slide)),
                  o.$slideTrack.children(this.options.slide).detach(),
                  o.$slideTrack.append(o.$slides),
                  (o.$slidesCache = o.$slides),
                  o.reinit();
              }),
            (e.prototype.setCSS = function (i) {
              var e,
                t,
                o = this,
                s = {};
              !0 === o.options.rtl && (i = -i),
                (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                (s[o.positionProp] = i),
                !1 === o.transformsEnabled
                  ? o.$slideTrack.css(s)
                  : ((s = {}),
                    !1 === o.cssTransitions
                      ? ((s[o.animType] = "translate(" + e + ", " + t + ")"),
                        o.$slideTrack.css(s))
                      : ((s[o.animType] =
                          "translate3d(" + e + ", " + t + ", 0px)"),
                        o.$slideTrack.css(s)));
            }),
            (e.prototype.setDimensions = function () {
              var i = this;
              !1 === i.options.vertical
                ? !0 === i.options.centerMode &&
                  i.$list.css({ padding: "0px " + i.options.centerPadding })
                : (i.$list.height(
                    i.$slides.first().outerHeight(!0) * i.options.slidesToShow,
                  ),
                  !0 === i.options.centerMode &&
                    i.$list.css({ padding: i.options.centerPadding + " 0px" })),
                (i.listWidth = i.$list.width()),
                (i.listHeight = i.$list.height()),
                !1 === i.options.vertical && !1 === i.options.variableWidth
                  ? ((i.slideWidth = Math.ceil(
                      i.listWidth / i.options.slidesToShow,
                    )),
                    i.$slideTrack.width(
                      Math.ceil(
                        i.slideWidth *
                          i.$slideTrack.children(".slick-slide").length,
                      ),
                    ))
                  : !0 === i.options.variableWidth
                  ? i.$slideTrack.width(5e3 * i.slideCount)
                  : ((i.slideWidth = Math.ceil(i.listWidth)),
                    i.$slideTrack.height(
                      Math.ceil(
                        i.$slides.first().outerHeight(!0) *
                          i.$slideTrack.children(".slick-slide").length,
                      ),
                    ));
              var e =
                i.$slides.first().outerWidth(!0) - i.$slides.first().width();
              !1 === i.options.variableWidth &&
                i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
            }),
            (e.prototype.setFade = function () {
              var e,
                t = this;
              t.$slides.each(function (o, s) {
                (e = t.slideWidth * o * -1),
                  !0 === t.options.rtl
                    ? i(s).css({
                        position: "relative",
                        right: e,
                        top: 0,
                        zIndex: t.options.zIndex - 2,
                        opacity: 0,
                      })
                    : i(s).css({
                        position: "relative",
                        left: e,
                        top: 0,
                        zIndex: t.options.zIndex - 2,
                        opacity: 0,
                      });
              }),
                t.$slides
                  .eq(t.currentSlide)
                  .css({ zIndex: t.options.zIndex - 1, opacity: 1 });
            }),
            (e.prototype.setHeight = function () {
              var i = this;
              if (
                1 === i.options.slidesToShow &&
                !0 === i.options.adaptiveHeight &&
                !1 === i.options.vertical
              ) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.css("height", e);
              }
            }),
            (e.prototype.setOption = e.prototype.slickSetOption =
              function () {
                var e,
                  t,
                  o,
                  s,
                  n,
                  r = this,
                  l = !1;
                if (
                  ("object" === i.type(arguments[0])
                    ? ((o = arguments[0]), (l = arguments[1]), (n = "multiple"))
                    : "string" === i.type(arguments[0]) &&
                      ((o = arguments[0]),
                      (s = arguments[1]),
                      (l = arguments[2]),
                      "responsive" === arguments[0] &&
                      "array" === i.type(arguments[1])
                        ? (n = "responsive")
                        : void 0 !== arguments[1] && (n = "single")),
                  "single" === n)
                )
                  r.options[o] = s;
                else if ("multiple" === n)
                  i.each(o, function (i, e) {
                    r.options[i] = e;
                  });
                else if ("responsive" === n)
                  for (t in s)
                    if ("array" !== i.type(r.options.responsive))
                      r.options.responsive = [s[t]];
                    else {
                      for (e = r.options.responsive.length - 1; e >= 0; )
                        r.options.responsive[e].breakpoint ===
                          s[t].breakpoint && r.options.responsive.splice(e, 1),
                          e--;
                      r.options.responsive.push(s[t]);
                    }
                l && (r.unload(), r.reinit());
              }),
            (e.prototype.setPosition = function () {
              var i = this;
              i.setDimensions(),
                i.setHeight(),
                !1 === i.options.fade
                  ? i.setCSS(i.getLeft(i.currentSlide))
                  : i.setFade(),
                i.$slider.trigger("setPosition", [i]);
            }),
            (e.prototype.setProps = function () {
              var i = this,
                e = document.body.style;
              (i.positionProp = !0 === i.options.vertical ? "top" : "left"),
                "top" === i.positionProp
                  ? i.$slider.addClass("slick-vertical")
                  : i.$slider.removeClass("slick-vertical"),
                (void 0 === e.WebkitTransition &&
                  void 0 === e.MozTransition &&
                  void 0 === e.msTransition) ||
                  (!0 === i.options.useCSS && (i.cssTransitions = !0)),
                i.options.fade &&
                  ("number" == typeof i.options.zIndex
                    ? i.options.zIndex < 3 && (i.options.zIndex = 3)
                    : (i.options.zIndex = i.defaults.zIndex)),
                void 0 !== e.OTransform &&
                  ((i.animType = "OTransform"),
                  (i.transformType = "-o-transform"),
                  (i.transitionType = "OTransition"),
                  void 0 === e.perspectiveProperty &&
                    void 0 === e.webkitPerspective &&
                    (i.animType = !1)),
                void 0 !== e.MozTransform &&
                  ((i.animType = "MozTransform"),
                  (i.transformType = "-moz-transform"),
                  (i.transitionType = "MozTransition"),
                  void 0 === e.perspectiveProperty &&
                    void 0 === e.MozPerspective &&
                    (i.animType = !1)),
                void 0 !== e.webkitTransform &&
                  ((i.animType = "webkitTransform"),
                  (i.transformType = "-webkit-transform"),
                  (i.transitionType = "webkitTransition"),
                  void 0 === e.perspectiveProperty &&
                    void 0 === e.webkitPerspective &&
                    (i.animType = !1)),
                void 0 !== e.msTransform &&
                  ((i.animType = "msTransform"),
                  (i.transformType = "-ms-transform"),
                  (i.transitionType = "msTransition"),
                  void 0 === e.msTransform && (i.animType = !1)),
                void 0 !== e.transform &&
                  !1 !== i.animType &&
                  ((i.animType = "transform"),
                  (i.transformType = "transform"),
                  (i.transitionType = "transition")),
                (i.transformsEnabled =
                  i.options.useTransform &&
                  null !== i.animType &&
                  !1 !== i.animType);
            }),
            (e.prototype.setSlideClasses = function (i) {
              var e,
                t,
                o,
                s,
                n = this;
              if (
                ((t = n.$slider
                  .find(".slick-slide")
                  .removeClass("slick-active slick-center slick-current")
                  .attr("aria-hidden", "true")),
                n.$slides.eq(i).addClass("slick-current"),
                !0 === n.options.centerMode)
              ) {
                var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
                (e = Math.floor(n.options.slidesToShow / 2)),
                  !0 === n.options.infinite &&
                    (i >= e && i <= n.slideCount - 1 - e
                      ? n.$slides
                          .slice(i - e + r, i + e + 1)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false")
                      : ((o = n.options.slidesToShow + i),
                        t
                          .slice(o - e + 1 + r, o + e + 2)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false")),
                    0 === i
                      ? t
                          .eq(t.length - 1 - n.options.slidesToShow)
                          .addClass("slick-center")
                      : i === n.slideCount - 1 &&
                        t.eq(n.options.slidesToShow).addClass("slick-center")),
                  n.$slides.eq(i).addClass("slick-center");
              } else
                i >= 0 && i <= n.slideCount - n.options.slidesToShow
                  ? n.$slides
                      .slice(i, i + n.options.slidesToShow)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : t.length <= n.options.slidesToShow
                  ? t.addClass("slick-active").attr("aria-hidden", "false")
                  : ((s = n.slideCount % n.options.slidesToShow),
                    (o =
                      !0 === n.options.infinite
                        ? n.options.slidesToShow + i
                        : i),
                    n.options.slidesToShow == n.options.slidesToScroll &&
                    n.slideCount - i < n.options.slidesToShow
                      ? t
                          .slice(o - (n.options.slidesToShow - s), o + s)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false")
                      : t
                          .slice(o, o + n.options.slidesToShow)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false"));
              ("ondemand" !== n.options.lazyLoad &&
                "anticipated" !== n.options.lazyLoad) ||
                n.lazyLoad();
            }),
            (e.prototype.setupInfinite = function () {
              var e,
                t,
                o,
                s = this;
              if (
                (!0 === s.options.fade && (s.options.centerMode = !1),
                !0 === s.options.infinite &&
                  !1 === s.options.fade &&
                  ((t = null), s.slideCount > s.options.slidesToShow))
              ) {
                for (
                  o =
                    !0 === s.options.centerMode
                      ? s.options.slidesToShow + 1
                      : s.options.slidesToShow,
                    e = s.slideCount;
                  e > s.slideCount - o;
                  e -= 1
                )
                  (t = e - 1),
                    i(s.$slides[t])
                      .clone(!0)
                      .attr("id", "")
                      .attr("data-slick-index", t - s.slideCount)
                      .prependTo(s.$slideTrack)
                      .addClass("slick-cloned");
                for (e = 0; e < o + s.slideCount; e += 1)
                  (t = e),
                    i(s.$slides[t])
                      .clone(!0)
                      .attr("id", "")
                      .attr("data-slick-index", t + s.slideCount)
                      .appendTo(s.$slideTrack)
                      .addClass("slick-cloned");
                s.$slideTrack
                  .find(".slick-cloned")
                  .find("[id]")
                  .each(function () {
                    i(this).attr("id", "");
                  });
              }
            }),
            (e.prototype.interrupt = function (i) {
              i || this.autoPlay(), (this.interrupted = i);
            }),
            (e.prototype.selectHandler = function (e) {
              var t = this,
                o = i(e.target).is(".slick-slide")
                  ? i(e.target)
                  : i(e.target).parents(".slick-slide"),
                s = parseInt(o.attr("data-slick-index"));
              s || (s = 0),
                t.slideCount <= t.options.slidesToShow
                  ? t.slideHandler(s, !1, !0)
                  : t.slideHandler(s);
            }),
            (e.prototype.slideHandler = function (i, e, t) {
              var o,
                s,
                n,
                r,
                l,
                d,
                a = this;
              if (
                ((e = e || !1),
                !(
                  (!0 === a.animating && !0 === a.options.waitForAnimate) ||
                  (!0 === a.options.fade && a.currentSlide === i)
                ))
              )
                if (
                  (!1 === e && a.asNavFor(i),
                  (o = i),
                  (l = a.getLeft(o)),
                  (r = a.getLeft(a.currentSlide)),
                  (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
                  !1 === a.options.infinite &&
                    !1 === a.options.centerMode &&
                    (i < 0 || i > a.getDotCount() * a.options.slidesToScroll))
                )
                  !1 === a.options.fade &&
                    ((o = a.currentSlide),
                    !0 !== t && a.slideCount > a.options.slidesToShow
                      ? a.animateSlide(r, function () {
                          a.postSlide(o);
                        })
                      : a.postSlide(o));
                else if (
                  !1 === a.options.infinite &&
                  !0 === a.options.centerMode &&
                  (i < 0 || i > a.slideCount - a.options.slidesToScroll)
                )
                  !1 === a.options.fade &&
                    ((o = a.currentSlide),
                    !0 !== t && a.slideCount > a.options.slidesToShow
                      ? a.animateSlide(r, function () {
                          a.postSlide(o);
                        })
                      : a.postSlide(o));
                else {
                  if (
                    (a.options.autoplay && clearInterval(a.autoPlayTimer),
                    (s =
                      o < 0
                        ? a.slideCount % a.options.slidesToScroll != 0
                          ? a.slideCount -
                            (a.slideCount % a.options.slidesToScroll)
                          : a.slideCount + o
                        : o >= a.slideCount
                        ? a.slideCount % a.options.slidesToScroll != 0
                          ? 0
                          : o - a.slideCount
                        : o),
                    (a.animating = !0),
                    a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
                    (n = a.currentSlide),
                    (a.currentSlide = s),
                    a.setSlideClasses(a.currentSlide),
                    a.options.asNavFor &&
                      (d = (d = a.getNavTarget()).slick("getSlick"))
                        .slideCount <= d.options.slidesToShow &&
                      d.setSlideClasses(a.currentSlide),
                    a.updateDots(),
                    a.updateArrows(),
                    !0 === a.options.fade)
                  )
                    return (
                      !0 !== t
                        ? (a.fadeSlideOut(n),
                          a.fadeSlide(s, function () {
                            a.postSlide(s);
                          }))
                        : a.postSlide(s),
                      void a.animateHeight()
                    );
                  !0 !== t && a.slideCount > a.options.slidesToShow
                    ? a.animateSlide(l, function () {
                        a.postSlide(s);
                      })
                    : a.postSlide(s);
                }
            }),
            (e.prototype.startLoad = function () {
              var i = this;
              !0 === i.options.arrows &&
                i.slideCount > i.options.slidesToShow &&
                (i.$prevArrow.hide(), i.$nextArrow.hide()),
                !0 === i.options.dots &&
                  i.slideCount > i.options.slidesToShow &&
                  i.$dots.hide(),
                i.$slider.addClass("slick-loading");
            }),
            (e.prototype.swipeDirection = function () {
              var i,
                e,
                t,
                o,
                s = this;
              return (
                (i = s.touchObject.startX - s.touchObject.curX),
                (e = s.touchObject.startY - s.touchObject.curY),
                (t = Math.atan2(e, i)),
                (o = Math.round((180 * t) / Math.PI)) < 0 &&
                  (o = 360 - Math.abs(o)),
                o <= 45 && o >= 0
                  ? !1 === s.options.rtl
                    ? "left"
                    : "right"
                  : o <= 360 && o >= 315
                  ? !1 === s.options.rtl
                    ? "left"
                    : "right"
                  : o >= 135 && o <= 225
                  ? !1 === s.options.rtl
                    ? "right"
                    : "left"
                  : !0 === s.options.verticalSwiping
                  ? o >= 35 && o <= 135
                    ? "down"
                    : "up"
                  : "vertical"
              );
            }),
            (e.prototype.swipeEnd = function (i) {
              var e,
                t,
                o = this;
              if (((o.dragging = !1), (o.swiping = !1), o.scrolling))
                return (o.scrolling = !1), !1;
              if (
                ((o.interrupted = !1),
                (o.shouldClick = !(o.touchObject.swipeLength > 10)),
                void 0 === o.touchObject.curX)
              )
                return !1;
              if (
                (!0 === o.touchObject.edgeHit &&
                  o.$slider.trigger("edge", [o, o.swipeDirection()]),
                o.touchObject.swipeLength >= o.touchObject.minSwipe)
              ) {
                switch ((t = o.swipeDirection())) {
                  case "left":
                  case "down":
                    (e = o.options.swipeToSlide
                      ? o.checkNavigable(o.currentSlide + o.getSlideCount())
                      : o.currentSlide + o.getSlideCount()),
                      (o.currentDirection = 0);
                    break;
                  case "right":
                  case "up":
                    (e = o.options.swipeToSlide
                      ? o.checkNavigable(o.currentSlide - o.getSlideCount())
                      : o.currentSlide - o.getSlideCount()),
                      (o.currentDirection = 1);
                }
                "vertical" != t &&
                  (o.slideHandler(e),
                  (o.touchObject = {}),
                  o.$slider.trigger("swipe", [o, t]));
              } else
                o.touchObject.startX !== o.touchObject.curX &&
                  (o.slideHandler(o.currentSlide), (o.touchObject = {}));
            }),
            (e.prototype.swipeHandler = function (i) {
              var e = this;
              if (
                !(
                  !1 === e.options.swipe ||
                  ("ontouchend" in document && !1 === e.options.swipe) ||
                  (!1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))
                )
              )
                switch (
                  ((e.touchObject.fingerCount =
                    i.originalEvent && void 0 !== i.originalEvent.touches
                      ? i.originalEvent.touches.length
                      : 1),
                  (e.touchObject.minSwipe =
                    e.listWidth / e.options.touchThreshold),
                  !0 === e.options.verticalSwiping &&
                    (e.touchObject.minSwipe =
                      e.listHeight / e.options.touchThreshold),
                  i.data.action)
                ) {
                  case "start":
                    e.swipeStart(i);
                    break;
                  case "move":
                    e.swipeMove(i);
                    break;
                  case "end":
                    e.swipeEnd(i);
                }
            }),
            (e.prototype.swipeMove = function (i) {
              var e,
                t,
                o,
                s,
                n,
                r,
                l = this;
              return (
                (n =
                  void 0 !== i.originalEvent ? i.originalEvent.touches : null),
                !(!l.dragging || l.scrolling || (n && 1 !== n.length)) &&
                  ((e = l.getLeft(l.currentSlide)),
                  (l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
                  (l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
                  (l.touchObject.swipeLength = Math.round(
                    Math.sqrt(
                      Math.pow(l.touchObject.curX - l.touchObject.startX, 2),
                    ),
                  )),
                  (r = Math.round(
                    Math.sqrt(
                      Math.pow(l.touchObject.curY - l.touchObject.startY, 2),
                    ),
                  )),
                  !l.options.verticalSwiping && !l.swiping && r > 4
                    ? ((l.scrolling = !0), !1)
                    : (!0 === l.options.verticalSwiping &&
                        (l.touchObject.swipeLength = r),
                      (t = l.swipeDirection()),
                      void 0 !== i.originalEvent &&
                        l.touchObject.swipeLength > 4 &&
                        ((l.swiping = !0), i.preventDefault()),
                      (s =
                        (!1 === l.options.rtl ? 1 : -1) *
                        (l.touchObject.curX > l.touchObject.startX ? 1 : -1)),
                      !0 === l.options.verticalSwiping &&
                        (s =
                          l.touchObject.curY > l.touchObject.startY ? 1 : -1),
                      (o = l.touchObject.swipeLength),
                      (l.touchObject.edgeHit = !1),
                      !1 === l.options.infinite &&
                        ((0 === l.currentSlide && "right" === t) ||
                          (l.currentSlide >= l.getDotCount() &&
                            "left" === t)) &&
                        ((o =
                          l.touchObject.swipeLength * l.options.edgeFriction),
                        (l.touchObject.edgeHit = !0)),
                      !1 === l.options.vertical
                        ? (l.swipeLeft = e + o * s)
                        : (l.swipeLeft =
                            e + o * (l.$list.height() / l.listWidth) * s),
                      !0 === l.options.verticalSwiping &&
                        (l.swipeLeft = e + o * s),
                      !0 !== l.options.fade &&
                        !1 !== l.options.touchMove &&
                        (!0 === l.animating
                          ? ((l.swipeLeft = null), !1)
                          : void l.setCSS(l.swipeLeft))))
              );
            }),
            (e.prototype.swipeStart = function (i) {
              var e,
                t = this;
              if (
                ((t.interrupted = !0),
                1 !== t.touchObject.fingerCount ||
                  t.slideCount <= t.options.slidesToShow)
              )
                return (t.touchObject = {}), !1;
              void 0 !== i.originalEvent &&
                void 0 !== i.originalEvent.touches &&
                (e = i.originalEvent.touches[0]),
                (t.touchObject.startX = t.touchObject.curX =
                  void 0 !== e ? e.pageX : i.clientX),
                (t.touchObject.startY = t.touchObject.curY =
                  void 0 !== e ? e.pageY : i.clientY),
                (t.dragging = !0);
            }),
            (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
              function () {
                var i = this;
                null !== i.$slidesCache &&
                  (i.unload(),
                  i.$slideTrack.children(this.options.slide).detach(),
                  i.$slidesCache.appendTo(i.$slideTrack),
                  i.reinit());
              }),
            (e.prototype.unload = function () {
              var e = this;
              i(".slick-cloned", e.$slider).remove(),
                e.$dots && e.$dots.remove(),
                e.$prevArrow &&
                  e.htmlExpr.test(e.options.prevArrow) &&
                  e.$prevArrow.remove(),
                e.$nextArrow &&
                  e.htmlExpr.test(e.options.nextArrow) &&
                  e.$nextArrow.remove(),
                e.$slides
                  .removeClass(
                    "slick-slide slick-active slick-visible slick-current",
                  )
                  .attr("aria-hidden", "true")
                  .css("width", "");
            }),
            (e.prototype.unslick = function (i) {
              var e = this;
              e.$slider.trigger("unslick", [e, i]), e.destroy();
            }),
            (e.prototype.updateArrows = function () {
              var i = this;
              Math.floor(i.options.slidesToShow / 2),
                !0 === i.options.arrows &&
                  i.slideCount > i.options.slidesToShow &&
                  !i.options.infinite &&
                  (i.$prevArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false"),
                  i.$nextArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false"),
                  0 === i.currentSlide
                    ? (i.$prevArrow
                        .addClass("slick-disabled")
                        .attr("aria-disabled", "true"),
                      i.$nextArrow
                        .removeClass("slick-disabled")
                        .attr("aria-disabled", "false"))
                    : i.currentSlide >= i.slideCount - i.options.slidesToShow &&
                      !1 === i.options.centerMode
                    ? (i.$nextArrow
                        .addClass("slick-disabled")
                        .attr("aria-disabled", "true"),
                      i.$prevArrow
                        .removeClass("slick-disabled")
                        .attr("aria-disabled", "false"))
                    : i.currentSlide >= i.slideCount - 1 &&
                      !0 === i.options.centerMode &&
                      (i.$nextArrow
                        .addClass("slick-disabled")
                        .attr("aria-disabled", "true"),
                      i.$prevArrow
                        .removeClass("slick-disabled")
                        .attr("aria-disabled", "false")));
            }),
            (e.prototype.updateDots = function () {
              var i = this;
              null !== i.$dots &&
                (i.$dots.find("li").removeClass("slick-active").end(),
                i.$dots
                  .find("li")
                  .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
                  .addClass("slick-active"));
            }),
            (e.prototype.visibility = function () {
              var i = this;
              i.options.autoplay &&
                (document[i.hidden]
                  ? (i.interrupted = !0)
                  : (i.interrupted = !1));
            }),
            (i.fn.slick = function () {
              var i,
                t,
                o = this,
                s = arguments[0],
                n = Array.prototype.slice.call(arguments, 1),
                r = o.length;
              for (i = 0; i < r; i++)
                if (
                  ("object" == typeof s || void 0 === s
                    ? (o[i].slick = new e(o[i], s))
                    : (t = o[i].slick[s].apply(o[i].slick, n)),
                  void 0 !== t)
                )
                  return t;
              return o;
            });
        });
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "modules/product/slider.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = t);
        var e = s(require("jquery"));
        function s(e) {
          return e && e.__esModule ? e : { default: e };
        }
        function t() {
          var s = (0, e.default)("[data-ps]");
          if (s.length) {
            s.on("init", function () {
              s.addClass("is-visible");
            });
            s.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: !0,
              dots: !0,
              adaptiveHeight: !0,
              nextArrow:
                '<button class="slick-arrow slick-next"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M501.333,245.333H36.417l141.792-141.792c4.167-4.167,4.167-10.917,0-15.083c-4.167-4.167-10.917-4.167-15.083,0l-160,160c-4.167,4.167-4.167,10.917,0,15.083l160,160c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125c4.167-4.167,4.167-10.917,0-15.083L36.417,266.667h464.917c5.896,0,10.667-4.771,10.667-10.667S507.229,245.333,501.333,245.333z"/></g></g></svg></button>',
              prevArrow:
                '<button class="slick-arrow slick-prev"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M501.333,245.333H36.417l141.792-141.792c4.167-4.167,4.167-10.917,0-15.083c-4.167-4.167-10.917-4.167-15.083,0l-160,160c-4.167,4.167-4.167,10.917,0,15.083l160,160c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125c4.167-4.167,4.167-10.917,0-15.083L36.417,266.667h464.917c5.896,0,10.667-4.771,10.667-10.667S507.229,245.333,501.333,245.333z"/></g></g></svg></button>',
            });
            s.find(".slick-slide").each(function () {
              (0, e.default)(this)
                .find(".video_wrapper video")
                .on("ended", function () {
                  (0, e.default)(this)
                    .closest(".video_wrapper")
                    .attr("data-play", "false");
                });
            });
          }
        }
        require("slick-carousel");
      },
      {
        jquery: "../node_modules/jquery/dist/jquery.js",
        "slick-carousel": "../node_modules/slick-carousel/slick/slick.js",
      },
    ],
    "tools/moneyFormats.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.formatMoney = t);
        var o = {
          USD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} USD",
          },
          EUR: {
            money_format: "&euro;{{amount}}",
            money_with_currency_format: "&euro;{{amount}} EUR",
          },
          GBP: {
            money_format: "&pound;{{amount}}",
            money_with_currency_format: "&pound;{{amount}} GBP",
          },
          CAD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} CAD",
          },
          ALL: {
            money_format: "Lek {{amount}}",
            money_with_currency_format: "Lek {{amount}} ALL",
          },
          DZD: {
            money_format: "DA {{amount}}",
            money_with_currency_format: "DA {{amount}} DZD",
          },
          AOA: {
            money_format: "Kz{{amount}}",
            money_with_currency_format: "Kz{{amount}} AOA",
          },
          ARS: {
            money_format: "${{amount_with_comma_separator}}",
            money_with_currency_format: "${{amount_with_comma_separator}} ARS",
          },
          AMD: {
            money_format: "{{amount}} AMD",
            money_with_currency_format: "{{amount}} AMD",
          },
          AWG: {
            money_format: "Afl{{amount}}",
            money_with_currency_format: "Afl{{amount}} AWG",
          },
          AUD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} AUD",
          },
          BBD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} Bds",
          },
          AZN: {
            money_format: "m.{{amount}}",
            money_with_currency_format: "m.{{amount}} AZN",
          },
          BDT: {
            money_format: "Tk {{amount}}",
            money_with_currency_format: "Tk {{amount}} BDT",
          },
          BSD: {
            money_format: "BS${{amount}}",
            money_with_currency_format: "BS${{amount}} BSD",
          },
          BHD: {
            money_format: "{{amount}}0 BD",
            money_with_currency_format: "{{amount}}0 BHD",
          },
          BYR: {
            money_format: "Br {{amount}}",
            money_with_currency_format: "Br {{amount}} BYR",
          },
          BZD: {
            money_format: "BZ${{amount}}",
            money_with_currency_format: "BZ${{amount}} BZD",
          },
          BTN: {
            money_format: "Nu {{amount}}",
            money_with_currency_format: "Nu {{amount}} BTN",
          },
          BAM: {
            money_format: "KM {{amount_with_comma_separator}}",
            money_with_currency_format:
              "KM {{amount_with_comma_separator}} BAM",
          },
          BRL: {
            money_format: "R$ {{amount_with_comma_separator}}",
            money_with_currency_format:
              "R$ {{amount_with_comma_separator}} BRL",
          },
          BOB: {
            money_format: "Bs{{amount_with_comma_separator}}",
            money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB",
          },
          BWP: {
            money_format: "P{{amount}}",
            money_with_currency_format: "P{{amount}} BWP",
          },
          BND: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} BND",
          },
          BGN: {
            money_format: "{{amount}} лв",
            money_with_currency_format: "{{amount}} лв BGN",
          },
          MMK: {
            money_format: "K{{amount}}",
            money_with_currency_format: "K{{amount}} MMK",
          },
          KHR: {
            money_format: "KHR{{amount}}",
            money_with_currency_format: "KHR{{amount}}",
          },
          KYD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} KYD",
          },
          XAF: {
            money_format: "FCFA{{amount}}",
            money_with_currency_format: "FCFA{{amount}} XAF",
          },
          CLP: {
            money_format: "${{amount_no_decimals}}",
            money_with_currency_format: "${{amount_no_decimals}} CLP",
          },
          CNY: {
            money_format: "&#165;{{amount}}",
            money_with_currency_format: "&#165;{{amount}} CNY",
          },
          COP: {
            money_format: "${{amount_with_comma_separator}}",
            money_with_currency_format: "${{amount_with_comma_separator}} COP",
          },
          CRC: {
            money_format: "&#8353; {{amount_with_comma_separator}}",
            money_with_currency_format:
              "&#8353; {{amount_with_comma_separator}} CRC",
          },
          HRK: {
            money_format: "{{amount_with_comma_separator}} kn",
            money_with_currency_format:
              "{{amount_with_comma_separator}} kn HRK",
          },
          CZK: {
            money_format: "{{amount_with_comma_separator}} K&#269;",
            money_with_currency_format:
              "{{amount_with_comma_separator}} K&#269;",
          },
          DKK: {
            money_format: "{{amount_with_comma_separator}}",
            money_with_currency_format: "kr.{{amount_with_comma_separator}}",
          },
          DOP: {
            money_format: "RD$ {{amount}}",
            money_with_currency_format: "RD$ {{amount}}",
          },
          XCD: {
            money_format: "${{amount}}",
            money_with_currency_format: "EC${{amount}}",
          },
          EGP: {
            money_format: "LE {{amount}}",
            money_with_currency_format: "LE {{amount}} EGP",
          },
          ETB: {
            money_format: "Br{{amount}}",
            money_with_currency_format: "Br{{amount}} ETB",
          },
          XPF: {
            money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
            money_with_currency_format:
              "{{amount_no_decimals_with_comma_separator}} XPF",
          },
          FJD: {
            money_format: "${{amount}}",
            money_with_currency_format: "FJ${{amount}}",
          },
          GMD: {
            money_format: "D {{amount}}",
            money_with_currency_format: "D {{amount}} GMD",
          },
          GHS: {
            money_format: "GH&#8373;{{amount}}",
            money_with_currency_format: "GH&#8373;{{amount}}",
          },
          GTQ: {
            money_format: "Q{{amount}}",
            money_with_currency_format: "{{amount}} GTQ",
          },
          GYD: {
            money_format: "G${{amount}}",
            money_with_currency_format: "${{amount}} GYD",
          },
          GEL: {
            money_format: "{{amount}} GEL",
            money_with_currency_format: "{{amount}} GEL",
          },
          HNL: {
            money_format: "L {{amount}}",
            money_with_currency_format: "L {{amount}} HNL",
          },
          HKD: {
            money_format: "${{amount}}",
            money_with_currency_format: "HK${{amount}}",
          },
          HUF: {
            money_format: "{{amount_no_decimals_with_comma_separator}}",
            money_with_currency_format:
              "{{amount_no_decimals_with_comma_separator}} Ft",
          },
          ISK: {
            money_format: "{{amount_no_decimals}} kr",
            money_with_currency_format: "{{amount_no_decimals}} kr ISK",
          },
          INR: {
            money_format: "Rs. {{amount}}",
            money_with_currency_format: "Rs. {{amount}}",
          },
          IDR: {
            money_format: "{{amount_with_comma_separator}}",
            money_with_currency_format: "Rp {{amount_with_comma_separator}}",
          },
          ILS: {
            money_format: "{{amount}} NIS",
            money_with_currency_format: "{{amount}} NIS",
          },
          JMD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} JMD",
          },
          JPY: {
            money_format: "&#165;{{amount_no_decimals}}",
            money_with_currency_format: "&#165;{{amount_no_decimals}} JPY",
          },
          JEP: {
            money_format: "&pound;{{amount}}",
            money_with_currency_format: "&pound;{{amount}} JEP",
          },
          JOD: {
            money_format: "{{amount}}0 JD",
            money_with_currency_format: "{{amount}}0 JOD",
          },
          KZT: {
            money_format: "{{amount}} KZT",
            money_with_currency_format: "{{amount}} KZT",
          },
          KES: {
            money_format: "KSh{{amount}}",
            money_with_currency_format: "KSh{{amount}}",
          },
          KWD: {
            money_format: "{{amount}}0 KD",
            money_with_currency_format: "{{amount}}0 KWD",
          },
          KGS: {
            money_format: "лв{{amount}}",
            money_with_currency_format: "лв{{amount}}",
          },
          LVL: {
            money_format: "Ls {{amount}}",
            money_with_currency_format: "Ls {{amount}} LVL",
          },
          LBP: {
            money_format: "L&pound;{{amount}}",
            money_with_currency_format: "L&pound;{{amount}} LBP",
          },
          LTL: {
            money_format: "{{amount}} Lt",
            money_with_currency_format: "{{amount}} Lt",
          },
          MGA: {
            money_format: "Ar {{amount}}",
            money_with_currency_format: "Ar {{amount}} MGA",
          },
          MKD: {
            money_format: "ден {{amount}}",
            money_with_currency_format: "ден {{amount}} MKD",
          },
          MOP: {
            money_format: "MOP${{amount}}",
            money_with_currency_format: "MOP${{amount}}",
          },
          MVR: {
            money_format: "Rf{{amount}}",
            money_with_currency_format: "Rf{{amount}} MRf",
          },
          MXN: {
            money_format: "$ {{amount}}",
            money_with_currency_format: "$ {{amount}} MXN",
          },
          MYR: {
            money_format: "RM{{amount}} MYR",
            money_with_currency_format: "RM{{amount}} MYR",
          },
          MUR: {
            money_format: "Rs {{amount}}",
            money_with_currency_format: "Rs {{amount}} MUR",
          },
          MDL: {
            money_format: "{{amount}} MDL",
            money_with_currency_format: "{{amount}} MDL",
          },
          MAD: {
            money_format: "{{amount}} dh",
            money_with_currency_format: "Dh {{amount}} MAD",
          },
          MNT: {
            money_format: "{{amount_no_decimals}} &#8366",
            money_with_currency_format: "{{amount_no_decimals}} MNT",
          },
          MZN: {
            money_format: "{{amount}} Mt",
            money_with_currency_format: "Mt {{amount}} MZN",
          },
          NAD: {
            money_format: "N${{amount}}",
            money_with_currency_format: "N${{amount}} NAD",
          },
          NPR: {
            money_format: "Rs{{amount}}",
            money_with_currency_format: "Rs{{amount}} NPR",
          },
          ANG: {
            money_format: "&fnof;{{amount}}",
            money_with_currency_format: "{{amount}} NA&fnof;",
          },
          NZD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} NZD",
          },
          NIO: {
            money_format: "C${{amount}}",
            money_with_currency_format: "C${{amount}} NIO",
          },
          NGN: {
            money_format: "&#8358;{{amount}}",
            money_with_currency_format: "&#8358;{{amount}} NGN",
          },
          NOK: {
            money_format: "kr {{amount_with_comma_separator}}",
            money_with_currency_format:
              "kr {{amount_with_comma_separator}} NOK",
          },
          OMR: {
            money_format: "{{amount_with_comma_separator}} OMR",
            money_with_currency_format: "{{amount_with_comma_separator}} OMR",
          },
          PKR: {
            money_format: "Rs.{{amount}}",
            money_with_currency_format: "Rs.{{amount}} PKR",
          },
          PGK: {
            money_format: "K {{amount}}",
            money_with_currency_format: "K {{amount}} PGK",
          },
          PYG: {
            money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
            money_with_currency_format:
              "Gs. {{amount_no_decimals_with_comma_separator}} PYG",
          },
          PEN: {
            money_format: "S/. {{amount}}",
            money_with_currency_format: "S/. {{amount}} PEN",
          },
          PHP: {
            money_format: "&#8369;{{amount}}",
            money_with_currency_format: "&#8369;{{amount}} PHP",
          },
          PLN: {
            money_format: "{{amount_with_comma_separator}} zl",
            money_with_currency_format:
              "{{amount_with_comma_separator}} zl PLN",
          },
          QAR: {
            money_format: "QAR {{amount_with_comma_separator}}",
            money_with_currency_format: "QAR {{amount_with_comma_separator}}",
          },
          RON: {
            money_format: "{{amount_with_comma_separator}} lei",
            money_with_currency_format:
              "{{amount_with_comma_separator}} lei RON",
          },
          RUB: {
            money_format:
              "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
            money_with_currency_format:
              "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB",
          },
          RWF: {
            money_format: "{{amount_no_decimals}} RF",
            money_with_currency_format: "{{amount_no_decimals}} RWF",
          },
          WST: {
            money_format: "WS$ {{amount}}",
            money_with_currency_format: "WS$ {{amount}} WST",
          },
          SAR: {
            money_format: "{{amount}} SR",
            money_with_currency_format: "{{amount}} SAR",
          },
          STD: {
            money_format: "Db {{amount}}",
            money_with_currency_format: "Db {{amount}} STD",
          },
          RSD: {
            money_format: "{{amount}} RSD",
            money_with_currency_format: "{{amount}} RSD",
          },
          SCR: {
            money_format: "Rs {{amount}}",
            money_with_currency_format: "Rs {{amount}} SCR",
          },
          SGD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} SGD",
          },
          SYP: {
            money_format: "S&pound;{{amount}}",
            money_with_currency_format: "S&pound;{{amount}} SYP",
          },
          ZAR: {
            money_format: "R {{amount}}",
            money_with_currency_format: "R {{amount}} ZAR",
          },
          KRW: {
            money_format: "&#8361;{{amount_no_decimals}}",
            money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW",
          },
          LKR: {
            money_format: "Rs {{amount}}",
            money_with_currency_format: "Rs {{amount}} LKR",
          },
          SEK: {
            money_format: "{{amount_no_decimals}} kr",
            money_with_currency_format: "{{amount_no_decimals}} kr SEK",
          },
          CHF: {
            money_format: "SFr. {{amount}}",
            money_with_currency_format: "SFr. {{amount}} CHF",
          },
          TWD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} TWD",
          },
          THB: {
            money_format: "{{amount}} &#xe3f;",
            money_with_currency_format: "{{amount}} &#xe3f; THB",
          },
          TZS: {
            money_format: "{{amount}} TZS",
            money_with_currency_format: "{{amount}} TZS",
          },
          TTD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} TTD",
          },
          TND: {
            money_format: "{{amount}}",
            money_with_currency_format: "{{amount}} DT",
          },
          TRY: {
            money_format: "{{amount}}TL",
            money_with_currency_format: "{{amount}}TL",
          },
          UGX: {
            money_format: "Ush {{amount_no_decimals}}",
            money_with_currency_format: "Ush {{amount_no_decimals}} UGX",
          },
          UAH: {
            money_format: "₴{{amount}}",
            money_with_currency_format: "₴{{amount}} UAH",
          },
          AED: {
            money_format: "Dhs. {{amount}}",
            money_with_currency_format: "Dhs. {{amount}} AED",
          },
          UYU: {
            money_format: "${{amount_with_comma_separator}}",
            money_with_currency_format: "${{amount_with_comma_separator}} UYU",
          },
          VUV: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}}VT",
          },
          VEF: {
            money_format: "Bs. {{amount_with_comma_separator}}",
            money_with_currency_format:
              "Bs. {{amount_with_comma_separator}} VEF",
          },
          VND: {
            money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
            money_with_currency_format:
              "{{amount_no_decimals_with_comma_separator}} VND",
          },
          XBT: {
            money_format: "{{amount_no_decimals}} BTC",
            money_with_currency_format: "{{amount_no_decimals}} BTC",
          },
          XOF: {
            money_format: "CFA{{amount}}",
            money_with_currency_format: "CFA{{amount}} XOF",
          },
          ZMW: {
            money_format: "K{{amount_no_decimals_with_comma_separator}}",
            money_with_currency_format:
              "ZMW{{amount_no_decimals_with_comma_separator}}",
          },
        };
        function m(o) {
          var m =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : 2,
            t =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : ",",
            a =
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : ".";
          if (isNaN(o) || !o) return 0;
          var _ = (o / 100).toFixed(m).split(t);
          return (
            _[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(t)) +
            (_[1] ? a + _[1] : "")
          );
        }
        function t(o, t) {
          "string" == typeof o && (o = o.replace(".", ""));
          var a = t || window.theme.money_format || "${{amount}}",
            _ = "",
            n = /\{\{\s*(\w+)\s*\}\}/;
          switch (a.match(n)[1]) {
            case "amount":
              _ = m(o, 2, ",", ".");
              break;
            case "amount_with_space_separator":
              _ = m(o, 2, " ", ".");
              break;
            case "amount_with_comma_separator":
              _ = m(o, 2, ".", ",");
              break;
            case "amount_with_apostrophe_separator":
              _ = m(o, 2, "'", ".");
              break;
            case "amount_no_decimals":
              _ = m(o, 0, ",", ".");
              break;
            case "amount_no_decimals_with_space_separator":
              _ = m(o, 0, " ", ".");
              break;
            case "amount_no_decimals_with_comma_separator":
              _ = m(o, 0, ",", ".");
          }
          return a.replace(n, _);
        }
        function a(o, m, t) {
          return -1 !== m.indexOf("amount_no_decimals")
            ? 100 * o
            : "JOD" === t || "KWD" === t || "BHD" === t
            ? o / 10
            : o;
        }
        function _(o) {
          var m = o.getAttribute("data-currency-original") || o.textContent,
            t = parseInt(m.replace(/[^0-9]/g, ""), 10);
          return isNaN(t) ? "" : t;
        }
      },
      {},
    ],
    "modules/product/swatches.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = f);
        var t = e(require("jquery")),
          a = require("/tools/moneyFormats");
        function e(t) {
          return t && t.__esModule ? t : { default: t };
        }
        var d = (0, t.default)("[data-all-variants]"),
          o = (0, t.default)("[data-product-option]"),
          i = (0, t.default)("[data-qty]"),
          n = function (a) {
            var e = (0, t.default)(
              "option:selected",
              a.find("[data-all-variants]"),
            );
            l(e, a), u(e, a), r(e, a), s(e, a), c(e, a);
          },
          l = function (t, e) {
            var d = e.find("[data-price]"),
              o = e.find("[data-price-compare]"),
              i = t.data("variant-price"),
              n = t.data("variant-compare-price");
            d.text((0, a.formatMoney)(i)),
              n > 0 ? o.text((0, a.formatMoney)(n)).show() : o.hide();
          },
          r = function (t, e) {
            var d = e.find("[data-add-to-cart]"),
              o = d.find("span label:first-child");
            if (
              (d
                .find("span label.variant_name")
                .text("(" + t.attr("data-option1") + ")"),
              "" != t.data("subscription-id"))
            ) {
              var i = window.theme.strings.recharge;
              if (
                (console.log(
                  " problem is here below - need to determine when should this fire",
                ),
                -1 != t.data("product-handle").indexOf("annual"))
              )
                i += " - " + (0, a.formatMoney)(t.data("variant-price"));
              d.attr("disabled", !1).text(i);
            } else if (1 == t.data("available"))
              if (
                "continue" == t.data("inventory-policy") &&
                t.data("inventory-quantity") <= 0
              )
                d.attr("disabled", !1), o.text(window.theme.strings.preOrder);
              else {
                var n;
                t.attr("data-option1");
                console.log(t.attr("data-prevent-v-name")),
                  (n =
                    (t.attr("data-prevent-v-name"),
                    window.theme.strings.addToCart)),
                  d.attr("disabled", !1),
                  o.text(n);
              }
            else d.attr("disabled", !0), o.text(window.theme.strings.soldOut);
          },
          c = function (e, d) {
            var o = d.find(".product-info__top-label").find("span");
            if (
              -1 != e.data("product-handle").indexOf("annual") &&
              "" != e.data("subscription-id") &&
              o.length
            ) {
              var i = window.theme.strings.recharge;
              (i += " - " + (0, a.formatMoney)(e.data("variant-price"))),
                (i = (0, t.default)("<b>".concat(i, "</b>"))),
                o.html(i);
            }
          },
          s = function (t, a) {
            var e = a.find("[data-low-stock]");
            t.data("available") ? e.removeClass("hide") : e.addClass("hide");
          },
          u = function (a, e) {
            (0, t.default)("[data-product-option=1]").each(function (a, e) {
              var d = (0, t.default)(this).closest("[data-product-form]"),
                o = !0,
                i = (0, t.default)(e).val();
              d
                .find("[data-all-variants]")
                .find("option")
                .each(function (a, e) {
                  (0, t.default)(e).data("option1") == i &&
                    1 == (0, t.default)(e).data("available") &&
                    (o = !1);
                }),
                o && (0, t.default)(e).addClass("is-disabled");
            });
            var d = a.data("option1");
            e.find("[data-all-variants]")
              .find("option")
              .each(function (a, e) {
                if ((0, t.default)(e).data("option1") == d) {
                  var o = (0, t.default)(e).data("option2"),
                    i = (0, t.default)(
                      "[data-product-option=2][value='".concat(o, "']"),
                    ),
                    n = (0, t.default)(e).data("option3"),
                    l = (0, t.default)(
                      "[data-product-option=3][value='".concat(n, "']"),
                    );
                  0 == (0, t.default)(e).data("available")
                    ? ((0, t.default)(o).addClass("is-disabled"),
                      (0, t.default)(n).addClass("is-disabled"))
                    : (i.attr("disabled", !1), l.attr("disabled", !1));
                }
              });
          };
        function f() {
          (0, t.default)(document).on(
            "click",
            "#variant-selector .selected_option",
            function () {
              (0, t.default)(this)
                .closest(".option_list")
                .find(".option")
                .removeClass("selected"),
                (0, t.default)(this).addClass("selected");
              var a = (0, t.default)(this).attr("data-value");
              (0, t.default)(this)
                .closest(".product-options__list")
                .find('.product-option input[value="' + a + '"]')
                .click(),
                (0, t.default)(this)
                  .closest("#variant-selector")
                  .removeClass("active"),
                (0, t.default)(this)
                  .closest("#variant-selector")
                  .find(".selected_option")
                  .text((0, t.default)(this).text());
            },
          );
          var e = (0, t.default)(".rc_container_wrapper.custom_widget");
          if (
            ((0, t.default)(document).on(
              "click",
              ".product-options__list .product-option__label",
              function () {
                (0, t.default)(".rc_container_wrapper");
                setTimeout(function () {
                  var d =
                      100 -
                      parseInt(
                        e
                          .find(".rc_widget__option__discount")
                          .text()
                          .replace("%", ""),
                      ),
                    o = parseFloat(
                      (0, t.default)(
                        "form#addToCartForm select[data-all-variants] option:selected",
                      ).attr("data-variant-price"),
                    ),
                    i = (0, a.formatMoney)((o * d) / 100);
                  e
                    .find(
                      "[data-option-onetime] [data-selector-onetime] [data-price-onetime]",
                    )
                    .text((0, a.formatMoney)(o)),
                    e
                      .find(
                        "[data-option-subsave] [data-selector-subsave] [data-price-subsave]",
                      )
                      .text(i);
                }, 300);
              },
            ),
            (0, t.default)(document).on(
              "click",
              "#variant-selector .option_list .option",
              function () {
                "sampack" == (0, t.default)(this).attr("data-value") &&
                  setTimeout(function () {
                    var d = parseInt(
                        e
                          .find(".rc_widget__option__discount")
                          .text()
                          .replace("%", ""),
                      ),
                      o = 100 - d;
                    console.log("percent: " + d);
                    var i = parseFloat(
                        (0, t.default)(
                          "form#addToCartForm select[data-all-variants] option:selected",
                        ).attr("data-variant-price"),
                      ),
                      n = (0, a.formatMoney)((i * o) / 100);
                    e
                      .find(
                        "[data-option-onetime] [data-selector-onetime] [data-price-onetime]",
                      )
                      .text((0, a.formatMoney)(i)),
                      e
                        .find(
                          "[data-option-subsave] [data-selector-subsave] [data-price-subsave]",
                        )
                        .text(n);
                  }, 300);
              },
            ),
            d.on("change", function () {
              n((0, t.default)(this).closest("[data-product-form]"));
            }),
            i.on("change", function () {
              n((0, t.default)(this).closest("[data-product-form]"));
            }),
            o.on("click", function () {
              var a = (0, t.default)("[data-product-option=1]:checked").length
                  ? (0, t.default)("[data-product-option=1]:checked").val()
                  : "_BLANK_",
                e = (0, t.default)("[data-product-option=2]:checked").length
                  ? (0, t.default)("[data-product-option=2]:checked").val()
                  : "_BLANK_",
                o = (0, t.default)("[data-product-option=3]:checked").length
                  ? (0, t.default)("[data-product-option=3]:checked").val()
                  : "_BLANK_";
              (0, t.default)(this).data("variant-href") &&
                (document.location.href = (0, t.default)(this).data(
                  "variant-href",
                )),
                console.log(a, e, o),
                localStorage.setItem(
                  "selectedVariantIndex",
                  (0, t.default)(this).data("variant-index"),
                ),
                localStorage.setItem(
                  "selectedVariantId",
                  (0, t.default)(this).data("variant-id"),
                ),
                (0, t.default)("[data-sticky-atc]").attr(
                  "data-variant-id",
                  (0, t.default)(this).data("variant-id"),
                ),
                (0, t.default)("[data-sticky-atc] span").removeClass(
                  "is-active",
                ),
                (0, t.default)(
                  "[data-sticky-atc] [data-variant-index=" +
                    (0, t.default)(this).data("variant-index") +
                    "]",
                ).addClass("is-active");
              var i = d
                .find(
                  "[data-option1='"
                    .concat(a, "'][data-option2='")
                    .concat(e, "'][data-option3='")
                    .concat(o, "']"),
                )
                .val();
              d.val(i).trigger("change"),
                console.log("variantselector value", d.val());
              var n = (0, t.default)(this).attr("data-variant-id");
              (0, t.default)(this)
                .closest("form")
                .find('input[name="id"]')
                .val(n);
            }),
            (0, t.default)("form#addToCartForm select#variant-selector").change(
              function () {
                var a = (0, t.default)(this).val();
                (0, t.default)(this)
                  .closest(".product-options__list")
                  .find('.product-option input[value="' + a + '"]')
                  .click();
              },
            ),
            (0, t.default)(document).on(
              "click",
              "[data-widget-container-wrapper] .rc_widget[data-widget] .rc_widget__option",
              function () {
                (0, t.default)(this)
                  .closest(".rc_widget[data-widget]")
                  .find('input[type="radio"]')
                  .prop("checked", !1),
                  (0, t.default)(this)
                    .find('input[type="radio"]')
                    .prop("checked", !0),
                  (0, t.default)(this)
                    .closest(".rc_widget[data-widget]")
                    .find(".rc_widget__option")
                    .removeClass("active")
                    .addClass("normal"),
                  (0, t.default)(this).removeClass("normal").addClass("active");
              },
            ),
            window.productTemplateLoaded)
          ) {
            if (window.self !== window.top);
            else {
              var l = localStorage.getItem("selectedVariantIndex");
              localStorage.getItem("selectedVariantId");
              parseInt(l) > 0 && parseInt(l);
            }
            n((0, t.default)(".product-main").find("[data-product-form]"));
          }
        }
      },
      {
        jquery: "../node_modules/jquery/dist/jquery.js",
        "/tools/moneyFormats": "tools/moneyFormats.js",
      },
    ],
    "modules/slider.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = a),
          (exports.mountSlider = void 0);
        var t = o(require("jquery"));
        function o(t) {
          return t && t.__esModule ? t : { default: t };
        }
        function e(t) {
          return (e =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                  return typeof t;
                }
              : function (t) {
                  return t &&
                    "function" == typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : typeof t;
                })(t);
        }
        require("slick-carousel");
        var i = function (o, i, a) {
          if (void 0 === o)
            return console.error("Can't mount undefined slider"), !1;
          if (
            "1" == o.data("desktop-only") &&
            (0, t.default)(window).width() <= 989
          )
            return !1;
          if (
            "1" == o.data("mobile-only") &&
            (0, t.default)(window).width() > 989
          )
            return !1;
          "function" == typeof i && o.on("init", i);
          var s = o.parent().find(".slider-controls"),
            d = {
              slidesToShow: o.data("slides-to-show") || 1,
              slidesToScroll: o.data("slides-to-scroll") || 1,
              draggable: 0 != o.data("draggable"),
              infinite: 0 != o.data("infinite"),
              adaptiveHeight: 1 == o.data("adaptive-height"),
              arrows: 0 != o.data("arrows"),
              dots: 0 != o.data("dots"),
              autoplay: 1 == o.data("autoplay"),
              centerMode: 1 == o.data("centermode"),
            };
          if (
            ("1" == o.data("custom-controls") &&
              ((d.appendDots = s.find("[data-hor-slider-dots]")),
              (d.prevArrow = s.find("[data-hor-slider-prev]")),
              (d.nextArrow = s.find("[data-hor-slider-next]"))),
            "1" == o.data("custom-dots") &&
              (d.appendDots = s.find("[data-hor-slider-dots]")),
            "1" == o.data("dots-titles") &&
              (d.customPaging = function (o, e) {
                return (
                  "<hr><button><span>" +
                  (0, t.default)(o.$slides[e])
                    .find("[data-title]")
                    .data("title") +
                  "</span></button>"
                );
              }),
            s.length &&
              o.on("init", function () {
                return s.addClass("m-mounted");
              }),
            "object" == e(a) && (d.responsive = a),
            o.data("slides-to-show-mob") &&
              (d.responsive = [
                {
                  breakpoint: 989,
                  settings: { slidesToShow: o.data("slides-to-show-mob") },
                },
              ]),
            o.data("slides-to-show-responsive") &&
              (d.responsive = [
                { variableWidth: !0, breakpoint: 9999, settings: "unslick" },
                {
                  variableWidth: !0,
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: !0,
                    dots: !1,
                  },
                },
                {
                  variableWidth: !0,
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: !0,
                    dots: !1,
                  },
                },
                {
                  variableWidth: !0,
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: !0,
                    dots: !1,
                  },
                },
              ]),
            o.data("as-nav-for"))
          ) {
            var n = o.data("as-nav-for");
            (d.asNavFor = "[data-slider=".concat(n, "]")),
              (d.focusOnSelect = !0);
          }
          var r = o.slick(d);
          (0, t.default)(window).on("resize", function () {
            (0, t.default)(window).width() < 1024 &&
              !r.hasClass("slick-initialized") &&
              o.slick(d);
          });
        };
        function a() {
          (0, t.default)("[data-hor-slider]").each(function (o, e) {
            var a = (0, t.default)(e);
            i(a);
          });
        }
        exports.mountSlider = i;
      },
      {
        jquery: "../node_modules/jquery/dist/jquery.js",
        "slick-carousel": "../node_modules/slick-carousel/slick/slick.js",
      },
    ],
    "modules/product/recommendations.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = d),
          (exports.mountRecommendationSection = void 0);
        var e = o(require("jquery")),
          t = require("../slider");
        function o(e) {
          return e && e.__esModule ? e : { default: e };
        }
        var n = function (o) {
          var n = ".product-recommendations-placeholder",
            d = " .product-recommendations-content",
            r = o.find(n),
            i = o.data("product-id"),
            a = o.data("limit");
          e.default.ajax({
            type: "GET",
            url:
              "/recommendations/products?section_id=ea-product-recommendations&limit=" +
              a +
              "&product_id=" +
              i,
            success: function (n) {
              void 0 === (0, e.default)(n).find(d)
                ? o.remove()
                : (r.html((0, e.default)(n).find(d).html()),
                  o.find("[data-hor-slider]").each(function (o, n) {
                    var d = (0, e.default)(n);
                    (0, t.mountSlider)(d);
                  }));
            },
            error: function () {
              console.error("Recommendations content load failed");
            },
          });
        };
        function d() {
          (0, e.default)("[data-product-recommendations]").each(function (
            t,
            o,
          ) {
            var d = (0, e.default)(o);
            n(d);
          });
        }
        exports.mountRecommendationSection = n;
      },
      {
        jquery: "../node_modules/jquery/dist/jquery.js",
        "../slider": "modules/slider.js",
      },
    ],
    "modules/product/index.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = d);
        var e = u(require("./slider")),
          r = u(require("./swatches")),
          t = u(require("./recommendations"));
        function u(e) {
          return e && e.__esModule ? e : { default: e };
        }
        function d() {
          (0, e.default)(), (0, r.default)(), (0, t.default)();
        }
      },
      {
        "./slider": "modules/product/slider.js",
        "./swatches": "modules/product/swatches.js",
        "./recommendations": "modules/product/recommendations.js",
      },
    ],
    "modules/login.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = void 0);
        var e = t(require("jquery"));
        function t(e) {
          return e && e.__esModule ? e : { default: e };
        }
        var a = function () {
            i();
          },
          i = function () {
            var t = (0, e.default)("[data-login]"),
              a = (0, e.default)("[data-login-forgot]"),
              i = (0, e.default)("[data-forgot-link]"),
              d = (0, e.default)("[data-login-link]");
            i.click(function (e) {
              e.preventDefault(),
                t.addClass("is-hidden").parent().css("height", 0),
                a.removeClass("is-hidden").parent().css("height", "auto");
            }),
              d
                .click(function (e) {
                  e.preventDefault(),
                    t.removeClass("is-hidden").parent().css("height", "auto"),
                    a.addClass("is-hidden").parent().css("height", 0);
                })
                .click();
          },
          d = a;
        exports.default = d;
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "modules/account.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = void 0);
        var e = d(require("jquery"));
        function d(e) {
          return e && e.__esModule ? e : { default: e };
        }
        var t = function () {
            var d = (0, e.default)("#AddressNewForm");
            d.length &&
              (Shopify &&
                new Shopify.CountryProvinceSelector(
                  "AddressCountryNew",
                  "AddressProvinceNew",
                  { hideElement: "AddressProvinceContainerNew" },
                ),
              (0, e.default)(".address-country-option").each(function () {
                var d = (0, e.default)(this).data("form-id"),
                  t = "AddressCountry_" + d,
                  r = "AddressProvince_" + d,
                  o = "AddressProvinceContainer_" + d;
                new Shopify.CountryProvinceSelector(t, r, { hideElement: o });
              }),
              (0, e.default)(".address-new-toggle").on("click", function () {
                d.toggleClass("hide");
              }),
              (0, e.default)(".address-edit-toggle").on("click", function () {
                var d = (0, e.default)(this).data("form-id");
                (0, e.default)("#EditAddress_" + d).toggleClass("hide");
              }),
              (0, e.default)(".address-delete").on("click", function () {
                var d = (0, e.default)(this),
                  t = d.data("form-id"),
                  r = d.data("confirm-message");
                confirm(r || "Are you sure you wish to delete this address?") &&
                  Shopify.postLink("/account/addresses/" + t, {
                    parameters: { _method: "delete" },
                  });
              }));
          },
          r = t;
        exports.default = r;
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "modules/cartPage.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = i),
          (exports.updateView = void 0);
        var t = r(require("jquery")),
          e = r(require("../vendor/cart.min.js")),
          a = require("../tools/moneyFormats");
        function r(t) {
          return t && t.__esModule ? t : { default: t };
        }
        var o = (0, t.default)("[data-cart-page]"),
          d = function () {
            t.default.get("/cart?view=ajax", function (e, a, r) {
              var d = (0, t.default)(e).find("[data-cart-page]").html(),
                c = (0, t.default)(e)
                  .find("[data-items-count]")
                  .data("items-count");
              o.html(d), (0, t.default)("[data-cart-count]").text(c);
            });
          };
        exports.updateView = d;
        var c = function (e) {
            e.forEach(function (e) {
              (0, t.default)("[data-discount]").each(function (r, o) {
                if (e.title == (0, t.default)(o).data("discount")) {
                  var d = (0, a.formatMoney)(e.total_allocated_amount);
                  (0, t.default)(o).text("-" + d);
                }
              });
            });
          },
          u = function () {
            var e = (0, t.default)("[data-checkout-btn]"),
              a = (0, t.default)("[data-checkout-btn]").next();
            "true" === localStorage.getItem("redirect_to_checkout") &&
              (window.ReCharge && window.ReCharge.subscriptions
                ? (console.log("redirect to recharge checkout"), e.click())
                : a.length
                ? (console.log("redirect to carthook checkout"),
                  setInterval(function () {
                    !0 === window.chScriptLoaded && a.click();
                  }, 500))
                : (console.log("redirect to shopify checkout"), e.click()),
              localStorage.setItem("redirect_to_checkout", !1));
          };
        function i() {
          o.length &&
            (u(),
            (0, t.default)(document).on("cart.requestComplete", d),
            (0, t.default)(document).on(
              "click",
              "[data-cart-remove-item]",
              function (a) {
                a.preventDefault();
                var r = (0, t.default)(this).data("id");
                e.default.removeItemById(r, {
                  error: function (t, e, a) {
                    console.error("cart delete item error:", t, e, a);
                  },
                });
              },
            ),
            (0, t.default)(document).on(
              "change",
              "[data-variant-select]",
              function (a) {
                var r = (0, t.default)(this).closest("[data-cart-row]"),
                  o = (0, t.default)("[data-qty]", r).val(),
                  d = (0, t.default)(this)
                    .find("option:selected")
                    .data("variant-id"),
                  c = (0, t.default)(this).data("current-id"),
                  u = (0, t.default)(this).data("properties");
                e.default.addItem(d, o, u, {
                  success: function (t, a, r) {
                    e.default.removeItemById(c, {
                      error: function (t, e, a) {
                        console.error(
                          "cart delete item after adding new item error:",
                          t,
                          e,
                          a,
                        );
                      },
                    });
                  },
                  error: function (t, e, a) {
                    console.error("cart update error:", t, e, a);
                  },
                });
              },
            ),
            (0, t.default)("[data-rc-period]").change(function (a) {
              var r = (0, t.default)(this).closest("[data-cart-row]"),
                o = (0, t.default)("[data-qty]", r).val(),
                d = (0, t.default)(this).data("line"),
                c = {
                  shipping_interval_frequency: (0, t.default)(this).val(),
                  shipping_interval_unit_type: (0, t.default)(this).data(
                    "rc-period",
                  ),
                  subscription_id: (0, t.default)(this).data("subscription-id"),
                };
              e.default.updateItem(d, o, c, {
                error: function (t, e, a) {
                  console.error("cart update error:", t, e, a);
                },
              });
            })),
            (0, t.default)("input#discreet").on("click", function (e) {
              (0, t.default)(this).toggleClass("active");
              var a = (0, t.default)(this).attr("data-id"),
                r = 0;
              (0, t.default)(this).hasClass("active")
                ? ((r = 1),
                  jQuery.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: { id: a, quantity: r },
                    dataType: "json",
                    success: function () {
                      console.log("success");
                    },
                  }))
                : jQuery.post("/cart/update.js", "updates[" + a + "]=0");
            });
        }
      },
      {
        jquery: "../node_modules/jquery/dist/jquery.js",
        "../vendor/cart.min.js": "vendor/cart.min.js",
        "../tools/moneyFormats": "tools/moneyFormats.js",
      },
    ],
    "modules/popup.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = a);
        var e = t(require("jquery"));
        function t(e) {
          return e && e.__esModule ? e : { default: e };
        }
        function a() {
          (0, e.default)("[data-popup-close]").click(function () {
            (0, e.default)(this)
              .closest("[data-popup]")
              .addClass("is-hidden")
              .trigger("setDefaultContent");
          }),
            (0, e.default)("[data-popup-open]").click(function (t) {
              t.preventDefault();
              var a = (0, e.default)(this).data("popup-open");
              (0, e.default)('[data-popup="' + a + '"').toggleClass(
                "is-hidden",
              );
            }),
            (0, e.default)("[data-popup-form-errors]").each(function (t, a) {
              var u = (0, e.default)(this).data("popup-form-errors");
              (0, e.default)('[data-popup-open="'.concat(u, '"]')).trigger(
                "click",
              );
            });
        }
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "../node_modules/tinybind/dist/tinybind.js": [
      function (require, module, exports) {
        var define;
        var global = arguments[3];
        var t,
          e = arguments[3];
        !(function (e, i) {
          "object" == typeof exports && "undefined" != typeof module
            ? (module.exports = i())
            : "function" == typeof t && t.amd
            ? t(i)
            : ((e = e || self).tinybind = i());
        })(this, function () {
          "use strict";
          var t = [
              "prefix",
              "templateDelimiters",
              "rootInterface",
              "preloadData",
              "handler",
            ],
            e = ["binders", "formatters", "adapters"],
            i = 0,
            n = 1,
            r = 0,
            s = 1,
            a = /^'.*'$|^".*"$/;
          function o(t) {
            var e = i,
              r = t;
            return (
              a.test(t)
                ? (r = t.slice(1, -1))
                : "true" === t
                ? (r = !0)
                : "false" === t
                ? (r = !1)
                : "null" === t
                ? (r = null)
                : "undefined" === t
                ? (r = void 0)
                : isNaN(t)
                ? (e = n)
                : (r = Number(t)),
              { type: e, value: r }
            );
          }
          function h(t, e) {
            for (
              var i, n = t.length, a = 0, o = 0, h = e[0], c = e[1];
              o < n;

            ) {
              if ((a = t.indexOf(h, o)) < 0) {
                i && i.push({ type: r, value: t.slice(o) });
                break;
              }
              if (
                (i || (i = []),
                a > 0 && o < a && i.push({ type: r, value: t.slice(o, a) }),
                (o = a + h.length),
                (a = t.indexOf(c, o)) < 0)
              ) {
                var u = t.slice(o - c.length),
                  l = i[i.length - 1];
                l && l.type === r
                  ? (l.value += u)
                  : i.push({ type: r, value: u });
                break;
              }
              var f = t.slice(o, a).trim();
              i.push({ type: s, value: f }), (o = a + c.length);
            }
            return i;
          }
          var c,
            u,
            l,
            f = {
              binders: {},
              formatters: {},
              adapters: {},
              _prefix: "rv",
              _fullPrefix: "rv-",
              get prefix() {
                return this._prefix;
              },
              set prefix(t) {
                (this._prefix = t), (this._fullPrefix = t + "-");
              },
              parseTemplate: h,
              parseType: o,
              templateDelimiters: ["{", "}"],
              rootInterface: ".",
              preloadData: !0,
              handler: function (t, e, i) {
                this.call(t, e, i.view.models);
              },
              fallbackBinder: function (t, e) {
                null != e
                  ? t.setAttribute(this.type, e)
                  : t.removeAttribute(this.type);
              },
              configure: function (t) {
                var i = this;
                t &&
                  Object.keys(t).forEach(function (n) {
                    var r = t[n];
                    e.indexOf(n) > -1
                      ? Object.keys(r).forEach(function (t) {
                          i[n][t] = r[t];
                        })
                      : (i[n] = r);
                  });
              },
            };
          function d(t) {
            return "object" == typeof t && null !== t;
          }
          var p = (function () {
            function t(t, e, i) {
              (this.keypath = e),
                (this.callback = i),
                (this.objectPath = []),
                this.parse(),
                (this.obj = this.getRootObject(t)),
                d((this.target = this.realize())) &&
                  this.set(!0, this.key, this.target, this.callback);
            }
            (t.updateOptions = function (t) {
              (c = t.adapters), (u = Object.keys(c)), (l = t.rootInterface);
            }),
              (t.tokenize = function (t, e) {
                var i,
                  n,
                  r = [],
                  s = { i: e, path: "" };
                for (i = 0; i < t.length; i++)
                  (n = t.charAt(i)),
                    ~u.indexOf(n)
                      ? (r.push(s), (s = { i: n, path: "" }))
                      : (s.path += n);
                return r.push(s), r;
              });
            var e = t.prototype;
            return (
              (e.parse = function () {
                var e, i;
                u.length ||
                  (function (t) {
                    throw new Error("[Observer] " + t);
                  })("Must define at least one adapter interface."),
                  ~u.indexOf(this.keypath[0])
                    ? ((i = this.keypath[0]), (e = this.keypath.substr(1)))
                    : ((i = l), (e = this.keypath)),
                  (this.tokens = t.tokenize(e, i)),
                  (this.key = this.tokens.pop());
              }),
              (e.realize = function () {
                for (
                  var t, e, i = this.obj, n = -1, r = 0;
                  r < this.tokens.length;
                  r++
                )
                  (e = this.tokens[r]),
                    d(i)
                      ? (void 0 !== this.objectPath[r]
                          ? i !== (t = this.objectPath[r]) &&
                            (this.set(!1, e, t, this),
                            this.set(!0, e, i, this),
                            (this.objectPath[r] = i))
                          : (this.set(!0, e, i, this),
                            (this.objectPath[r] = i)),
                        (i = this.get(e, i)))
                      : (-1 === n && (n = r),
                        (t = this.objectPath[r]) && this.set(!1, e, t, this));
                return -1 !== n && this.objectPath.splice(n), i;
              }),
              (e.sync = function () {
                var t, e, i;
                (t = this.realize()) !== this.target
                  ? (d(this.target) &&
                      this.set(!1, this.key, this.target, this.callback),
                    d(t) && this.set(!0, this.key, t, this.callback),
                    (e = this.value()),
                    (this.target = t),
                    ((i = this.value()) !== e || i instanceof Function) &&
                      this.callback.sync())
                  : t instanceof Array && this.callback.sync();
              }),
              (e.value = function () {
                if (d(this.target)) return this.get(this.key, this.target);
              }),
              (e.setValue = function (t) {
                d(this.target) &&
                  c[this.key.i].set(this.target, this.key.path, t);
              }),
              (e.get = function (t, e) {
                return c[t.i].get(e, t.path);
              }),
              (e.set = function (t, e, i, n) {
                var r = t ? "observe" : "unobserve";
                c[e.i][r](i, e.path, n);
              }),
              (e.unobserve = function () {
                for (var t, e, i = 0; i < this.tokens.length; i++)
                  (e = this.tokens[i]),
                    (t = this.objectPath[i]) && this.set(!1, e, t, this);
                d(this.target) &&
                  this.set(!1, this.key, this.target, this.callback);
              }),
              (e.getRootObject = function (t) {
                var e, i;
                if (!t.$parent) return t;
                for (
                  e = this.tokens.length ? this.tokens[0].path : this.key.path,
                    i = t;
                  i.$parent && void 0 === i[e];

                )
                  i = i.$parent;
                return i;
              }),
              t
            );
          })();
          var v = /[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g,
            b = /\s+/,
            y = (function () {
              function t(t, e, i, n, r, s, a) {
                (this.view = t),
                  (this.el = e),
                  (this.type = i),
                  (this.keypath = n),
                  (this.binder = r),
                  (this.arg = s),
                  (this.formatters = a),
                  (this.formatterObservers = {}),
                  (this.model = void 0);
              }
              var e = t.prototype;
              return (
                (e.observe = function (t, e) {
                  return new p(t, e, this);
                }),
                (e.parseTarget = function () {
                  if (this.keypath) {
                    var t = o(this.keypath);
                    0 === t.type
                      ? (this.value = t.value)
                      : ((this.observer = this.observe(
                          this.view.models,
                          this.keypath,
                        )),
                        (this.model = this.observer.target));
                  } else this.value = void 0;
                }),
                (e.parseFormatterArguments = function (t, e) {
                  var i = this;
                  return t.map(o).map(function (t, n) {
                    var r = t.type,
                      s = t.value;
                    if (0 === r) return s;
                    i.formatterObservers[e] || (i.formatterObservers[e] = {});
                    var a = i.formatterObservers[e][n];
                    return (
                      a ||
                        ((a = i.observe(i.view.models, s)),
                        (i.formatterObservers[e][n] = a)),
                      a.value()
                    );
                  });
                }),
                (e.formattedValue = function (t) {
                  var e = this;
                  return this.formatters.reduce(function (t, i, n) {
                    var r = i.match(v),
                      s = r.shift(),
                      a = e.view.options.formatters[s],
                      o = e.parseFormatterArguments(r, n);
                    return (
                      a && a.read instanceof Function
                        ? (t = a.read.apply(a, [t].concat(o)))
                        : a instanceof Function &&
                          (t = a.apply(void 0, [t].concat(o))),
                      t
                    );
                  }, t);
                }),
                (e.eventHandler = function (t) {
                  var e = this,
                    i = e.view.options.handler;
                  return function (n) {
                    i.call(t, this, n, e);
                  };
                }),
                (e.set = function (t) {
                  t =
                    t instanceof Function && !this.binder.function
                      ? this.formattedValue(t.call(this.model))
                      : this.formattedValue(t);
                  var e = this.binder.routine || this.binder;
                  e instanceof Function && e.call(this, this.el, t);
                }),
                (e.sync = function () {
                  this.observer
                    ? ((this.model = this.observer.target),
                      this.set(this.observer.value()))
                    : this.set(this.value);
                }),
                (e.publish = function () {
                  var t = this;
                  if (this.observer) {
                    var e = this.formatters.reduceRight(function (e, i, n) {
                      var r = i.split(b),
                        s = r.shift(),
                        a = t.view.options.formatters[s],
                        o = t.parseFormatterArguments(r, n);
                      return (
                        a &&
                          a.publish &&
                          (e = a.publish.apply(a, [e].concat(o))),
                        e
                      );
                    }, this.getValue(this.el));
                    this.observer.setValue(e);
                  }
                }),
                (e.bind = function () {
                  this.parseTarget(),
                    this.binder.hasOwnProperty("bind") &&
                      this.binder.bind.call(this, this.el),
                    this.view.options.preloadData && this.sync();
                }),
                (e.unbind = function () {
                  var t = this;
                  this.binder.unbind && this.binder.unbind.call(this, this.el),
                    this.observer && this.observer.unobserve(),
                    Object.keys(this.formatterObservers).forEach(function (e) {
                      var i = t.formatterObservers[e];
                      Object.keys(i).forEach(function (t) {
                        i[t].unobserve();
                      });
                    }),
                    (this.formatterObservers = {});
                }),
                (e.update = function (t) {
                  void 0 === t && (t = {}),
                    this.observer && (this.model = this.observer.target),
                    this.binder.update && this.binder.update.call(this, t);
                }),
                (e.getValue = function (t) {
                  return this.binder && this.binder.getValue
                    ? this.binder.getValue.call(this, t)
                    : (function (t) {
                        if ("checkbox" === t.type) return t.checked;
                        if ("select-multiple" === t.type) {
                          for (var e, i = [], n = 0; n < t.options.length; n++)
                            (e = t.options[n]).selected && i.push(e.value);
                          return i;
                        }
                        return t.value;
                      })(t);
                }),
                t
              );
            })(),
            m = {
              routine: function (t, e) {
                t.data = null != e ? e : "";
              },
            },
            g = /((?:'[^']*')*(?:(?:[^\|']*(?:'[^']*')+[^\|']*)+|[^\|]+))|^$/g,
            k = function t(e, i) {
              var n = !1;
              if (3 === i.nodeType) {
                var r = h(i.data, f.templateDelimiters);
                if (r) {
                  for (var s = 0; s < r.length; s++) {
                    var a = r[s],
                      o = document.createTextNode(a.value);
                    i.parentNode.insertBefore(o, i),
                      1 === a.type && e.buildBinding(o, null, a.value, m, null);
                  }
                  i.parentNode.removeChild(i);
                }
                n = !0;
              } else 1 === i.nodeType && (n = e.traverse(i));
              if (!n)
                for (var c = 0; c < i.childNodes.length; c++)
                  t(e, i.childNodes[c]);
            },
            _ = function (t, e) {
              var i = (t.binder && t.binder.priority) || 0;
              return ((e.binder && e.binder.priority) || 0) - i;
            },
            O = function (t) {
              return t.trim();
            },
            w = (function () {
              function t(t, e, i) {
                t.jquery || t instanceof Array
                  ? (this.els = t)
                  : (this.els = [t]),
                  (this.models = e),
                  (this.options = i),
                  this.build();
              }
              var e = t.prototype;
              return (
                (e.buildBinding = function (t, e, i, n, r) {
                  var s = i.match(g).map(O),
                    a = s.shift();
                  this.bindings.push(new y(this, t, e, a, n, r, s));
                }),
                (e.build = function () {
                  this.bindings = [];
                  var t,
                    e,
                    i = this.els;
                  for (t = 0, e = i.length; t < e; t++) k(this, i[t]);
                  this.bindings.sort(_);
                }),
                (e.traverse = function (t) {
                  for (
                    var e,
                      i,
                      n,
                      r,
                      s = f._fullPrefix,
                      a = "SCRIPT" === t.nodeName || "STYLE" === t.nodeName,
                      o = t.attributes,
                      h = [],
                      c = this.options.starBinders,
                      u = 0,
                      l = o.length;
                    u < l;
                    u++
                  ) {
                    var d = o[u];
                    if (0 === d.name.indexOf(s)) {
                      if (
                        ((e = d.name.slice(s.length)),
                        (r = void 0),
                        !(i = this.options.binders[e]))
                      )
                        for (var p = 0; p < c.length; p++)
                          if (
                            ((n = c[p]),
                            e.slice(0, n.length - 1) === n.slice(0, -1))
                          ) {
                            (i = this.options.binders[n]),
                              (r = e.slice(n.length - 1));
                            break;
                          }
                      if ((i || (i = f.fallbackBinder), i.block))
                        return (
                          this.buildBinding(t, e, d.value, i, r),
                          t.removeAttribute(d.name),
                          !0
                        );
                      h.push({ attr: d, binder: i, type: e, arg: r });
                    }
                  }
                  for (var v = 0; v < h.length; v++) {
                    var b = h[v];
                    this.buildBinding(t, b.type, b.attr.value, b.binder, b.arg),
                      t.removeAttribute(b.attr.name);
                  }
                  return a;
                }),
                (e.bind = function () {
                  this.bindings.forEach(function (t) {
                    t.bind();
                  });
                }),
                (e.unbind = function () {
                  this.bindings.forEach(function (t) {
                    t.unbind();
                  });
                }),
                (e.sync = function () {
                  this.bindings.forEach(function (t) {
                    t.sync();
                  });
                }),
                (e.publish = function () {
                  this.bindings.forEach(function (t) {
                    t.binder && t.binder.publishes && t.publish();
                  });
                }),
                (e.update = function (t) {
                  var e = this;
                  void 0 === t && (t = {}),
                    Object.keys(t).forEach(function (i) {
                      e.models[i] = t[i];
                    }),
                    this.bindings.forEach(function (e) {
                      e.update && e.update(t);
                    });
                }),
                t
              );
            })(),
            E = [
              "push",
              "pop",
              "shift",
              "unshift",
              "sort",
              "reverse",
              "splice",
            ],
            j = {
              counter: 0,
              weakmap: {},
              weakReference: function (t) {
                if (!t.hasOwnProperty("__rv")) {
                  var e = this.counter++;
                  Object.defineProperty(t, "__rv", { value: e });
                }
                return (
                  this.weakmap[t.__rv] ||
                    (this.weakmap[t.__rv] = { callbacks: {} }),
                  this.weakmap[t.__rv]
                );
              },
              cleanupWeakReference: function (t, e) {
                Object.keys(t.callbacks).length ||
                  (t.pointers && Object.keys(t.pointers).length) ||
                  delete this.weakmap[e];
              },
              stubFunction: function (t, e) {
                var i = t[e],
                  n = this.weakReference(t),
                  r = this.weakmap;
                t[e] = function () {
                  for (
                    var e = arguments.length, s = new Array(e), a = 0;
                    a < e;
                    a++
                  )
                    s[a] = arguments[a];
                  var o = i.apply(t, s);
                  return (
                    Object.keys(n.pointers).forEach(function (t) {
                      var e = n.pointers[t];
                      r[t] &&
                        r[t].callbacks[e] instanceof Array &&
                        r[t].callbacks[e].forEach(function (t) {
                          t.sync();
                        });
                    }),
                    o
                  );
                };
              },
              observeArray: function (t, e, i) {
                var n = this;
                if (t instanceof Array) {
                  var r = this.weakReference(t);
                  r.pointers ||
                    ((r.pointers = {}),
                    E.forEach(function (e) {
                      n.stubFunction(t, e);
                    })),
                    r.pointers[e] || (r.pointers[e] = []),
                    -1 === r.pointers[e].indexOf(i) && r.pointers[e].push(i);
                }
              },
              unobserveArray: function (t, e, i) {
                if (t instanceof Array && null != t.__rv) {
                  var n = this.weakmap[t.__rv];
                  if (n) {
                    var r = n.pointers[e];
                    if (r) {
                      var s = r.indexOf(i);
                      s > -1 && r.splice(s, 1),
                        r.length || delete n.pointers[e],
                        this.cleanupWeakReference(n, t.__rv);
                    }
                  }
                }
              },
              observe: function (t, e, i) {
                var n,
                  r = this,
                  s = this.weakReference(t).callbacks;
                if (!s[e]) {
                  s[e] = [];
                  var a = Object.getOwnPropertyDescriptor(t, e);
                  (a && (a.get || a.set || !a.configurable)) ||
                    ((n = t[e]),
                    Object.defineProperty(t, e, {
                      enumerable: !0,
                      get: function () {
                        return n;
                      },
                      set: function (i) {
                        if (i !== n) {
                          r.unobserveArray(n, t.__rv, e), (n = i);
                          var s = r.weakmap[t.__rv];
                          if (s) {
                            var a = s.callbacks[e];
                            a &&
                              a.forEach(function (t) {
                                t.sync();
                              }),
                              r.observeArray(i, t.__rv, e);
                          }
                        }
                      },
                    }));
                }
                -1 === s[e].indexOf(i) && s[e].push(i),
                  this.observeArray(t[e], t.__rv, e);
              },
              unobserve: function (t, e, i) {
                var n = this.weakmap[t.__rv];
                if (n) {
                  var r = n.callbacks[e];
                  if (r) {
                    var s = r.indexOf(i);
                    s > -1 &&
                      (r.splice(s, 1),
                      r.length ||
                        (delete n.callbacks[e],
                        this.unobserveArray(t[e], t.__rv, e))),
                      this.cleanupWeakReference(n, t.__rv);
                  }
                }
              },
              get: function (t, e) {
                return t[e];
              },
              set: function (t, e, i) {
                t[e] = i;
              },
            },
            x = function (t) {
              return null != t ? t.toString() : void 0;
            };
          function N(t, e, i) {
            var n = t.el.cloneNode(!0),
              r = new w(n, e, t.view.options);
            return r.bind(), t.marker.parentNode.insertBefore(n, i), r;
          }
          var A = {
            "on-*": {
              function: !0,
              priority: 1e3,
              unbind: function (t) {
                this.handler && t.removeEventListener(this.arg, this.handler);
              },
              routine: function (t, e) {
                this.handler && t.removeEventListener(this.arg, this.handler),
                  (this.handler = this.eventHandler(e)),
                  t.addEventListener(this.arg, this.handler);
              },
            },
            "each-*": {
              block: !0,
              priority: 4e3,
              bind: function (t) {
                this.marker
                  ? this.iterated.forEach(function (t) {
                      t.bind();
                    })
                  : ((this.marker = document.createComment(
                      " tinybind: " + this.type + " ",
                    )),
                    (this.iterated = []),
                    t.parentNode.insertBefore(this.marker, t),
                    t.parentNode.removeChild(t));
              },
              unbind: function (t) {
                this.iterated &&
                  this.iterated.forEach(function (t) {
                    t.unbind();
                  });
              },
              routine: function (t, e) {
                var i = this,
                  n = this.arg;
                e = e || [];
                var r = t.getAttribute("index-property") || "$index";
                e.forEach(function (t, e) {
                  var s = { $parent: i.view.models };
                  (s[r] = e), (s[n] = t);
                  var a = i.iterated[e];
                  if (a)
                    if (a.models[n] !== t) {
                      for (var o, h, c = e + 1; c < i.iterated.length; c++)
                        if ((h = i.iterated[c]).models[n] === t) {
                          o = c;
                          break;
                        }
                      void 0 !== o
                        ? (i.iterated.splice(o, 1),
                          i.marker.parentNode.insertBefore(h.els[0], a.els[0]),
                          (h.models[r] = e))
                        : (h = N(i, s, a.els[0])),
                        i.iterated.splice(e, 0, h);
                    } else a.models[r] = e;
                  else {
                    var u = i.marker;
                    i.iterated.length &&
                      (u = i.iterated[i.iterated.length - 1].els[0]),
                      (a = N(i, s, u.nextSibling)),
                      i.iterated.push(a);
                  }
                }),
                  this.iterated.length > e.length &&
                    (function (t, e) {
                      for (var i = 0; i < t; i++) e();
                    })(this.iterated.length - e.length, function () {
                      var t = i.iterated.pop();
                      t.unbind(), i.marker.parentNode.removeChild(t.els[0]);
                    }),
                  "OPTION" === t.nodeName &&
                    this.view.bindings.forEach(function (t) {
                      t.el === i.marker.parentNode &&
                        "value" === t.type &&
                        t.sync();
                    });
              },
              update: function (t) {
                var e = this,
                  i = {};
                Object.keys(t).forEach(function (n) {
                  n !== e.arg && (i[n] = t[n]);
                }),
                  this.iterated.forEach(function (t) {
                    t.update(i);
                  });
              },
            },
            "class-*": function (t, e) {
              var i = " " + t.className + " ";
              !e == i.indexOf(" " + this.arg + " ") > -1 &&
                (t.className = e
                  ? t.className + " " + this.arg
                  : i.replace(" " + this.arg + " ", " ").trim());
            },
            text: function (t, e) {
              t.textContent = null != e ? e : "";
            },
            html: function (t, e) {
              t.innerHTML = null != e ? e : "";
            },
            show: function (t, e) {
              t.style.display = e ? "" : "none";
            },
            hide: function (t, e) {
              t.style.display = e ? "none" : "";
            },
            enabled: function (t, e) {
              t.disabled = !e;
            },
            disabled: function (t, e) {
              t.disabled = !!e;
            },
            checked: {
              publishes: !0,
              priority: 2e3,
              bind: function (t) {
                var e = this;
                this.callback ||
                  (this.callback = function () {
                    e.publish();
                  }),
                  t.addEventListener("change", this.callback);
              },
              unbind: function (t) {
                t.removeEventListener("change", this.callback);
              },
              routine: function (t, e) {
                "radio" === t.type
                  ? (t.checked = x(t.value) === x(e))
                  : (t.checked = !!e);
              },
            },
            value: {
              publishes: !0,
              priority: 3e3,
              bind: function (t) {
                if (
                  ((this.isRadio = "INPUT" === t.tagName && "radio" === t.type),
                  !this.isRadio)
                ) {
                  this.event =
                    t.getAttribute("event-name") ||
                    ("SELECT" === t.tagName ? "change" : "input");
                  var e = this;
                  this.callback ||
                    (this.callback = function () {
                      e.publish();
                    }),
                    t.addEventListener(this.event, this.callback);
                }
              },
              unbind: function (t) {
                this.isRadio ||
                  t.removeEventListener(this.event, this.callback);
              },
              routine: function (t, e) {
                if (this.isRadio) t.setAttribute("value", e);
                else if ("select-multiple" === t.type) {
                  if (e instanceof Array)
                    for (var i = 0; i < t.length; i++) {
                      var n = t[i];
                      n.selected = e.indexOf(n.value) > -1;
                    }
                } else x(e) !== x(t.value) && (t.value = null != e ? e : "");
              },
            },
            if: {
              block: !0,
              priority: 4e3,
              bind: function (t) {
                this.marker
                  ? !1 === this.bound && this.nested && this.nested.bind()
                  : ((this.marker = document.createComment(
                      " tinybind: " + this.type + " " + this.keypath + " ",
                    )),
                    (this.attached = !1),
                    t.parentNode.insertBefore(this.marker, t),
                    t.parentNode.removeChild(t)),
                  (this.bound = !0);
              },
              unbind: function () {
                this.nested && (this.nested.unbind(), (this.bound = !1));
              },
              routine: function (t, e) {
                !!e !== this.attached &&
                  (e
                    ? (this.nested ||
                        ((this.nested = new w(
                          t,
                          this.view.models,
                          this.view.options,
                        )),
                        this.nested.bind()),
                      this.marker.parentNode.insertBefore(
                        t,
                        this.marker.nextSibling,
                      ),
                      (this.attached = !0))
                    : (t.parentNode.removeChild(t), (this.attached = !1)));
              },
              update: function (t) {
                this.nested && this.nested.update(t);
              },
            },
          };
          function P(t, e) {
            for (var i = 0; i < e.length; i++) {
              var n = e[i];
              (n.enumerable = n.enumerable || !1),
                (n.configurable = !0),
                "value" in n && (n.writable = !0),
                Object.defineProperty(t, n.key, n);
            }
          }
          function R(t) {
            return (R = Object.setPrototypeOf
              ? Object.getPrototypeOf
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
          }
          function C(t, e) {
            return (C =
              Object.setPrototypeOf ||
              function (t, e) {
                return (t.__proto__ = e), t;
              })(t, e);
          }
          function T(t, e, i) {
            return (T = (function () {
              if ("undefined" == typeof Reflect || !Reflect.construct)
                return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {}),
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            })()
              ? Reflect.construct
              : function (t, e, i) {
                  var n = [null];
                  n.push.apply(n, e);
                  var r = new (Function.bind.apply(t, n))();
                  return i && C(r, i.prototype), r;
                }).apply(null, arguments);
          }
          function B(t) {
            var e = "function" == typeof Map ? new Map() : void 0;
            return (B = function (t) {
              if (
                null === t ||
                ((i = t),
                -1 === Function.toString.call(i).indexOf("[native code]"))
              )
                return t;
              var i;
              if ("function" != typeof t)
                throw new TypeError(
                  "Super expression must either be null or a function",
                );
              if (void 0 !== e) {
                if (e.has(t)) return e.get(t);
                e.set(t, n);
              }
              function n() {
                return T(t, arguments, R(this).constructor);
              }
              return (
                (n.prototype = Object.create(t.prototype, {
                  constructor: {
                    value: n,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0,
                  },
                })),
                C(n, t)
              );
            })(t);
          }
          var F = (function (t) {
            var e, i;
            function n() {
              return t.apply(this, arguments) || this;
            }
            (i = t),
              ((e = n).prototype = Object.create(i.prototype)),
              (e.prototype.constructor = e),
              (e.__proto__ = i);
            var r,
              s,
              a,
              o = n.prototype;
            return (
              (o.connectedCallback = function () {
                var t = this.constructor.__templateEl.content.cloneNode(!0);
                for (this.__tinybindView = f.bind(t, this); this.firstChild; )
                  this.removeChild(this.firstChild);
                this.appendChild(t);
              }),
              (o.disconnectedCallback = function () {
                this.__tinybindView.unbind();
              }),
              (o.attributeChangedCallback = function (t, e, i) {
                e !== i && (this[this.constructor.__propAttributeMap[t]] = i);
              }),
              (r = n),
              (a = [
                {
                  key: "observedAttributes",
                  get: function () {
                    var t = this.template;
                    if (!t)
                      throw new Error("No template declared for " + this.name);
                    (this.__templateEl = document.createElement("template")),
                      (this.__templateEl.innerHTML = t);
                    var e = (this.__propAttributeMap = {}),
                      i = [],
                      n = this.properties;
                    return (
                      n &&
                        Object.keys(n).forEach(function (t) {
                          var r = n[t],
                            s = "string" == typeof r ? r : t;
                          (e[s] = t), i.push(s);
                        }),
                      i
                    );
                  },
                },
              ]),
              (s = null) && P(r.prototype, s),
              a && P(r, a),
              n
            );
          })(B(HTMLElement));
          return (
            (f.binders = A),
            (f.formatters = {
              watch: function (t) {
                return t;
              },
              not: function (t) {
                return !t;
              },
              negate: function (t) {
                return !t;
              },
            }),
            (f.adapters["."] = j),
            (f.Component = F),
            (f.bind = function (i, n, r) {
              var s = {};
              (n = n || {}),
                (r = r || {}),
                e.forEach(function (t) {
                  (s[t] = Object.create(null)),
                    r[t] &&
                      Object.keys(r[t]).forEach(function (e) {
                        s[t][e] = r[t][e];
                      }),
                    Object.keys(f[t]).forEach(function (e) {
                      s[t][e] || (s[t][e] = f[t][e]);
                    });
                }),
                t.forEach(function (t) {
                  var e = r[t];
                  s[t] = null != e ? e : f[t];
                }),
                (s.starBinders = Object.keys(s.binders).filter(function (t) {
                  return t.indexOf("*") > 0;
                })),
                p.updateOptions(s);
              var a = new w(i, n, s);
              return a.bind(), a;
            }),
            f
          );
        });
      },
      {},
    ],
    "modules/minicart.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = w);
        var t = o(require("jquery")),
          e = o(require("/vendor/cart.min.js")),
          a = o(require("tinybind")),
          n = require("/tools/moneyFormats");
        function o(t) {
          return t && t.__esModule ? t : { default: t };
        }
        function r(t) {
          return (r =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                  return typeof t;
                }
              : function (t) {
                  return t &&
                    "function" == typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : typeof t;
                })(t);
        }
        var i = (0, t.default)("[data-all-variants]"),
          c = {
            cart: {},
            update: function (t) {
              this.cart = t;
            },
            setRedirect: function (t) {
              t.preventDefault(), v();
            },
          },
          d = !1,
          u = (0, t.default)("[data-minicart]"),
          l = function () {
            (0, t.default)("[data-cart-count]").text(c.cart.item_count),
              c.cart.item_count
                ? (0, t.default)("[data-slide-cart-title]").text(
                    "review your cart",
                  )
                : (0, t.default)("[data-slide-cart-title]").text(
                    "your cart is empty",
                  );
          },
          s = function (e, a, n) {
            var o = { quantity: a, id: e, properties: {} };
            n.shipping_interval_frequency &&
              n.shipping_interval_unit_type &&
              n.subscription_id &&
              ((o.properties.shipping_interval_frequency =
                n.shipping_interval_frequency),
              (o.properties.shipping_interval_unit_type =
                n.shipping_interval_unit_type),
              (o.properties.subscription_id = n.subscription_id)),
              t.default.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: o,
                dataType: "json",
                success: function () {
                  (d = !0), (window.location.href = "/cart/");
                },
                error: function () {
                  console.error("Can't add item to cart");
                },
              });
          },
          f = function (e) {
            var a = [];
            return (
              e.find("[data-product-property]").each(function (e, n) {
                var o = (0, t.default)(n).data("product-property"),
                  r = (0, t.default)(n).val();
                o && "hidden" != o && r && (a[o] = r);
              }),
              a
            );
          },
          p = function (e) {
            console.log(e);
            var a = (0, t.default)(
                "option:selected",
                e.find("[data-all-variants]"),
              ),
              n = a.val();
            "" != a.data("discount-variant-id") &&
              (n = a.data("discount-variant-id"));
            var o = e.find("[data-qty]").val() || 1,
              r = f(e);
            if ((console.log(n), n)) s(n, o, r);
            else if (
              e
                .find("[data-all-variants] option:selected")
                .data("multi-variants")
            ) {
              e.find("[data-all-variants] option:selected")
                .data("multi-variants")
                .forEach(function (t) {
                  console.log(t), s(t, o, r);
                });
            } else
              console.error(
                "minicart.js: can't add item to cart, wrong variantId",
                n,
              );
          },
          m = function () {
            if (null != (0, t.default)(this).data("line")) {
              var a = (0, t.default)(this).data("line");
              null != a
                ? (console.log("remove", a), e.default.removeItem(a + 1))
                : console.error("Can't remove item", a, " from the cart!");
            } else
              console.error(
                "Can't remove item to the cart since data-line is not present in the remove-from-cart button!",
              );
          };
        function y() {
          var t,
            e = "";
          do {
            (t = "cart"),
              (e = (document.cookie.match("(^|; )" + t + "=([^;]*)") || 0)[2]);
          } while (null == e);
          try {
            var a = ga.getAll()[0].get("linkerParam");
          } catch (n) {
            a = "";
          }
          document.location.href =
            "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" +
            myshopify_domain +
            "&cart_token=" +
            e +
            "&" +
            a +
            "&{% if customer %}customer_id={{customer.id}}&customer_email={{customer.email}}{% endif %}";
        }
        var v = function () {
            for (var t = !1, e = 0; e < c.cart.items.length; e++) {
              c.cart.items[e].product_title.includes("Auto renew") && (t = !0);
            }
            t ? y() : (document.location.href = "/checkout");
          },
          h = function () {
            t.default
              .get("/cart.js", function (e) {
                var a = JSON.parse(e);
                c.update(a),
                  l(),
                  _(),
                  d &&
                    (u.addClass("is-open"),
                    (0, t.default)("body").addClass("is-cart-open"),
                    (d = !1),
                    "object" ==
                      ("undefined" == typeof Gs ? "undefined" : r(Gs)) &&
                      "function" == typeof Gs.initializeDrawer &&
                      (console.log("hereherehere"), Gs.initializeDrawer()));
              })
              .fail(function () {
                console.error("minicart.js: updateMinicart error");
              });
          },
          _ = function () {
            if (c.cart.total_price >= 8e3)
              (0, t.default)("[data-free-shipping-label]").html(
                "Congrats! You get free standard shipping.",
              ),
                (0, t.default)("[data-free-shipping-percent]").css(
                  "width",
                  "100%",
                );
            else {
              var e = parseInt(8e3 - c.cart.total_price),
                a = parseInt((100 * c.cart.total_price) / 8e3);
              (0, t.default)("[data-free-shipping-label]").html(
                "You are " +
                  (0, n.formatMoney)(e) +
                  " case away from free shipping!",
              ),
                (0, t.default)("[data-free-shipping-percent]").css(
                  "width",
                  a + "%",
                );
            }
          },
          g = function (e) {
            var a = { quantity: 1, id: e, properties: {} };
            console.log(a),
              t.default.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: a,
                dataType: "json",
                success: function () {
                  (d = !0), h();
                },
                error: function () {
                  console.error("Can't add item to cart");
                },
              });
          },
          b = function () {
            (0, t.default)("[data-add-to-cart]").on("click", function (t) {}),
              (0, t.default)(document).on(
                "click",
                "form#addToCartForm button[data-add-to-cart] *",
                function () {},
              ),
              (0, t.default)("[data-sticky-atc]").on("click", function (e) {
                e.preventDefault(),
                  console.log((0, t.default)(this).data("variant-id")),
                  g(localStorage.getItem("selectedVariantId"));
              }),
              (0, t.default)("[data-quick-atc]").on("click", function (e) {
                e.preventDefault(),
                  g((0, t.default)(this).data("variant-id")),
                  console.log("quick add");
              }),
              (0, t.default)(document).on(
                "click",
                "[data-remove-from-cart]",
                m,
              ),
              (0, t.default)("[data-minicart-toggle]").on(
                "click",
                function (t) {},
              ),
              (0, t.default)(document).on(
                "click",
                "[data-qty-plus]",
                function () {
                  q("inc", (0, t.default)(this));
                },
              ),
              (0, t.default)(document).on(
                "click",
                "[data-qty-minus]",
                function () {
                  q("dec", (0, t.default)(this));
                },
              ),
              (0, t.default)(document).on(
                "cart.requestComplete",
                function (t, e) {
                  h();
                },
              ),
              (0, t.default)(document).ready(function () {
                h();
              });
          },
          q = function (t, e) {
            var a = e.closest(".minicart__item").attr("data-id"),
              n = parseInt(e.parent(".item__qty").find("[data-qty]").text());
            "inc" == t ? k(a, (n += 1)) : 1 != n && k(a, (n -= 1));
          },
          k = function (t, e) {
            jQuery.post(
              "/cart/update.js",
              "updates[" + t + "]=" + e,
              function () {
                h();
              },
            );
          },
          j = function () {
            if (!a.default)
              return (
                console.error(
                  "minicart.js: Tinybind template library is not connected",
                ),
                !1
              );
            (a.default.formatters.formatMoney = n.formatMoney),
              (a.default.formatters.isDefaultTitle = function (t) {
                return "default title" != t.toLowerCase();
              }),
              (a.default.formatters.append = function (t, e) {
                return t + e;
              }),
              (a.default.formatters.convert = function (t, e) {
                return e ? "/products/" + e : t;
              }),
              a.default.bind(u, c),
              "true" == localStorage.getItem("opened_side_cart") &&
                "/" == window.location.pathname &&
                (console.log("here2"),
                (0, t.default)("[data-minicart]").addClass("is-open"),
                (0, t.default)("body").addClass("is-cart-open"),
                localStorage.setItem("opened_side_cart", !1));
          };
        function w() {
          j(), b();
        }
      },
      {
        jquery: "../node_modules/jquery/dist/jquery.js",
        "/vendor/cart.min.js": "vendor/cart.min.js",
        tinybind: "../node_modules/tinybind/dist/tinybind.js",
        "/tools/moneyFormats": "tools/moneyFormats.js",
      },
    ],
    "modules/megamenu.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = n);
        var e = t(require("jquery"));
        function t(e) {
          return e && e.__esModule ? e : { default: e };
        }
        function n() {
          (0, e.default)("[data-parent-link]").each(function (t, n) {
            console.log("megamenu");
            (0, e.default)(n).data("parent-link");
            (0, e.default)(window).width() < 990 &&
              (0, e.default)(n).attr("data-accordion-content", "");
          }),
            (0, e.default)(window).width() < 990 &&
              (0, e.default)(".sidenav.hide--desktop").append(
                (0, e.default)("[data-mob-megamenu]").html(),
              );
          var t = !1;
          function n(e) {
            setTimeout(function () {
              0 == t && e.removeClass("menu--open");
            }, 300);
          }
          (0, e.default)(".nav__item.m-level-1")
            .mouseover(function () {
              (0, e.default)(this).nextAll().removeClass("menu--open"),
                (0, e.default)(this).prevAll().removeClass("menu--open"),
                (0, e.default)(this).addClass("menu--open"),
                (t = !0);
            })
            .mouseout(function () {
              (t = !1), n((0, e.default)(this));
            }),
            (0, e.default)(".mega-menu__ea-megamenu--complex")
              .mouseover(function () {
                t = !0;
              })
              .mouseout(function () {
                (t = !1),
                  n((0, e.default)(this).closest(".nav__item.m-level-1"));
              });
        }
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "modules/search.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = t);
        var e = a(require("jquery"));
        function a(e) {
          return e && e.__esModule ? e : { default: e };
        }
        function t() {
          (0, e.default)(".search-close").click(function () {
            (0, e.default)("[data-overlay-search]").removeClass("is_active");
          }),
            (0, e.default)("[data-show-search-trigger]").click(function () {
              "overlay" == (0, e.default)(this).data("search-style") &&
                ((0, e.default)("[data-overlay-search]").toggleClass(
                  "is_active",
                ),
                (0, e.default)("[data-popup='search-popup']").addClass(
                  "is-hidden",
                ),
                (0, e.default)("[data-search-input]").focus());
            });
        }
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "modules/footerMenu.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = i);
        var e = t(require("jquery"));
        function t(e) {
          return e && e.__esModule ? e : { default: e };
        }
        function i() {
          (0, e.default)(".mobile-footer-menu .footer-title").click(
            function () {
              (0, e.default)(this).hasClass("is_active")
                ? (0, e.default)(this).toggleClass("is_active")
                : ((0, e.default)(".mobile-footer-menu")
                    .find(".is_active")
                    .removeClass("is_active"),
                  (0, e.default)(this).addClass("is_active"));
            },
          );
        }
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "modules/maquee.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = i);
        var e = t(require("jquery"));
        function t(e) {
          return e && e.__esModule ? e : { default: e };
        }
        function i() {
          var t;
          ((t = jQuery).fn.marquee = function (e) {
            return this.each(function () {
              var i,
                a,
                r,
                n,
                s,
                o = t.extend({}, t.fn.marquee.defaults, e),
                d = t(this),
                u = 3,
                p = "animation-play-state",
                l = !1,
                f = function (e, t, i) {
                  for (
                    var a = ["webkit", "moz", "MS", "o", ""], r = 0;
                    r < a.length;
                    r++
                  )
                    a[r] || (t = t.toLowerCase()),
                      e.addEventListener(a[r] + t, i, !1);
                },
                c = function () {
                  d.timer = setTimeout(k, o.delayBeforeStart);
                },
                m = {
                  pause: function () {
                    l && o.allowCss3Support
                      ? i.css(p, "paused")
                      : t.fn.pause && i.pause(),
                      d.data("runningStatus", "paused"),
                      d.trigger("paused");
                  },
                  resume: function () {
                    l && o.allowCss3Support
                      ? i.css(p, "running")
                      : t.fn.resume && i.resume(),
                      d.data("runningStatus", "resumed"),
                      d.trigger("resumed");
                  },
                  toggle: function () {
                    m[
                      "resumed" == d.data("runningStatus") ? "pause" : "resume"
                    ]();
                  },
                  destroy: function () {
                    clearTimeout(d.timer),
                      d
                        .css("visibility", "hidden")
                        .html(d.find(".js-marquee:first")),
                      setTimeout(function () {
                        d.css("visibility", "visible");
                      }, 0);
                  },
                };
              if ("string" != typeof e) {
                var g;
                t.each(o, function (e, t) {
                  if (void 0 !== (g = d.attr("data-" + e))) {
                    switch (g) {
                      case "true":
                        g = !0;
                        break;
                      case "false":
                        g = !1;
                    }
                    o[e] = g;
                  }
                }),
                  (o.duration = o.speed || o.duration),
                  (n = "up" == o.direction || "down" == o.direction),
                  (o.gap = o.duplicated ? o.gap : 0),
                  d.wrapInner('<div class="js-marquee"></div>');
                var h = d
                  .find(".js-marquee")
                  .css({ "margin-right": o.gap, float: "left" });
                if (
                  (o.duplicated && h.clone(!0).appendTo(d),
                  d.wrapInner(
                    '<div style="width:100000px" class="js-marquee-wrapper"></div>',
                  ),
                  (i = d.find(".js-marquee-wrapper")),
                  n)
                ) {
                  var v = d.height();
                  i.removeAttr("style"),
                    d.height(v),
                    d
                      .find(".js-marquee")
                      .css({
                        float: "none",
                        "margin-bottom": o.gap,
                        "margin-right": 0,
                      }),
                    o.duplicated &&
                      d.find(".js-marquee:last").css({ "margin-bottom": 0 });
                  var y = d.find(".js-marquee:first").height() + o.gap;
                  o.duration =
                    ((parseInt(y, 10) + parseInt(v, 10)) / parseInt(v, 10)) *
                    o.duration;
                } else
                  (s = d.find(".js-marquee:first").width() + o.gap),
                    (a = d.width()),
                    (o.duration =
                      ((parseInt(s, 10) + parseInt(a, 10)) / parseInt(a, 10)) *
                      o.duration);
                if (
                  (o.duplicated && (o.duration = o.duration / 2),
                  o.allowCss3Support)
                ) {
                  var w = document.body || document.createElement("div"),
                    q = "marqueeAnimation-" + Math.floor(1e7 * Math.random()),
                    x = "Webkit Moz O ms Khtml".split(" "),
                    S = "animation",
                    b = "",
                    j = "";
                  if (
                    (w.style.animation &&
                      ((j = "@keyframes " + q + " "), (l = !0)),
                    !1 === l)
                  )
                    for (var I = 0; I < x.length; I++)
                      if (void 0 !== w.style[x[I] + "AnimationName"]) {
                        var C = "-" + x[I].toLowerCase() + "-";
                        (S = C + S),
                          (p = C + p),
                          (j = "@" + C + "keyframes " + q + " "),
                          (l = !0);
                        break;
                      }
                  l &&
                    ((b =
                      q +
                      " " +
                      o.duration / 1e3 +
                      "s " +
                      o.delayBeforeStart / 1e3 +
                      "s infinite " +
                      o.css3easing),
                    d.data("css3AnimationIsSupported", !0));
                }
                var A = function () {
                    i.css(
                      "margin-top",
                      "up" == o.direction ? v + "px" : "-" + y + "px",
                    );
                  },
                  O = function () {
                    i.css(
                      "margin-left",
                      "left" == o.direction ? a + "px" : "-" + s + "px",
                    );
                  };
                o.duplicated
                  ? (n
                      ? i.css(
                          "margin-top",
                          "up" == o.direction
                            ? v
                            : "-" + (2 * y - o.gap) + "px",
                        )
                      : i.css(
                          "margin-left",
                          "left" == o.direction
                            ? a / o.startPosition + "px"
                            : "-" + (2 * s - o.gap) + "px",
                        ),
                    (u = 1))
                  : n
                  ? A()
                  : O();
                var k = function e() {
                  if (
                    (o.duplicated &&
                      (1 === u
                        ? ((o._originalDuration = o.duration),
                          (o.duration = n
                            ? "up" == o.direction
                              ? o.duration + v / (y / o.duration)
                              : 2 * o.duration
                            : "left" == o.direction
                            ? o.duration + a / (s / o.duration)
                            : 2 * o.duration),
                          b &&
                            (b =
                              q +
                              " " +
                              o.duration / 1e3 +
                              "s " +
                              o.delayBeforeStart / 1e3 +
                              "s " +
                              o.css3easing),
                          u++)
                        : 2 === u &&
                          ((o.duration = o._originalDuration),
                          b &&
                            ((q += "0"),
                            (j = t.trim(j) + "0 "),
                            (b =
                              q +
                              " " +
                              o.duration / 1e3 +
                              "s 0s infinite " +
                              o.css3easing)),
                          u++)),
                    n
                      ? o.duplicated
                        ? (u > 2 &&
                            i.css(
                              "margin-top",
                              "up" == o.direction ? 0 : "-" + y + "px",
                            ),
                          (r = {
                            "margin-top":
                              "up" == o.direction ? "-" + y + "px" : 0,
                          }))
                        : (A(),
                          (r = {
                            "margin-top":
                              "up" == o.direction
                                ? "-" + i.height() + "px"
                                : v + "px",
                          }))
                      : o.duplicated
                      ? (u > 2 &&
                          i.css(
                            "margin-left",
                            "left" == o.direction ? 0 : "-" + s + "px",
                          ),
                        (r = {
                          "margin-left":
                            "left" == o.direction ? "-" + s + "px" : 0,
                        }))
                      : (O(),
                        (r = {
                          "margin-left":
                            "left" == o.direction ? "-" + s + "px" : a + "px",
                        })),
                    d.trigger("beforeStarting"),
                    l)
                  ) {
                    i.css(S, b);
                    var p =
                        j +
                        " { 100%  " +
                        (function (e) {
                          var t = [];
                          for (var i in e)
                            e.hasOwnProperty(i) && t.push(i + ":" + e[i]);
                          return t.push(), "{" + t.join(",") + "}";
                        })(r) +
                        "}",
                      m = t("style");
                    0 !== m.length
                      ? m.filter(":last").append(p)
                      : t("head").append("<style>" + p + "</style>"),
                      f(i[0], "AnimationIteration", function () {
                        d.trigger("finished");
                      }),
                      f(i[0], "AnimationEnd", function () {
                        e(), d.trigger("finished");
                      });
                  } else
                    i.animate(r, o.duration, o.easing, function () {
                      d.trigger("finished"), o.pauseOnCycle ? c() : e();
                    });
                  d.data("runningStatus", "resumed");
                };
                d.bind("pause", m.pause),
                  d.bind("resume", m.resume),
                  o.pauseOnHover && d.bind("mouseenter mouseleave", m.toggle),
                  l && o.allowCss3Support ? k() : c();
              } else t.isFunction(m[e]) && (i || (i = d.find(".js-marquee-wrapper")), !0 === d.data("css3AnimationIsSupported") && (l = !0), m[e]());
            });
          }),
            (t.fn.marquee.defaults = {
              allowCss3Support: !0,
              css3easing: "linear",
              easing: "linear",
              delayBeforeStart: 1e3,
              direction: "left",
              duplicated: !1,
              duration: 5e3,
              gap: 20,
              pauseOnCycle: !1,
              pauseOnHover: !1,
            });
          var i,
            a = (0, e.default)("[data-marquee-slider]"),
            r = a.find(".sliderItem"),
            n = r.find(".item"),
            s = a.width(),
            o = n.length + 1,
            d = (s - r.innerWidth()) / o + 10;
          d < 30 && (d = 30),
            console.log(d),
            n.css("margin-right", d + "px"),
            (i =
              (0, e.default)(window).width() < 941
                ? 15 * (0, e.default)("[data-marquee-slider]").width()
                : 7 * (0, e.default)("[data-marquee-slider]").width()),
            a.marquee({
              duration: i,
              gap: 0,
              delayBeforeStart: 0,
              direction: "left",
              duplicated: !0,
              allowCss3Support: !0,
              startPosition: 2,
            }),
            (0, e.default)("[data-marquee-slider]").css("opacity", 1);
        }
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "modules/customAccordion.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = u);
        var e = t(require("jquery"));
        function t(e) {
          return e && e.__esModule ? e : { default: e };
        }
        function u() {
          (0, e.default)(document).ready(function () {
            (0, e.default)("#shopify-section-page-faq .faq-item-wrap").click(
              function () {
                (0, e.default)(this)
                  .closest(".block-item")
                  .toggleClass("is__selected");
              },
            );
          });
        }
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "modules/productMeet.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = t);
        var e = a(require("jquery"));
        function a(e) {
          return e && e.__esModule ? e : { default: e };
        }
        function t() {
          (0, e.default)(".plus-dot").on("click", function () {
            var a = (0, e.default)(this).data("index");
            (0, e.default)(this).hasClass("is-active")
              ? ((0, e.default)(".plus-dot").removeClass("is-active"),
                (0, e.default)(".image-wrap .plus-text").removeClass(
                  "is-active",
                ),
                (0, e.default)(this).removeClass("is-active"),
                (0, e.default)(
                  '.image-wrap .plus-text[data-index="' + a + '"]',
                ).removeClass("is-active"))
              : ((0, e.default)(".plus-dot").removeClass("is-active"),
                (0, e.default)(".image-wrap .plus-text").removeClass(
                  "is-active",
                ),
                (0, e.default)(this).addClass("is-active"),
                (0, e.default)(
                  '.image-wrap .plus-text[data-index="' + a + '"]',
                ).addClass("is-active"));
          });
        }
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "tools/inView.js": [
      function (require, module, exports) {
        var define;
        var t;
        function e(t) {
          return (e =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                  return typeof t;
                }
              : function (t) {
                  return t &&
                    "function" == typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : typeof t;
                })(t);
        }
        !(function (n, r) {
          "object" ==
            ("undefined" == typeof exports ? "undefined" : e(exports)) &&
          "object" == ("undefined" == typeof module ? "undefined" : e(module))
            ? (module.exports = r())
            : "function" == typeof t && t.amd
            ? t([], r)
            : "object" ==
              ("undefined" == typeof exports ? "undefined" : e(exports))
            ? (exports.inView = r())
            : (n.inView = r());
        })(this, function () {
          return (function (t) {
            function e(r) {
              if (n[r]) return n[r].exports;
              var o = (n[r] = { exports: {}, id: r, loaded: !1 });
              return (
                t[r].call(o.exports, o, o.exports, e),
                (o.loaded = !0),
                o.exports
              );
            }
            var n = {};
            return (e.m = t), (e.c = n), (e.p = ""), e(0);
          })([
            function (t, e, n) {
              "use strict";
              var r = (function (t) {
                return t && t.__esModule ? t : { default: t };
              })(n(2));
              t.exports = r.default;
            },
            function (t, n) {
              t.exports = function (t) {
                var n = e(t);
                return null != t && ("object" == n || "function" == n);
              };
            },
            function (t, e, n) {
              "use strict";
              function r(t) {
                return t && t.__esModule ? t : { default: t };
              }
              Object.defineProperty(e, "__esModule", { value: !0 });
              var o = r(n(9)),
                i = r(n(3)),
                u = n(4);
              e.default = (function () {
                if ("undefined" != typeof window) {
                  var t = { history: [] },
                    e = { offset: {}, threshold: 0, test: u.inViewport },
                    n = (0, o.default)(function () {
                      t.history.forEach(function (e) {
                        t[e].check();
                      });
                    }, 100);
                  ["scroll", "resize", "load"].forEach(function (t) {
                    return addEventListener(t, n);
                  }),
                    window.MutationObserver &&
                      addEventListener("DOMContentLoaded", function () {
                        new MutationObserver(n).observe(document.body, {
                          attributes: !0,
                          childList: !0,
                          subtree: !0,
                        });
                      });
                  var r = function (n) {
                    if ("string" == typeof n) {
                      var r = [].slice.call(document.querySelectorAll(n));
                      return (
                        t.history.indexOf(n) > -1
                          ? (t[n].elements = r)
                          : ((t[n] = (0, i.default)(r, e)), t.history.push(n)),
                        t[n]
                      );
                    }
                  };
                  return (
                    (r.offset = function (t) {
                      if (void 0 === t) return e.offset;
                      var n = function (t) {
                        return "number" == typeof t;
                      };
                      return (
                        ["top", "right", "bottom", "left"].forEach(
                          n(t)
                            ? function (n) {
                                return (e.offset[n] = t);
                              }
                            : function (r) {
                                return n(t[r]) ? (e.offset[r] = t[r]) : null;
                              },
                        ),
                        e.offset
                      );
                    }),
                    (r.threshold = function (t) {
                      return "number" == typeof t && t >= 0 && t <= 1
                        ? (e.threshold = t)
                        : e.threshold;
                    }),
                    (r.test = function (t) {
                      return "function" == typeof t ? (e.test = t) : e.test;
                    }),
                    (r.is = function (t) {
                      return e.test(t, e);
                    }),
                    r.offset(0),
                    r
                  );
                }
              })();
            },
            function (t, e) {
              "use strict";
              Object.defineProperty(e, "__esModule", { value: !0 });
              var n = (function () {
                  function t(t, e) {
                    for (var n = 0; n < e.length; n++) {
                      var r = e[n];
                      (r.enumerable = r.enumerable || !1),
                        (r.configurable = !0),
                        "value" in r && (r.writable = !0),
                        Object.defineProperty(t, r.key, r);
                    }
                  }
                  return function (e, n, r) {
                    return n && t(e.prototype, n), r && t(e, r), e;
                  };
                })(),
                r = (function () {
                  function t(e, n) {
                    (function (t, e) {
                      if (!(t instanceof e))
                        throw new TypeError(
                          "Cannot call a class as a function",
                        );
                    })(this, t),
                      (this.options = n),
                      (this.elements = e),
                      (this.current = []),
                      (this.handlers = { enter: [], exit: [] }),
                      (this.singles = { enter: [], exit: [] });
                  }
                  return (
                    n(t, [
                      {
                        key: "check",
                        value: function () {
                          var t = this;
                          return (
                            this.elements.forEach(function (e) {
                              var n = t.options.test(e, t.options),
                                r = t.current.indexOf(e),
                                o = r > -1,
                                i = !n && o;
                              n &&
                                !o &&
                                (t.current.push(e), t.emit("enter", e)),
                                i &&
                                  (t.current.splice(r, 1), t.emit("exit", e));
                            }),
                            this
                          );
                        },
                      },
                      {
                        key: "on",
                        value: function (t, e) {
                          return this.handlers[t].push(e), this;
                        },
                      },
                      {
                        key: "once",
                        value: function (t, e) {
                          return this.singles[t].unshift(e), this;
                        },
                      },
                      {
                        key: "emit",
                        value: function (t, e) {
                          for (; this.singles[t].length; )
                            this.singles[t].pop()(e);
                          for (var n = this.handlers[t].length; --n > -1; )
                            this.handlers[t][n](e);
                          return this;
                        },
                      },
                    ]),
                    t
                  );
                })();
              e.default = function (t, e) {
                return new r(t, e);
              };
            },
            function (t, e) {
              "use strict";
              Object.defineProperty(e, "__esModule", { value: !0 }),
                (e.inViewport = function (t, e) {
                  var n = t.getBoundingClientRect(),
                    r = n.top,
                    o = n.right,
                    i = n.bottom,
                    u = n.left,
                    f = n.width,
                    s = n.height,
                    c = i,
                    a = window.innerWidth - u,
                    l = window.innerHeight - r,
                    d = o,
                    h = e.threshold * f,
                    p = e.threshold * s;
                  return (
                    c > e.offset.top + p &&
                    a > e.offset.right + h &&
                    l > e.offset.bottom + p &&
                    d > e.offset.left + h
                  );
                });
            },
            function (t, n) {
              (function (n) {
                var r = "object" == e(n) && n && n.Object === Object && n;
                t.exports = r;
              }.call(
                n,
                (function () {
                  return this;
                })(),
              ));
            },
            function (t, n, r) {
              var o = r(5),
                i =
                  "object" ==
                    ("undefined" == typeof self ? "undefined" : e(self)) &&
                  self &&
                  self.Object === Object &&
                  self,
                u = o || i || Function("return this")();
              t.exports = u;
            },
            function (t, e, n) {
              var r = n(1),
                o = n(8),
                i = n(10),
                u = "Expected a function",
                f = Math.max,
                s = Math.min;
              t.exports = function (t, e, n) {
                function c(e) {
                  var n = p,
                    r = v;
                  return (p = v = void 0), (g = e), (m = t.apply(r, n));
                }
                function a(t) {
                  var n = t - x;
                  return void 0 === x || n >= e || n < 0 || (j && t - g >= y);
                }
                function l() {
                  var t = o();
                  return a(t)
                    ? d(t)
                    : void (b = setTimeout(
                        l,
                        (function (t) {
                          var n = e - (t - x);
                          return j ? s(n, y - (t - g)) : n;
                        })(t),
                      ));
                }
                function d(t) {
                  return (b = void 0), O && p ? c(t) : ((p = v = void 0), m);
                }
                function h() {
                  var t = o(),
                    n = a(t);
                  if (((p = arguments), (v = this), (x = t), n)) {
                    if (void 0 === b)
                      return (function (t) {
                        return (g = t), (b = setTimeout(l, e)), w ? c(t) : m;
                      })(x);
                    if (j) return (b = setTimeout(l, e)), c(x);
                  }
                  return void 0 === b && (b = setTimeout(l, e)), m;
                }
                var p,
                  v,
                  y,
                  m,
                  b,
                  x,
                  g = 0,
                  w = !1,
                  j = !1,
                  O = !0;
                if ("function" != typeof t) throw new TypeError(u);
                return (
                  (e = i(e) || 0),
                  r(n) &&
                    ((w = !!n.leading),
                    (y = (j = "maxWait" in n) ? f(i(n.maxWait) || 0, e) : y),
                    (O = "trailing" in n ? !!n.trailing : O)),
                  (h.cancel = function () {
                    void 0 !== b && clearTimeout(b),
                      (g = 0),
                      (p = x = v = b = void 0);
                  }),
                  (h.flush = function () {
                    return void 0 === b ? m : d(o());
                  }),
                  h
                );
              };
            },
            function (t, e, n) {
              var r = n(6);
              t.exports = function () {
                return r.Date.now();
              };
            },
            function (t, e, n) {
              var r = n(7),
                o = n(1),
                i = "Expected a function";
              t.exports = function (t, e, n) {
                var u = !0,
                  f = !0;
                if ("function" != typeof t) throw new TypeError(i);
                return (
                  o(n) &&
                    ((u = "leading" in n ? !!n.leading : u),
                    (f = "trailing" in n ? !!n.trailing : f)),
                  r(t, e, { leading: u, maxWait: e, trailing: f })
                );
              };
            },
            function (t, e) {
              t.exports = function (t) {
                return t;
              };
            },
          ]);
        });
      },
      {},
    ],
    "modules/stickyATC.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = d);
        var a = e(require("jquery")),
          t = e(require("../tools/inView"));
        function e(a) {
          return a && a.__esModule ? a : { default: a };
        }
        var i = function () {
          var e = localStorage.getItem("selectedVariantIndex"),
            i = localStorage.getItem("selectedVariantId");
          if (
            (console.log("selected variant index" + e),
            console.log(i),
            console.log("one-variant:" + localStorage.getItem("one-variant")),
            "true" != localStorage.getItem("one-variant"))
          ) {
            if (e)
              if (4 != e)
                (0, a.default)("[data-sticky-atc]").attr("data-variant-id", i),
                  (0, a.default)("[data-sticky-atc] span").removeClass(
                    "is-active",
                  ),
                  (0, a.default)(
                    "[data-sticky-atc] [data-variant-index=" + e + "]",
                  ).addClass("is-active"),
                  (0, a.default)(".container-dripstick").removeClass("hide"),
                  (0, a.default)(".container-69-pack").addClass("hide");
              else {
                (0, a.default)(".container-dripstick").addClass("hide"),
                  (0, a.default)(".container-69-pack").removeClass("hide");
                var d = (0, a.default)(
                  ".container-69-pack [data-sticky-atc] span",
                );
                if (1 != d.data("available")) {
                  var s = "";
                  (s =
                    (0, a.default)(window).width() > 990
                      ? (0, a.default)(
                          '.sticky-atc:not(".sticky-atc-mobile") .container-69-pack [data-sticky-atc] span',
                        ).text()
                      : (0, a.default)(
                          ".sticky-atc-mobile .container-69-pack [data-sticky-atc] span",
                        ).text()),
                    d.text(s.replace("Add To Cart", "pre order"));
                }
                (0, a.default)("[data-sticky-atc] span").addClass("is-active");
              }
          } else
            (0, a.default)(".sticky-atc .container").addClass("hide"),
              (0, a.default)(".container-bonus").removeClass("hide"),
              (0, a.default)("[data-sticky-atc] span").addClass("is-active");
          (0, t.default)(".d-flex.product-add-to-cart")
            .on("enter", function () {
              console.log("asdfasdf"),
                (0, a.default)(".sticky-atc").addClass("hide"),
                (0, a.default)(".sticky-atc").removeClass("is-active"),
                (0, a.default)(".sticky-atc").css("opacity", "1");
            })
            .on("exit", function (t) {
              (0, a.default)(".sticky-atc").removeClass("hide"),
                (0, a.default)(".sticky-atc").css("opacity", "1"),
                setTimeout(function () {
                  (0, a.default)(".sticky-atc").addClass("is-active");
                }, 50);
            }),
            (0, a.default)(window).width() >= 990 &&
              (0, t.default)(".product-main-section")
                .on("enter", function () {
                  (0, a.default)(".site-header ").removeClass("hide");
                })
                .on("exit", function (t) {
                  (0, a.default)(".site-header ").addClass("hide");
                });
        };
        function d() {
          setTimeout(function () {
            i();
          }, 1e3);
        }
      },
      {
        jquery: "../node_modules/jquery/dist/jquery.js",
        "../tools/inView": "tools/inView.js",
      },
    ],
    "modules/tab.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = r);
        var t = e(require("jquery"));
        function e(t) {
          return t && t.__esModule ? t : { default: t };
        }
        var a = function () {
          (0, t.default)(".template-index [data-tab-product-handler]").on(
            "click",
            function () {
              var e = (0, t.default)(this).attr("data-variant-id"),
                a = (0, t.default)(this)
                  .closest(".tab-section")
                  .find("[data-home-atc]"),
                r = (0, t.default)(this)
                  .closest(".tab-section")
                  .find(".accent_title");
              "36314227867799" == e
                ? a.attr("href", "/products/dripstick-the-69")
                : a.attr("href", "/products/dripstick"),
                r.text((0, t.default)(this).attr("data-accent-title"));
            },
          );
        };
        function r() {
          a();
        }
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "scripts/modules/customEvent.js": [
      function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", { value: !0 }),
          (exports.default = a);
        var t = e(require("jquery"));
        function e(t) {
          return t && t.__esModule ? t : { default: t };
        }
        function a() {
          (0, t.default)(document).ready(function () {
            n(), c();
          });
        }
        var o = "onetime",
          i = (0, t.default)(".rc_container_wrapper.custom_widget");
        function n() {
          i.length > 0 &&
            setTimeout(function () {
              (0, t.default)(".rc_container_wrapper").length < 2 ? n() : l();
            }, 500);
        }
        function l() {
          var e = (0, t.default)(".rc_container_wrapper:not(.custom_widget)");
          (0, t.default)(".rc_container_wrapper.custom_widget").addClass(
            "visible",
          ),
            (0, t.default)(".recharge_title").addClass("visible"),
            i
              .find(".rc_widget__option__discount")
              .text(e.find(".rc_widget__option__discount").text()),
            i
              .find("select[data-plans-dropdown]")
              .html(
                e
                  .find("select[data-plans-dropdown]")
                  .html()
                  .replaceAll("Delivery every ", ""),
              ),
            i
              .find("[data-custom-select-wrapper] .option_list")
              .html(
                e
                  .find("select[data-plans-dropdown]")
                  .html()
                  .replaceAll("Delivery every ", "")
                  .replaceAll("option", "div"),
              ),
            i
              .find("[data-custom-select-wrapper] .selected_option")
              .html(
                i
                  .find(
                    "[data-custom-select-wrapper] .option_list >div:first-child",
                  )
                  .text(),
              ),
            i
              .find(
                "[data-custom-select-wrapper] .option_list >div:first-child",
              )
              .addClass("selected"),
            e.find("[data-option-onetime]").click(),
            i.find("[data-option-onetime] input").click(),
            (0, t.default)(
              "[data-onetime-price-wrapper], [data-subscribe-price-wrapper], [data-plans-container]",
            ).show(),
            (0, t.default)(
              "[data-onetime-price-wrapper], [data-subscribe-price-wrapper], [data-plans-container]",
            ).addClass("visible");
          var a =
              100 -
              parseInt(
                i.find(".rc_widget__option__discount").text().replace("%", ""),
              ),
            n =
              parseFloat(
                (0, t.default)(
                  "form#addToCartForm select[data-all-variants] option[selected]",
                ).attr("data-variant-price"),
              ) / 100,
            l = (n * a) / 100,
            s = theme.moneyFormat.split("{")[0];
          i
            .find(
              "[data-option-onetime] [data-selector-onetime] [data-price-onetime]",
            )
            .text(s + n),
            i
              .find(
                "[data-option-subsave] [data-selector-subsave] [data-price-subsave]",
              )
              .text(s + l),
            (0, t.default)(document).on(
              "click",
              "[data-option-subsave] [data-custom-select-wrapper] .option_list > div",
              function () {
                var e = (0, t.default)(this).attr("value");
                console.log((0, t.default)(this).attr("data-href")),
                  (0, t.default)(this)
                    .closest(".option_list")
                    .find("div")
                    .removeClass("selected"),
                  (0, t.default)(this)
                    .closest("#variant-selector")
                    .find(".selected_option")
                    .text((0, t.default)(this).text()),
                  (0, t.default)(this).addClass("selected"),
                  (0, t.default)(this)
                    .closest("#variant-selector")
                    .removeClass("active"),
                  (0, t.default)(this)
                    .closest("[data-option-subsave]")
                    .find("select[data-plans-dropdown]")
                    .val(e)
                    .change();
              },
            );
          var c = 0;
          (0, t.default)(document).on(
            "click",
            "[data-option-onetime]",
            function () {
              1 == c && d("up"), (c = 0), (o = "onetime");
            },
          ),
            (0, t.default)(document).on(
              "click",
              "[data-option-subsave]",
              function () {
                0 == c && d("down"), (c = 1), (o = "subsave");
              },
            );
        }
        function d(e) {
          (0, t.default)(".product-options .selected_option").text(
            s((0, t.default)(".product-options .selected_option").text(), e),
          ),
            (0, t.default)(".product-options .option_list .option").each(
              function () {
                (0, t.default)(this).text(s((0, t.default)(this).text(), e));
              },
            );
        }
        function s(t, e) {
          var a,
            o,
            n = theme.moneyFormat.split("{")[0],
            l =
              100 -
              parseInt(
                i.find(".rc_widget__option__discount").text().replace("%", ""),
              );
          return (
            t.indexOf(n) &&
              ((a = t.split(n)[0]),
              (o = t.split(n)[1]),
              (o =
                "down" == e
                  ? (parseFloat(o) * l) / 100
                  : (parseFloat(o) / l) * 100)),
            a + n + o.toFixed(2)
          );
        }
        function c() {
          (0, t.default)(document).on(
            "click",
            "#variant-selector .selected_option",
            function () {
              -1 ==
              (0, t.default)(this)
                .closest("#variant-selector")
                .attr("class")
                .indexOf("active")
                ? (0, t.default)(this)
                    .closest("#variant-selector")
                    .addClass("active")
                : (0, t.default)(this)
                    .closest("#variant-selector")
                    .removeClass("active");
            },
          ),
            (0, t.default)(document).on(
              "click",
              "#variant-selector .option_list .option",
              function () {
                (0, t.default)(this)
                  .closest(".option_list")
                  .find(".option")
                  .removeClass("selected"),
                  (0, t.default)(this).addClass("selected");
                var e = (0, t.default)(this).attr("data-value");
                (0, t.default)(this)
                  .closest(".product-options__list")
                  .find('.product-option input[value="' + e + '"]')
                  .click(),
                  (0, t.default)(this)
                    .closest("#variant-selector")
                    .removeClass("active"),
                  (0, t.default)(this)
                    .closest("#variant-selector")
                    .find(".selected_option")
                    .text((0, t.default)(this).text());
              },
            );
          var e = !1;
          (0, t.default)(document).on(
            "mouseover",
            "#variant-selector .selected_option",
            function () {
              e = !0;
            },
          ),
            (0, t.default)(document).on(
              "mouseleave",
              "#variant-selector .selected_option",
              function () {
                e = !1;
              },
            ),
            (0, t.default)(document).on(
              "mouseover",
              "#variant-selector .option_list",
              function () {
                e = !0;
              },
            ),
            (0, t.default)(document).on(
              "mouseleave",
              "#variant-selector .option_list",
              function () {
                e = !1;
              },
            ),
            (0, t.default)(document).on("click", "*", function () {
              e ||
                (0, t.default)(".variant-selector.active").each(function () {
                  (0, t.default)(this).removeClass("active");
                });
            }),
            (0, t.default)(document).on(
              "click",
              ".order-summary-box [data-cart-page-checkout]",
              function () {
                (0, t.default)(this).append(
                  " <div class='loader_wrapper'><div class='loader'></div></div>",
                );
              },
            ),
            (0, t.default)(document).on(
              "click",
              "[data-recharge-checkout-btn]",
              function (e) {
                e.preventDefault();
                var a = (0, t.default)(this).closest("form"),
                  i = a.attr("data-handle"),
                  n = [],
                  l = a
                    .find(
                      "[data-option-subsave] [data-variant-selector] .option_list > div.selected",
                    )
                    .attr("value"),
                  d =
                    ((0, t.default)(".rc_container_wrapper.custom_widget").data(
                      "group",
                    ),
                    !1);
                a.find("select[data-all-variants]").val();
                jQuery.getJSON("/cart.js", function (e) {
                  if ("dripstick-sample-pack" == i)
                    for (var s = 0; s < e.items.length; s++)
                      "onetime" == o && e.items[s].handle == i && (d = !0),
                        "subsave" == o &&
                          e.items[s].handle == i &&
                          e.items[s].selling_plan_allocation.selling_plan.id ==
                            l &&
                          (d = !0);
                  d
                    ? (0, t.default)("[data-popup-open]").click()
                    : ("subsave" == o
                        ? (n = {
                            id: a.find("select[data-all-variants]").val(),
                            quantity: a.find(".e-input").val(),
                            selling_plan: a
                              .find(
                                "[data-option-subsave] [data-variant-selector] .option_list > div.selected",
                              )
                              .attr("value"),
                            group_name: o,
                          })
                        : "onetime" == o &&
                          (n = {
                            id: a.find("select[data-all-variants]").val(),
                            quantity: a.find(".e-input").val(),
                          }),
                      jQuery.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: n,
                        dataType: "json",
                        success: function () {},
                      }));
                });
              },
            );
        }
        (0, t.default)(document).on(
          "click",
          ".product-options__list .option_list .option",
          function (e) {
            e.preventDefault();
            var a = (0, t.default)(this),
              o = a.attr("data-sticky-index");
            setTimeout(function () {
              null != o &&
                null != o &&
                localStorage.setItem("selectedVariantIndex", o),
                (location.href = a.attr("data-href"));
            }, 100);
          },
        ),
          (0, t.default)(document).on(
            "click",
            ".product-options__list .product-option",
            function () {
              void 0 !== (0, t.default)(this).data("href") &&
                (location.href = (0, t.default)(this).data("href"));
            },
          );
      },
      { jquery: "../node_modules/jquery/dist/jquery.js" },
    ],
    "scripts/ae.js": [
      function (require, module, exports) {
        "use strict";
        var t = p(require("jquery")),
          e = p(require("./modules/header")),
          a = p(require("./modules/qty-selector")),
          o = p(require("./modules/product")),
          d = p(require("./modules/login")),
          l = p(require("./modules/account")),
          i = p(require("./modules/cartPage")),
          n = p(require("./modules/popup")),
          u = p(require("./modules/minicart")),
          s = p(require("./modules/megamenu")),
          c = p(require("./modules/search")),
          f = p(require("./modules/footerMenu")),
          r = p(require("./modules/maquee")),
          h = p(require("./modules/customAccordion")),
          v = p(require("./modules/productMeet")),
          g = p(require("./modules/stickyATC")),
          m = p(require("./modules/tab")),
          b = p(require("./modules/customEvent"));
        function p(t) {
          return t && t.__esModule ? t : { default: t };
        }
        window.$ = window.jQuery = t.default;
        var q = function (e, a) {
            try {
              e(a),
                a &&
                  a.resize &&
                  (0, t.default)(window).resize(function () {
                    e(a);
                  });
            } catch (o) {
              console.error(o);
            }
          },
          w = function () {
            (0, t.default)("[data-trigger]").click(function (e) {
              e.preventDefault(),
                (0, t.default)("[data-trigger]")
                  .not((0, t.default)(this))
                  .removeClass("is-open"),
                (0, t.default)(this).toggleClass("is-open");
            }),
              (0, t.default)("[data-trigger-hover]").mouseover(function (e) {
                e.preventDefault(),
                  (0, t.default)("[data-trigger]").removeClass("is-open");
              }),
              (0, t.default)(document).on("click", function (e) {
                var a = "[data-trigger]",
                  o = (0, t.default)(e.target),
                  d = o.closest(a),
                  l = (0, t.default)(a).next().find(o).length;
                d.length || l || (0, t.default)(a).removeClass("is-open");
              });
          },
          C = function () {
            (0, t.default)("[data-tab]").click(function (e) {
              e.stopPropagation();
              var a = (0, t.default)(this).data("tab"),
                o = (0, t.default)(this).closest("[data-tabs]");
              (0, t.default)("[data-tab], [data-tab-content]", o).removeClass(
                "is-active",
              ),
                (0, t.default)(this).addClass("is-active"),
                (0, t.default)("[data-tab-content=".concat(a, "]"), o).addClass(
                  "is-active",
                );
            });
          },
          y = function () {
            var e = localStorage.getItem("collection-tab");
            e &&
              ((0, t.default)("[data-collection-tabs] [data-tab]").removeClass(
                "is-active",
              ),
              (0, t.default)(
                "[data-collection-tabs] [data-tab=".concat(e, "]"),
              ).addClass("is-active"),
              (0, t.default)(
                "[data-collection-tabs] [data-tab-content]",
              ).removeClass("is-active"),
              (0, t.default)(
                "[data-collection-tabs] [data-tab-content=".concat(e, "]"),
              ).addClass("is-active")),
              (0, t.default)("[data-collection-tabs] .nav__link").click(
                function () {
                  var e = (0, t.default)(this)
                    .closest("[data-tab-content]")
                    .data("tab-content");
                  localStorage.setItem("collection-tab", e);
                },
              );
          },
          k = function () {
            var e = (0, t.default)("[data-video] video");
            (0, t.default)("[data-video-btn]").click(function (e) {
              (0, t.default)(this).siblings("video").click();
            }),
              e.each(function (e, a) {
                (0, t.default)(a).on("play seeking", function () {
                  (0, t.default)(this).attr("controls", !0),
                    (0, t.default)(this).siblings("button").hide(),
                    (0, t.default)(this)
                      .closest("[data-video]")
                      .addClass("is-playing");
                }),
                  (0, t.default)(a).on("seeked", function () {
                    (0, t.default)(this)[0].play();
                  }),
                  (0, t.default)(a).on("pause", function () {
                    (0, t.default)(this).removeAttr("controls"),
                      (0, t.default)(this).siblings("button").show(),
                      (0, t.default)(this)
                        .closest("[data-video]")
                        .removeClass("is-playing");
                  });
              });
          },
          M = function () {
            var e = (0, t.default)("[data-gotop]");
            (0, t.default)(document).scroll(function () {
              (0, t.default)(this).scrollTop() >=
              (0, t.default)(window).height()
                ? e.show()
                : e.hide();
            });
          },
          x = function () {
            (0, t.default)(document).on(
              "click",
              "[data-accordion-button]",
              function (e) {
                e.preventDefault();
                var a = (0, t.default)(this).closest(
                  "[data-accordions-container]",
                );
                if (
                  "1" == a.data("accordions-mobile-only") &&
                  (0, t.default)(window).outerWidth() > 989
                )
                  return !1;
                var o = (0, t.default)(this),
                  d = (0, t.default)(this).siblings("[data-accordion-content]");
                o.toggleClass("is-open"),
                  d.slideToggle(),
                  (0, t.default)("[data-accordion-button]", a)
                    .not(o)
                    .removeClass("is-open"),
                  (0, t.default)("[data-accordion-content]", a)
                    .not(d)
                    .slideUp();
              },
            );
          },
          D = function () {
            var e = (0, t.default)("[data-faq-section-toggle]"),
              a = (0, t.default)("[data-faq-section]");
            e.length &&
              e.click(function (o) {
                var d = (0, t.default)(this).data("faq-section-toggle");
                e.removeClass("is-active"),
                  (0, t.default)(this).addClass("is-active"),
                  a.removeClass("is-active"),
                  a
                    .filter("[data-faq-section=".concat(d, "]"))
                    .addClass("is-active");
              });
          },
          T = function () {
            var e = function () {
              setTimeout(function () {
                if ((0, t.default)(window).width() <= 989)
                  return (
                    (0, t.default)("body").css("paddingBottom", 0),
                    (0, t.default)("[data-site-footer]").show(),
                    !1
                  );
                var e = (0, t.default)("[data-site-footer]").outerHeight();
                (0, t.default)("body").css({ paddingBottom: e }),
                  (0, t.default)("[data-site-footer]").show();
              }, 250);
            };
            e(), (0, t.default)(window).resize(e);
          },
          _ = function () {
            Shopify.designMode &&
              (0, t.default)("body").removeClass("animations-on");
          },
          z = function () {
            (0, t.default)("[data-toggle]").click(function () {
              var e = (0, t.default)(this).data("toggle");
              (0, t.default)("[data-target=".concat(e, "]")).toggleClass(
                "is-active",
              );
            });
          },
          A = function () {
            (0, t.default)("[data-goto]").click(function () {
              var e = (0, t.default)(this).data("goto"),
                a = (0, t.default)("[data-goto-target=".concat(e, "]"));
              (0, t.default)(this)
                .closest("[data-goto-target]")
                .addClass("hide"),
                a.removeClass("hide");
            });
          };
        function S(t, e) {
          return (
            (t = Math.ceil(t)),
            (e = Math.floor(e)),
            Math.floor(Math.random() * (e - t)) + t
          );
        }
        var j = function () {
            (0, t.default)("[data-random-number]").text(S(2, 9));
          },
          B = function () {
            (0, t.default)(".btn.add-to-cart:not([data-add-to-cart]").click(
              function (e) {
                if (
                  (e.preventDefault(),
                  "order now" == (0, t.default)(this).text().toLowerCase() &&
                    (0, t.default)(".product-main").length)
                )
                  (0, t.default)("html, body").animate(
                    { scrollTop: 0 },
                    "slow",
                  );
                else {
                  var a = (0, t.default)(this).attr("href");
                  window.location.href = a;
                }
              },
            );
          },
          I = function () {
            (0, t.default)(document).on(
              "mousedown",
              ".variant-tab-item",
              function () {
                console.log("here"),
                  (0, t.default)(this).hasClass("best-seller-tab") &&
                    (0, t.default)(".best-seller.hide--mobile").css(
                      "opacity",
                      "1",
                    );
              },
            );
          },
          O = function () {
            (0, t.default)(document).on(
              "change",
              "[data-faq-search]",
              function (e) {
                console.log((0, t.default)(this).val());
                var a = (0, t.default)(this).val();
                (0, t.default)("[data-accordion]").each(function (e, o) {
                  var d = (0, t.default)(o),
                    l = d.find("[data-accordion-button]").text(),
                    i = d.find("[data-accordion-content]").text();
                  -1 == l.indexOf(a) && -1 == i.indexOf(a)
                    ? d.hide()
                    : d.show();
                });
              },
            ),
              (0, t.default)(".faq-search-form").on("submit", function (t) {
                t.preventDefault();
              });
          };
        (0, t.default)(document).ready(function () {
          q(e.default),
            q(T),
            q(k),
            q(M),
            q(o.default),
            q(a.default),
            q(I),
            q(x),
            q(d.default),
            q(l.default),
            q(i.default),
            q(n.default),
            q(D),
            q(_),
            q(w),
            q(C),
            q(y),
            q(z),
            q(A),
            q(u.default),
            q(j),
            q(B),
            q(s.default),
            q(c.default),
            q(f.default),
            q(r.default),
            q(h.default),
            q(O),
            q(v.default),
            q(g.default),
            q(m.default),
            q(b.default);
        });
      },
      {
        jquery: "../node_modules/jquery/dist/jquery.js",
        "./modules/header": "modules/header.js",
        "./modules/qty-selector": "modules/qty-selector.js",
        "./modules/product": "modules/product/index.js",
        "./modules/login": "modules/login.js",
        "./modules/account": "modules/account.js",
        "./modules/cartPage": "modules/cartPage.js",
        "./modules/popup": "modules/popup.js",
        "./modules/minicart": "modules/minicart.js",
        "./modules/megamenu": "modules/megamenu.js",
        "./modules/search": "modules/search.js",
        "./modules/footerMenu": "modules/footerMenu.js",
        "./modules/maquee": "modules/maquee.js",
        "./modules/customAccordion": "modules/customAccordion.js",
        "./modules/productMeet": "modules/productMeet.js",
        "./modules/stickyATC": "modules/stickyATC.js",
        "./modules/tab": "modules/tab.js",
        "./modules/customEvent": "scripts/modules/customEvent.js",
      },
    ],
  },
  {},
  ["scripts/ae.js"],
  null,
);
//# sourceMappingURL=/scripts/ae.js.map

$(document).ajaxComplete(function (event, xhr, settings) {
  if (settings.url === "/cart/add.js") {
    $.get("/cart.js", function (cartObj) {
      cart_drawer.$data.cart_items = JSON.parse(cartObj).items;
      cart_drawer.$data.cart_open = true;
      $(".cart-item__count").html(JSON.parse(cartObj).item_count);
    });
  }
});
